/**
 * AUTO-GENERATED — node scripts/buildGnkExpenseRequestSeed.js
 * GNK 2026 본예산(bud_knd=1, ino_gb=2) 지출편성 이관
 * 마스터 285건 · 디테일 1433건 (금액: 천원, 지출 절상)
 * 부서별: {"GNK1010":22,"GNK1020":12,"GNK1030":4,"GNK1040":11,"GNK1050":30,"GNK1060":8,"GNK1070":48,"GNK1080":19,"GNK1090":4,"GNK1100":12,"GNK1110":21,"GNK1120":5,"GNK1140":11,"GNK1150":13,"GNK1160":11,"GNK1170":6,"GNK1210":34,"GNK1220":4,"GNK1230":6,"GNK1240":3,"GNK1250":1}
 */
export const GNK_EXPENSE_REQUEST_ROWS = [
  {
    "deptCode": "GNK1010",
    "deptName": "예산기획팀",
    "bizName": "학대피해아동보호 및 예방 (예산)",
    "sehangName": "사업비",
    "mokName": "학대피해아동보호 및 예방 (예산)",
    "semokName": "학대피해아동보호 및 예방 (예산)",
    "legacyBudgetAmtWon": 3675965730,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장 인건비 상승분 등",
        "calcBasis": "2888888880",
        "calcAmt": 2888889,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "본부 인건비 상승분 등",
        "calcBasis": "43903186+664",
        "calcAmt": 43904,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "학대 사업비",
        "calcBasis": "600000000",
        "calcAmt": 600000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "조기개입사업비",
        "calcBasis": "62000000+81173000",
        "calcAmt": 143173,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1010",
    "deptName": "예산기획팀",
    "bizName": "반환금",
    "sehangName": "예비비 및 기타",
    "mokName": "반환금",
    "semokName": "반환금(당해년도)_기타 반환금",
    "legacyBudgetAmtWon": 280,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "반환금 절사",
        "calcBasis": "280",
        "calcAmt": 1,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1010",
    "deptName": "예산기획팀",
    "bizName": "가정보호 및 대안양육 (예산)",
    "sehangName": "사업비",
    "mokName": "가정보호 및 대안양육 (예산)",
    "semokName": "가정보호 및 대안양육 (예산)",
    "legacyBudgetAmtWon": 213810500,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장 인건비 상승분 및 퇴충 연충",
        "calcBasis": "108932462-462",
        "calcAmt": 108932,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "본부 인건비 상승분 및 퇴충 연충",
        "calcBasis": "4878132+368",
        "calcAmt": 4879,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "가정현보호지원사업비",
        "calcBasis": "100000000",
        "calcAmt": 100000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1010",
    "deptName": "예산기획팀",
    "bizName": "위기가정아동 긴급지원 (예산)",
    "sehangName": "사업비",
    "mokName": "위기가정아동 긴급지원 (예산)",
    "semokName": "위기가정아동 긴급지원 (예산)",
    "legacyBudgetAmtWon": 238939990,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장 인건비 상승분 및 퇴충 연충 반영",
        "calcBasis": "204792990",
        "calcAmt": 204793,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "본부 인건비 상승분 및 퇴충 연충 반영",
        "calcBasis": "34147000",
        "calcAmt": 34147,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1010",
    "deptName": "예산기획팀",
    "bizName": "마음건강 지원 (예산)",
    "sehangName": "사업비",
    "mokName": "마음건강 지원 (예산)",
    "semokName": "마음건강 지원 (예산)",
    "legacyBudgetAmtWon": 122306990,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장 인건비 상승분 및 퇴충 연충 반영",
        "calcBasis": "17429194-194",
        "calcAmt": 17429,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "본부 인건비 상승분 및 퇴충 연충 반영",
        "calcBasis": "4878132-142",
        "calcAmt": 4878,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "마음건강지원사업비",
        "calcBasis": "100000000",
        "calcAmt": 100000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1010",
    "deptName": "예산기획팀",
    "bizName": "아동친화적 환경, 인프라 개선 기획사업(예산)",
    "sehangName": "사업비",
    "mokName": "아동친화적 환경, 인프라 개선 기획사업(예산)",
    "semokName": "아동친화적 환경, 인프라 개선 기획사업(예산)",
    "legacyBudgetAmtWon": 209756320,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "본부 인건비 상승분 및 퇴충 연충 반영",
        "calcBasis": "9756264+56",
        "calcAmt": 9757,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "아동 친화적 성장환경조성사업",
        "calcBasis": "200000000",
        "calcAmt": 200000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1010",
    "deptName": "예산기획팀",
    "bizName": "미래성장 지원 (예산)",
    "sehangName": "사업비",
    "mokName": "미래성장 지원 (예산)",
    "semokName": "미래성장 지원 (예산)",
    "legacyBudgetAmtWon": 204878000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "본부 인건비 상승분 및 퇴충 연충 반영",
        "calcBasis": "4878132-132",
        "calcAmt": 4878,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "미래성장지원사업",
        "calcBasis": "200000000",
        "calcAmt": 200000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1010",
    "deptName": "예산기획팀",
    "bizName": "자립 지원(예산)",
    "sehangName": "사업비",
    "mokName": "자립 지원(예산)",
    "semokName": "자립 지원(예산)",
    "legacyBudgetAmtWon": 489968540,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장 인건비 상승분 및 퇴충 연충 반영",
        "calcBasis": "165577342+658",
        "calcAmt": 165578,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "본부 인건비 상승분 및 퇴충 연충 반영",
        "calcBasis": "24390659-119",
        "calcAmt": 24391,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "자립지원사업",
        "calcBasis": "300000000",
        "calcAmt": 300000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1010",
    "deptName": "예산기획팀",
    "bizName": "아동권리 캠페인 (예산)",
    "sehangName": "사업비",
    "mokName": "아동권리 캠페인 (예산)",
    "semokName": "아동권리 캠페인 (예산)",
    "legacyBudgetAmtWon": 124390647,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "본부 인건비 상승분 및 퇴충 연충 반영",
        "calcBasis": "24390659-12",
        "calcAmt": 24391,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "옹호사업비",
        "calcBasis": "100000000",
        "calcAmt": 100000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1010",
    "deptName": "예산기획팀",
    "bizName": "지역사회 지원(예산)",
    "sehangName": "사업비",
    "mokName": "지역사회 지원(예산)",
    "semokName": "지역사회 지원(예산)",
    "legacyBudgetAmtWon": 749737890,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장 인건비 상승분 및 퇴충 연충 반영",
        "calcBasis": "196078470",
        "calcAmt": 196079,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "본부 인건비 상승분 및 퇴충 연충 반영",
        "calcBasis": "",
        "calcAmt": 53660,
        "remark": "산출기초(이관): 553659420"
      },
      {
        "calcLevel": 1,
        "calcDesc": "지역사회지원사업비",
        "calcBasis": "500000000",
        "calcAmt": 500000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1010",
    "deptName": "예산기획팀",
    "bizName": "부서운영비",
    "sehangName": "사업비",
    "mokName": "부서운영비",
    "semokName": "부서운영비",
    "legacyBudgetAmtWon": 1560000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "예산기획팀(2명), 전략기획본부장, 사무총장 부서운영비",
        "calcBasis": "30,000원*4명*12개월",
        "calcAmt": 1440,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "예산기획팀(2명), 전략기획본부장 워크샵비",
        "calcBasis": "40,000원*3명*1회",
        "calcAmt": 120,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1010",
    "deptName": "예산기획팀",
    "bizName": "부서운영비",
    "sehangName": "사업비",
    "mokName": "부서운영비",
    "semokName": "업무추진비",
    "legacyBudgetAmtWon": 6000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사무총장 업무추진비",
        "calcBasis": "300,000원*12개월",
        "calcAmt": 3600,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "전략기획본부장 업무추진비",
        "calcBasis": "200,000원*12개월",
        "calcAmt": 2400,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1010",
    "deptName": "예산기획팀",
    "bizName": "조사연구사업(예산)",
    "sehangName": "사업비",
    "mokName": "조사연구사업(예산)",
    "semokName": "조사연구사업(예산)",
    "legacyBudgetAmtWon": 61902920,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "인건비 상승분 및 퇴충 연충 반영",
        "calcBasis": "58537920",
        "calcAmt": 58538,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "사업비",
        "calcBasis": "3365000",
        "calcAmt": 3365,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1010",
    "deptName": "예산기획팀",
    "bizName": "조사연구사업(예산)",
    "sehangName": "사업비",
    "mokName": "조사연구사업(예산)",
    "semokName": "조사연구사업(예산)",
    "legacyBudgetAmtWon": 29269580,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "인건비 상승분 및 퇴충 연충 반영",
        "calcBasis": "29269580",
        "calcAmt": 29270,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1010",
    "deptName": "예산기획팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 53660395,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "인건비 상승분 및 퇴충 연충 반영",
        "calcBasis": "53660395",
        "calcAmt": 53661,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1010",
    "deptName": "예산기획팀",
    "bizName": "급여",
    "sehangName": "인건비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 117075740,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "인건비 상승분 및 퇴충 연충 반영",
        "calcBasis": "117075740",
        "calcAmt": 117076,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1010",
    "deptName": "예산기획팀",
    "bizName": "기관운영비",
    "sehangName": "업무추진비",
    "mokName": "기관운영비",
    "semokName": "기관운영비",
    "legacyBudgetAmtWon": 13800000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "직원 경조사비",
        "calcBasis": "200,000원*65명",
        "calcAmt": 13000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "직원 경조사 교통비",
        "calcBasis": "10회*30,000원",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "외부기관 경조사비",
        "calcBasis": "100,000원*5명",
        "calcAmt": 500,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1010",
    "deptName": "예산기획팀",
    "bizName": "직책보조비",
    "sehangName": "업무추진비",
    "mokName": "직책보조비",
    "semokName": "직책보조비",
    "legacyBudgetAmtWon": 3600000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사무총장 직책보조비",
        "calcBasis": "300,000원*12개월",
        "calcAmt": 3600,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1010",
    "deptName": "예산기획팀",
    "bizName": "자산취득비",
    "sehangName": "시설비",
    "mokName": "자산취득비",
    "semokName": "자산취득비",
    "legacyBudgetAmtWon": 20000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "노트북 구입",
        "calcBasis": "20,000,000",
        "calcAmt": 20000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1010",
    "deptName": "예산기획팀",
    "bizName": "신체건강 지원 (예산)",
    "sehangName": "사업비",
    "mokName": "신체건강 지원 (예산)",
    "semokName": "신체건강 지원 (예산)",
    "legacyBudgetAmtWon": 404878260,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "본부 인건비 증가분",
        "calcBasis": "4878132",
        "calcAmt": 4879,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "아동건강증진사업비",
        "calcBasis": "400000000",
        "calcAmt": 400000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "절삭",
        "calcBasis": "128",
        "calcAmt": 1,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1010",
    "deptName": "예산기획팀",
    "bizName": "가정보호 및 대안양육 (예산)",
    "sehangName": "사업비",
    "mokName": "가정보호 및 대안양육 (예산)",
    "semokName": "가정보호 및 대안양육 (예산)",
    "legacyBudgetAmtWon": 0,
    "details": []
  },
  {
    "deptCode": "GNK1010",
    "deptName": "예산기획팀",
    "bizName": "지속준비사업비(예산)",
    "sehangName": "사업비",
    "mokName": "지속준비사업비(예산)",
    "semokName": "지속준비사업비(예산)",
    "legacyBudgetAmtWon": 34480580000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지속준비 사업비",
        "calcBasis": "",
        "calcAmt": 34480580,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "",
        "calcBasis": "-656000",
        "calcAmt": -656,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "",
        "calcBasis": "1000193000",
        "calcAmt": 1000193,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "",
        "calcBasis": "33481043000",
        "calcAmt": 33481043,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1020",
    "deptName": "경영기획팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 84695780,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "고O석(L급 22호봉)",
        "calcBasis": "84695780",
        "calcAmt": 84696,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1020",
    "deptName": "경영기획팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 293066020,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "김O아(L급 17호봉), 박O나(4급 14-15호봉), 이O지(4급 11-12호봉), 임O경(4급 11-12호봉), 김O영(4급 9-10호봉)",
        "calcBasis": "67,172,180+61,416,720+54,008,040+56,150,400+54,318,680",
        "calcAmt": 293067,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1020",
    "deptName": "경영기획팀",
    "bizName": "지부지원사업",
    "sehangName": "사업비",
    "mokName": "지부지원사업",
    "semokName": "사업계획",
    "legacyBudgetAmtWon": 17403000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[중장기계획회의 수립]",
        "calcBasis": "",
        "calcAmt": 1900,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 사전워크숍_킥오프회의",
        "calcBasis": "",
        "calcAmt": 550,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-다과비",
        "calcBasis": "5,000원*90명",
        "calcAmt": 450,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-진행물품비",
        "calcBasis": "100,000원*1회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2. 부서장 워크숍",
        "calcBasis": "",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-식사비",
        "calcBasis": "15,000원*15명*1회",
        "calcAmt": 225,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-다과비",
        "calcBasis": "5,000원*15명",
        "calcAmt": 75,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-진행물품비",
        "calcBasis": "100,000원*1회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "3. 사전 전략공유 워크숍",
        "calcBasis": "",
        "calcAmt": 350,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-다과비",
        "calcBasis": "5,000원*50명",
        "calcAmt": 250,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-진행물품비",
        "calcBasis": "100,000원*1회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "4. 공유 워크숍",
        "calcBasis": "",
        "calcAmt": 600,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-다과비",
        "calcBasis": "5,000원*100명",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-진행물품비",
        "calcBasis": "100,000원*1회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[중장기계획회의]",
        "calcBasis": "",
        "calcAmt": 15503,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 장소 및 사전답사",
        "calcBasis": "",
        "calcAmt": 36,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-식대 및 다과비",
        "calcBasis": "(13,000원*2명*1회)+(5,000원*2명*1회)",
        "calcAmt": 36,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2. 교통비",
        "calcBasis": "",
        "calcAmt": 800,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-렌트카",
        "calcBasis": "150,000*4대",
        "calcAmt": 600,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-통행료 및 주유비",
        "calcBasis": "50,000원*4대",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "3. 장소대관비",
        "calcBasis": "",
        "calcAmt": 11317,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-숙박비",
        "calcBasis": "30,000원*91명",
        "calcAmt": 2730,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-식대비",
        "calcBasis": "(13,000원*91명*3식)+(13,000원*26명*1식)",
        "calcAmt": 3887,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-강의장 대관비(VAT포함,2일)",
        "calcBasis": "2,350,000*2일(아산홀 대관비)",
        "calcAmt": 4700,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "4. 경영진 회의",
        "calcBasis": "",
        "calcAmt": 845,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-사전 회의 진행비",
        "calcBasis": "13,000원*20명*1회",
        "calcAmt": 260,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-전략 회의 진행비",
        "calcBasis": "13,000원*45명*1회",
        "calcAmt": 585,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "5. 자료집 제작비",
        "calcBasis": "",
        "calcAmt": 1650,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-사전 자료집 제작비",
        "calcBasis": "15,000원*100부",
        "calcAmt": 1500,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-결과 자료집 제작비",
        "calcBasis": "15,000원*10부",
        "calcAmt": 150,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "6. 다과비",
        "calcBasis": "",
        "calcAmt": 455,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-다과비",
        "calcBasis": "5,000원*91명",
        "calcAmt": 455,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "7. 진행물품 구입비",
        "calcBasis": "",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-현수막 제작비",
        "calcBasis": "100,000원*1개",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-진행물품 구입비",
        "calcBasis": "300,000원",
        "calcAmt": 300,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1020",
    "deptName": "경영기획팀",
    "bizName": "지부지원사업",
    "sehangName": "사업비",
    "mokName": "지부지원사업",
    "semokName": "사업계획",
    "legacyBudgetAmtWon": 4497000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[경영전략회의]",
        "calcBasis": "",
        "calcAmt": 2887,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 경영전략회의",
        "calcBasis": "",
        "calcAmt": 2387,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-사업계획서 제본",
        "calcBasis": "10부*20,000원*1회",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-자료집 제작",
        "calcBasis": "95부*15,000원*1회",
        "calcAmt": 1425,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-식대",
        "calcBasis": "26명*12,000원*1회",
        "calcAmt": 312,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-다과비",
        "calcBasis": "90명*5,000원*1회",
        "calcAmt": 450,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2. 경영전략회의 공유워크숍",
        "calcBasis": "",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-다과비",
        "calcBasis": "100명*5,000원*1회",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[경영방향 포스터 제작]",
        "calcBasis": "",
        "calcAmt": 1610,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "-포스터 디자인, 인쇄 배송 등",
        "calcBasis": "46개 지부 및 본부*35,000원",
        "calcAmt": 1610,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1020",
    "deptName": "경영기획팀",
    "bizName": "지부지원사업",
    "sehangName": "사업비",
    "mokName": "지부지원사업",
    "semokName": "사업평가",
    "legacyBudgetAmtWon": 18515000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[사업평가회의]",
        "calcBasis": "",
        "calcAmt": 3515,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 사업평가회의",
        "calcBasis": "",
        "calcAmt": 3015,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-사전회의비(식대 및 다과)",
        "calcBasis": "17,000원*20명",
        "calcAmt": 340,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-다과비",
        "calcBasis": "5,000원*90명",
        "calcAmt": 450,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-물품제작비(판넬)",
        "calcBasis": "50,000원*15개",
        "calcAmt": 750,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-자료집",
        "calcBasis": "15,000원*95부",
        "calcAmt": 1425,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-진행비",
        "calcBasis": "50,000원*1회",
        "calcAmt": 50,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2. 사업평가회의 공유 워크숍",
        "calcBasis": "",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-다과비",
        "calcBasis": "5,000원*100명",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[지부시상]",
        "calcBasis": "",
        "calcAmt": 15000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 지부시상",
        "calcBasis": "",
        "calcAmt": 15000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-국내사업종합부문(대상)",
        "calcBasis": "3,250,000원*2개",
        "calcAmt": 6500,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-국내사업종합부문(최우수, 우수상)",
        "calcBasis": "500,000원*10개",
        "calcAmt": 5000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-특별부문(장려상)",
        "calcBasis": "140,000원*25개",
        "calcAmt": 3500,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1020",
    "deptName": "경영기획팀",
    "bizName": "지부지원사업",
    "sehangName": "사업비",
    "mokName": "지부지원사업",
    "semokName": "조직관리",
    "legacyBudgetAmtWon": 12644000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[찾아가는 경영전략회의]",
        "calcBasis": "",
        "calcAmt": 8529,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "-교통비",
        "calcBasis": "90,000원*4회*6명",
        "calcAmt": 2160,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "-주차비",
        "calcBasis": "10,000원*2회*5명",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "-식대",
        "calcBasis": "12,000원*247명",
        "calcAmt": 2964,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "-다과비",
        "calcBasis": "5,000원*247명",
        "calcAmt": 1235,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "-진행비",
        "calcBasis": "10,000원*7회",
        "calcAmt": 70,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "-대관비",
        "calcBasis": "500,000원*4회",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[지부방문]",
        "calcBasis": "",
        "calcAmt": 4115,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "-교통비",
        "calcBasis": "30,000원*4회*3명*2회",
        "calcAmt": 720,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "-주차비",
        "calcBasis": "10,000원*4회*2명",
        "calcAmt": 80,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "-식대 및 간식비",
        "calcBasis": "17,000원*13명*15회",
        "calcAmt": 3315,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1020",
    "deptName": "경영기획팀",
    "bizName": "지부지원사업",
    "sehangName": "사업비",
    "mokName": "지부지원사업",
    "semokName": "조직관리",
    "legacyBudgetAmtWon": 4190000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[CEO 간담회]",
        "calcBasis": "",
        "calcAmt": 2040,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "-식대비",
        "calcBasis": "17,000원*120명",
        "calcAmt": 2040,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[확대부서장워크숍]",
        "calcBasis": "",
        "calcAmt": 2150,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 부서장/부장",
        "calcBasis": "",
        "calcAmt": 1156,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-식대비",
        "calcBasis": "12,000원*14명*2회",
        "calcAmt": 336,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-다과비",
        "calcBasis": "5,000원*14명*2회",
        "calcAmt": 140,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-장소대관비",
        "calcBasis": "200,000원*1개*1일*2회",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-프로그램비",
        "calcBasis": "10,000원*14명*2회",
        "calcAmt": 280,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2. 팀장",
        "calcBasis": "",
        "calcAmt": 994,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-식대비",
        "calcBasis": "12,000원*11명*2회",
        "calcAmt": 264,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-다과비",
        "calcBasis": "5,000원*11명*2회",
        "calcAmt": 110,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-장소대관비",
        "calcBasis": "200,000원*1개*1일*2회",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "-프로그램비",
        "calcBasis": "10,000원*11명*2회",
        "calcAmt": 220,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1020",
    "deptName": "경영기획팀",
    "bizName": "대외협력사업",
    "sehangName": "사업비",
    "mokName": "대외협력사업",
    "semokName": "대외협력사업비",
    "legacyBudgetAmtWon": 20000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[연회비 지원 및 대외행사 참석]",
        "calcBasis": "",
        "calcAmt": 20000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "-한국아동단체협의회 연회비",
        "calcBasis": "5,500,000원",
        "calcAmt": 5500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "-학술대회 협력비",
        "calcBasis": "8,500,000",
        "calcAmt": 8500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "-기타 단체 후원금 및 대외협력 사업비",
        "calcBasis": "6,000,000",
        "calcAmt": 6000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1020",
    "deptName": "경영기획팀",
    "bizName": "부서운영비",
    "sehangName": "사업비",
    "mokName": "부서운영비",
    "semokName": "부서운영비",
    "legacyBudgetAmtWon": 2000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "부서운영비",
        "calcBasis": "30,000원*5명*12개월",
        "calcAmt": 1800,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "부서워크숍",
        "calcBasis": "40,000원*5명",
        "calcAmt": 200,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1020",
    "deptName": "경영기획팀",
    "bizName": "부서운영비",
    "sehangName": "사업비",
    "mokName": "부서운영비",
    "semokName": "업무추진비",
    "legacyBudgetAmtWon": 1200000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "경영기획부장 업무추진비",
        "calcBasis": "100,000원*12개월",
        "calcAmt": 1200,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1020",
    "deptName": "경영기획팀",
    "bizName": "기관운영비",
    "sehangName": "업무추진비",
    "mokName": "기관운영비",
    "semokName": "기관운영비",
    "legacyBudgetAmtWon": 150000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "연하장 발송비",
        "calcBasis": "150,000원*1회",
        "calcAmt": 150,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1020",
    "deptName": "경영기획팀",
    "bizName": "제세공과금",
    "sehangName": "운영비",
    "mokName": "제세공과금",
    "semokName": "제세공과금(본부)",
    "legacyBudgetAmtWon": 300000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "한국사회복지협의회 연회비",
        "calcBasis": "300,000원*1회",
        "calcAmt": 300,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1030",
    "deptName": "감사실",
    "bizName": "여비",
    "sehangName": "운영비",
    "mokName": "여비",
    "semokName": "감사수행여비",
    "legacyBudgetAmtWon": 15305150,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "법인감사 수행비용",
        "calcBasis": "=식비 (17000*6)",
        "calcAmt": 102,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "서울서남아동보호전문기관(2월)",
        "calcBasis": "=교통비 60400",
        "calcAmt": 61,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "군포시아동보호전문기관(2월)",
        "calcBasis": "=숙박비(100000*2)+교통비 80000+식비 (12000*3*2)+ 회의비 (12000*3*2)",
        "calcAmt": 424,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "경기의왕아동보호전문기관(2월)",
        "calcBasis": "=숙박비 (100000*2)+교통비 70000+식비 (12000*3*2)+회의비(12000*3*2)",
        "calcAmt": 414,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "충북아동보호전문기관(3월)",
        "calcBasis": "=숙박비 (100000*2)+교통비 90000+식비 (12000*3*5)+회의비(12000*3*2)",
        "calcAmt": 542,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "충남중부아동보호전문기관(3월)",
        "calcBasis": "=숙박비 (100000*2)+교통비 84600+식비 (12000*3*5)+회의비 (12000*3*2)",
        "calcAmt": 537,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "광주지부(3월)",
        "calcBasis": "=숙박비 (100000*2)+교통비 286800+식비 (12000*3*5)+회의비 (12000*3*2)",
        "calcAmt": 739,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "광주좋은이웃지역아동센터(3월)",
        "calcBasis": "=숙박비 (100000*2)+교통비 20000+식비 (12000*3*5)+회의비 (12000*3*2)",
        "calcAmt": 472,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "방화2종합사회복지관(4월)",
        "calcBasis": "=교통비 71200",
        "calcAmt": 72,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "보성어린이집(4월)",
        "calcBasis": "=교통비 71200",
        "calcAmt": 72,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "전북특별자치도아동보호전문기관(4월)",
        "calcBasis": "=숙박비(100000*2)+교통비 123200+식비(12000*3*5)+회의비(12000*3*2)",
        "calcAmt": 576,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "전북군산시아동보호전문기관(4월)",
        "calcBasis": "=숙박비 (100000*2)+교통비 137050+식비 (12000*3*5)+회의비(12000*3*2)",
        "calcAmt": 590,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "전남북부권아동보호전문기관(4월)",
        "calcBasis": "=숙박비(100000*2)+교통비 315300+식비 (12000*3*5)+회의비 (12000*3*2)",
        "calcAmt": 768,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "울산가정위탁지원센터(4월)",
        "calcBasis": "=숙박비 (100000*2)+교통비 354000+식비(12000*3*5)+회의비(12000*3*2)",
        "calcAmt": 806,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "강원아동복지센터(5월)",
        "calcBasis": "=숙박비 (100000*2)+교통비 60600+식비 (12000*3*5)+회의비 (12000*3*2)",
        "calcAmt": 513,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "부산서부아동보호전문기관(5월)",
        "calcBasis": "=숙박비 (100000*2)+교통비 401200+식비 (12000*3*5)+회의비(12000*3*2)",
        "calcAmt": 854,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "김해좋은이웃지역아동센터(5월)",
        "calcBasis": "=숙박비 (100000*2)+교통비 20000+식비 (12000*3*5)+회의비(12000*3*2)",
        "calcAmt": 472,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "부산동부졸은이웃지역아동센터(5월)",
        "calcBasis": "=숙박비 (100000*2)+교통비 76000+식비 (12000*3*5)+회의비 (12000*3*2)",
        "calcAmt": 528,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "경기도거점아동보호전문기관(6월)",
        "calcBasis": "=숙박비 (100000*2)+교통비 100000+식비 (12000*3*2)+회의비 (12000*3*2)",
        "calcAmt": 444,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "아주좋은이웃심리치유센터(6월)",
        "calcBasis": "=숙박비 (100000*2)+교통비 90000+식비 (12000*3*2)+회의비(12000*3*2)",
        "calcAmt": 434,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "온주종합사회복지관(6월)",
        "calcBasis": "=숙박비(100000*2)+교통비 40000+식비 (12000*3*5)+회의비 (12000*3*2)",
        "calcAmt": 492,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "온주푸른교실지역아동센터(6월)",
        "calcBasis": "=숙박비 (100000*2)+교통비 20000+식비 (12000*3*5)+회의비(12000*3*2)",
        "calcAmt": 472,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "서울북부아동보호전문기관(7월)",
        "calcBasis": "=교통비 113600",
        "calcAmt": 114,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "성동좋은이웃지역아동센터(7월)",
        "calcBasis": "=교통비 89200",
        "calcAmt": 90,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "수원아동보호전문기관(7월)",
        "calcBasis": "=숙박비 (100000*2)+교통비 100000+식비 (12000*3*2)+회의비(12000*3*2)",
        "calcAmt": 444,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "전북특별자지도자립지원전담기관(9월)",
        "calcBasis": "=숙박비 (100000*2)+교통비 206400+식비 (12000*3*5)+회의비(12000*3*2)",
        "calcAmt": 659,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "경상남도자립지원전담기관(9월)",
        "calcBasis": "=숙박비 (100000*2)+교통비 328200+교통비 (12000*3*5)+회의비(12000*3*2)",
        "calcAmt": 781,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "대전아동보호전문기관(10월)",
        "calcBasis": "=숙박비 (100000*2)+교통비 142200+식비 (12000*3*5)+회의비 (12000*3*2)",
        "calcAmt": 595,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "창원좋은이웃지역아동센터(9월)",
        "calcBasis": "=숙박비 (100000*2)+교통비 20000+식비 (12000*3*5)+회의비 (12000*3*2)",
        "calcAmt": 472,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "특별감사 수행비용",
        "calcBasis": "=숙박비(69,000*2*4)+교통비 216,000+식비 (12000*3*5*4)+회의비(12000*3*2*4)",
        "calcAmt": 1776,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1030",
    "deptName": "감사실",
    "bizName": "지급수수료",
    "sehangName": "운영비",
    "mokName": "지급수수료",
    "semokName": "지급수수료(본부)",
    "legacyBudgetAmtWon": 400000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "법인감사 수행 ( 감사인 지급수수료)",
        "calcBasis": "=200000*2",
        "calcAmt": 400,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1030",
    "deptName": "감사실",
    "bizName": "통신비",
    "sehangName": "운영비",
    "mokName": "통신비",
    "semokName": "통신비(본부)",
    "legacyBudgetAmtWon": 198480,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "감사실 포켓와이파이 사용비용",
        "calcBasis": "=16540*12",
        "calcAmt": 199,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1030",
    "deptName": "감사실",
    "bizName": "기타제지출",
    "sehangName": "운영비",
    "mokName": "기타제지출",
    "semokName": "기타제지출",
    "legacyBudgetAmtWon": 2400000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "업무추진비",
        "calcBasis": "=100000*12",
        "calcAmt": 1200,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "부서운영비",
        "calcBasis": "=30000*3*12",
        "calcAmt": 1080,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "부서연수 및 워크샵",
        "calcBasis": "=40000*3*1",
        "calcAmt": 120,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1040",
    "deptName": "예산운영부",
    "bizName": "모금사업비",
    "sehangName": "사업비",
    "mokName": "모금사업비",
    "semokName": "모금관리비",
    "legacyBudgetAmtWon": 1230000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[2025년 사회복지법인 기부금품 모집 및 사용에 대한 회계감사비]",
        "calcBasis": "",
        "calcAmt": 1230,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) 회계감사비",
        "calcBasis": "1,100,000원*1명",
        "calcAmt": 1100,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2) 회계감사보고서 제작비",
        "calcBasis": "20,000원*5부",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "3) 회계감사진행비(다과비)",
        "calcBasis": "5,000원*6명",
        "calcAmt": 30,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1040",
    "deptName": "예산운영부",
    "bizName": "모금사업비",
    "sehangName": "사업비",
    "mokName": "모금사업비",
    "semokName": "회비수수료",
    "legacyBudgetAmtWon": 2880000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[전자결제 수수료]",
        "calcBasis": "80,000원*3개 전자결제 시스템*12개월",
        "calcAmt": 2880,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1040",
    "deptName": "예산운영부",
    "bizName": "회의비",
    "sehangName": "업무추진비",
    "mokName": "회의비",
    "semokName": "회의비",
    "legacyBudgetAmtWon": 1003000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[외부감사(중간,결산)]",
        "calcBasis": "",
        "calcAmt": 850,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) 외부감사 진행 다과비(3,10월)",
        "calcBasis": "5,000원*5회*10명",
        "calcAmt": 250,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2) 외부감사 진행 식비(3,10월)",
        "calcBasis": "12,000원*5회*10명",
        "calcAmt": 600,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[내부감사]",
        "calcBasis": "",
        "calcAmt": 153,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) 내부감사 진행 다과비(3월)",
        "calcBasis": "5,000원*1회*9명",
        "calcAmt": 45,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2) 내부감사 진행시 식비(3월)",
        "calcBasis": "12,000원*1회*9명",
        "calcAmt": 108,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1040",
    "deptName": "예산운영부",
    "bizName": "여비",
    "sehangName": "운영비",
    "mokName": "여비",
    "semokName": "여비교통비(본부)",
    "legacyBudgetAmtWon": 240000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[이사회 및 출납업무 교통비]",
        "calcBasis": "20,000원*12회",
        "calcAmt": 240,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1040",
    "deptName": "예산운영부",
    "bizName": "지급수수료",
    "sehangName": "운영비",
    "mokName": "지급수수료",
    "semokName": "지급수수료(본부)",
    "legacyBudgetAmtWon": 65569000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[회계법인 외부감사비]",
        "calcBasis": "",
        "calcAmt": 45700,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) 2025년 외부감사 보수비(잔금)(3월)",
        "calcBasis": "16,280,000원*1회",
        "calcAmt": 16280,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2) 2025년 은행조회 및 감사보고서 제작등 제반비(4월)",
        "calcBasis": "5,000,000원*1회",
        "calcAmt": 5000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "3) 2026년 외부감사 보수비(계약금,중도금)(7월,10월)",
        "calcBasis": "12,210,000원*2회",
        "calcAmt": 24420,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[내부감사 거마비]",
        "calcBasis": "200,000원*2명*1회",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[외부전문가 세무확인 계약금]",
        "calcBasis": "3,300,000원*1회",
        "calcAmt": 3300,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[인증서 발급]",
        "calcBasis": "",
        "calcAmt": 45,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) CMS공인인증서 발급",
        "calcBasis": "5,000원*5회",
        "calcAmt": 25,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2) OTP발급수수료",
        "calcBasis": "5,000원*4회",
        "calcAmt": 20,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[잔액증명서 및 등기부등본 발급]",
        "calcBasis": "100,000원*1회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[수수료]",
        "calcBasis": "",
        "calcAmt": 556,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) 법인세 조정비용",
        "calcBasis": "550,000원*1회",
        "calcAmt": 550,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2) 하이패스카드 연회비",
        "calcBasis": "3,000원*2회",
        "calcAmt": 6,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[비즈플레이 사용료]",
        "calcBasis": "1,289,000원*12개월",
        "calcAmt": 15468,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1040",
    "deptName": "예산운영부",
    "bizName": "통신비",
    "sehangName": "운영비",
    "mokName": "통신비",
    "semokName": "통신비(본부)",
    "legacyBudgetAmtWon": 180000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[업무관련 서류발송]",
        "calcBasis": "3,000원*5회*12개월",
        "calcAmt": 180,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1040",
    "deptName": "예산운영부",
    "bizName": "제세공과금",
    "sehangName": "운영비",
    "mokName": "제세공과금",
    "semokName": "제세공과금(본부)",
    "legacyBudgetAmtWon": 548000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[신원보증보험]",
        "calcBasis": "",
        "calcAmt": 521,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) 갱신보험료",
        "calcBasis": "108,000원*4명",
        "calcAmt": 432,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2) 2025년도 보험료 선급비용",
        "calcBasis": "89,000원",
        "calcAmt": 89,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[출판면허세]",
        "calcBasis": "27,000원*1회",
        "calcAmt": 27,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1040",
    "deptName": "예산운영부",
    "bizName": "기타제지출",
    "sehangName": "운영비",
    "mokName": "기타제지출",
    "semokName": "기타제지출",
    "legacyBudgetAmtWon": 1200000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[행정지원부장 업무추진비]",
        "calcBasis": "100,000원*12회",
        "calcAmt": 1200,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1040",
    "deptName": "예산운영부",
    "bizName": "기타제지출",
    "sehangName": "운영비",
    "mokName": "기타제지출",
    "semokName": "기타제지출(부서운영비)",
    "legacyBudgetAmtWon": 1600000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[회계팀 부서운영비]",
        "calcBasis": "30,000원*4명*12개월",
        "calcAmt": 1440,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[부서연수 및 워크샵]",
        "calcBasis": "40,000원*4명*1회",
        "calcAmt": 160,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1040",
    "deptName": "예산운영부",
    "bizName": "기타제지출",
    "sehangName": "운영비",
    "mokName": "기타제지출",
    "semokName": "기타제지출(회계교육)",
    "legacyBudgetAmtWon": 3695000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[본부 세출교육]",
        "calcBasis": "5,000원*84명*1회",
        "calcAmt": 420,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[국내 사업장 회계교육]",
        "calcBasis": "",
        "calcAmt": 3275,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) 대표직책 회계교육",
        "calcBasis": "15,000원*55명*1회",
        "calcAmt": 825,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2) 신규 담당자 회계교육",
        "calcBasis": "15,000원*64개사업장*1명*1회",
        "calcAmt": 960,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "3) 예비리더 회계교육",
        "calcBasis": "15,000원*30명*1회",
        "calcAmt": 450,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "4) 사무원 및 중간관리자 외부전문가 초청교육",
        "calcBasis": "5,000원*128명*1회",
        "calcAmt": 640,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "5) 사무원 및 중간관리자 외부전문가 초청교육 강사비",
        "calcBasis": "250,000원*1시간+150,000원*1시간*1회",
        "calcAmt": 400,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1040",
    "deptName": "예산운영부",
    "bizName": "기타제지출",
    "sehangName": "운영비",
    "mokName": "기타제지출",
    "semokName": "기타제지출(기타)",
    "legacyBudgetAmtWon": 150000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지법인 및 시설 관리책자 제본비]",
        "calcBasis": "150,000원*1회",
        "calcAmt": 150,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "부서운영비",
    "sehangName": "사업비",
    "mokName": "부서운영비",
    "semokName": "장비유지보수비",
    "legacyBudgetAmtWon": 2261520,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지법인 공기청정기 임대료]",
        "calcBasis": "",
        "calcAmt": 118,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 공기청정기 임대료(기획실)",
        "calcBasis": "9,820원*1대*12개월",
        "calcAmt": 118,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지법인 정수기 임대료]",
        "calcBasis": "",
        "calcAmt": 309,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 정수기 임대료(9층 탕비실)",
        "calcBasis": "25,740원*1대*12개월",
        "calcAmt": 309,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지법인 복합기 임대료]",
        "calcBasis": "",
        "calcAmt": 1835,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 컬러무한잉크 프린트(4층 좌)",
        "calcBasis": "37,400원*1대*12개월",
        "calcAmt": 449,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 컬러무한잉크 프린트(9층)",
        "calcBasis": "37,400원*1대*12개월",
        "calcAmt": 449,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- A3 흑백 복합기(4층 좌)",
        "calcBasis": "78,100원*1대*12개월",
        "calcAmt": 938,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "아동보호전문기관 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "아동보호전문기관 전출금(후원금)",
    "semokName": "아동보호전문기관 전출금(후원금)",
    "legacyBudgetAmtWon": 323748000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장 일반공사, 수선 및 비품교체",
        "calcBasis": "약 2,270,600원*12개월",
        "calcAmt": 27248,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "사업장 이전 및 종료 제반비용",
        "calcBasis": "59,300,000원*5회",
        "calcAmt": 296500,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "기획사업비",
    "sehangName": "사업비",
    "mokName": "기획사업비",
    "semokName": "기타지부지원사업비",
    "legacyBudgetAmtWon": 3151000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "2024년 12월 31일 종료 사업장 발생 비용",
        "calcBasis": "240,000원*6개월",
        "calcAmt": 1440,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "2025년 12월 31일 종료 사업장 발생 비용",
        "calcBasis": "1,711,000원*1회",
        "calcAmt": 1711,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "가정위탁지원센터 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "가정위탁지원센터 전출금(후원금)",
    "semokName": "가정위탁지원센터 전출금(후원금)",
    "legacyBudgetAmtWon": 49056000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장 일반공사, 수선 및 비품교체",
        "calcBasis": "63,000원*12개월",
        "calcAmt": 756,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "사업장 이전에 따른 설치",
        "calcBasis": "48,300,000원*1회",
        "calcAmt": 48300,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "지역아동센터 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "지역아동센터 전출금(후원금)",
    "semokName": "지역아동센터 전출금(후원금)",
    "legacyBudgetAmtWon": 10596000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장 일반공사, 수선 및 비품교체",
        "calcBasis": "883,000원*12개월",
        "calcAmt": 10596,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "심리치유센터 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "심리치유센터 전출금(후원금)",
    "semokName": "심리치유센터 전출금(후원금)",
    "legacyBudgetAmtWon": 756000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장 일반공사, 수선 및 비품교체",
        "calcBasis": "63,000원*12개월",
        "calcAmt": 756,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "자립지원전담기관 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "자립지원전담기관 전출금(후원금)",
    "semokName": "자립지원전담기관 전출금(후원금)",
    "legacyBudgetAmtWon": 1514000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장 일반공사, 수선 및 비품교체",
        "calcBasis": "약 126,100원*12개월",
        "calcAmt": 1514,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "부서운영비",
    "sehangName": "사업비",
    "mokName": "부서운영비",
    "semokName": "장비유지보수비",
    "legacyBudgetAmtWon": 451080,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지법인 공기청정기 임대료]",
        "calcBasis": "",
        "calcAmt": 452,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 공기청정기 임대료(4층 좌)",
        "calcBasis": "17,950원*1대*12개월",
        "calcAmt": 216,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 공기청정기 임대료(감사실, 연구소)",
        "calcBasis": "9,820원*2대*12개월",
        "calcAmt": 236,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "종합사회복지관 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "종합사회복지관 전출금(후원금)",
    "semokName": "종합사회복지관 전출금(후원금)",
    "legacyBudgetAmtWon": 1514000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장 일반공사, 수선 및 비품교체",
        "calcBasis": "약 126,166원*12개월",
        "calcAmt": 1514,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "부서운영비",
    "sehangName": "조사연구사업",
    "mokName": "부서운영비",
    "semokName": "장비유지보수비",
    "legacyBudgetAmtWon": 599640,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지법인 공기청정기 임대료]",
        "calcBasis": "",
        "calcAmt": 118,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 공기청정기 임대료(사무총장실)",
        "calcBasis": "9,820원*1대*12개월",
        "calcAmt": 118,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지법인 복합기 임대료]",
        "calcBasis": "",
        "calcAmt": 482,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 컬러무한잉크 복합기(사무총장실)",
        "calcBasis": "40,150원*1대*12개월",
        "calcAmt": 482,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "기획사업비",
    "sehangName": "조사연구사업",
    "mokName": "기획사업비",
    "semokName": "기타지부지원사업비",
    "legacyBudgetAmtWon": 9000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[법무 지원 프리랜서 급요]",
        "calcBasis": "750,000원*12개월",
        "calcAmt": 9000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "직책보조비",
    "sehangName": "업무추진비",
    "mokName": "직책보조비",
    "semokName": "직책보조비",
    "legacyBudgetAmtWon": 3600000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "이사장 직책보조비",
        "calcBasis": "300,000원*12개월",
        "calcAmt": 3600,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "회의비",
    "sehangName": "업무추진비",
    "mokName": "회의비",
    "semokName": "회의비",
    "legacyBudgetAmtWon": 10016000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지법인 이사회 진행비 / 4회(3,6,10,12월)",
        "calcBasis": "",
        "calcAmt": 10016,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 거마비",
        "calcBasis": "200,000원*8명*4회",
        "calcAmt": 6400,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 진행비",
        "calcBasis": "30,000원*15명(임원9명, 사무국6명)*4회",
        "calcAmt": 1800,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 자료집 제작",
        "calcBasis": "7부*10,000원*4회",
        "calcAmt": 280,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 기타 준비비(주차, 물품구입, 대관비, 수행직원 진행비 등)",
        "calcBasis": "300,000원*4회",
        "calcAmt": 1200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 제본비",
        "calcBasis": "17,000원*8부*1회(12월)",
        "calcAmt": 136,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 외부추천이사(최소연) 퇴임에 따른 감사패 및 선물 구매",
        "calcBasis": "150,000원*1회(6월)",
        "calcAmt": 150,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 신규 선임 임원 내방교육 진행비",
        "calcBasis": "50,000원*1회(6월)",
        "calcAmt": 50,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "여비",
    "sehangName": "운영비",
    "mokName": "여비",
    "semokName": "여비교통비(본부)",
    "legacyBudgetAmtWon": 2528000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[사업장 방문- 종료]",
        "calcBasis": "",
        "calcAmt": 848,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "* 1월 목포햇살아래 그룹홈",
        "calcBasis": "",
        "calcAmt": 544,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 교통비",
        "calcBasis": "50,000원*2회(왕복)*2회*2인",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 식비",
        "calcBasis": "12,000원*2식*2회*2인",
        "calcAmt": 96,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 일비",
        "calcBasis": "12,000원*2회*2인",
        "calcAmt": 48,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "* 3월 사랑샘그룹홈",
        "calcBasis": "",
        "calcAmt": 304,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 교통비",
        "calcBasis": "20,000원*2회(왕복)*2회*2인",
        "calcAmt": 160,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 식비",
        "calcBasis": "12,000원*2식*2회*2인",
        "calcAmt": 96,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 일비",
        "calcBasis": "12,000원*2회*2인",
        "calcAmt": 48,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[하이패스 요금]",
        "calcBasis": "",
        "calcAmt": 1680,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 하이패스 요금",
        "calcBasis": "35,000원*4대*12개월",
        "calcAmt": 1680,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "수용비및수수료",
    "sehangName": "운영비",
    "mokName": "수용비및수수료",
    "semokName": "수용비및수수료",
    "legacyBudgetAmtWon": 200000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[종료사업장 전세권 말소 수수료(대구경북지역본부)]",
        "calcBasis": "200,000원*1회",
        "calcAmt": 200,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "지급수수료",
    "sehangName": "운영비",
    "mokName": "지급수수료",
    "semokName": "지급수수료(본부)",
    "legacyBudgetAmtWon": 11734000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[지부 설치,이전,종료,명칭변경,자산변경 등 등기수수료]",
        "calcBasis": "",
        "calcAmt": 640,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 본점등기",
        "calcBasis": "100,000원*4회",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 지점등기",
        "calcBasis": "60,000원*4회",
        "calcAmt": 240,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[임원변동 등기수수료(임원1명/최소연이사)",
        "calcBasis": "",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 본점 및 지점등기",
        "calcBasis": "100,000원*1회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[법인서류(인감증명서 및 등기) 발급]",
        "calcBasis": "",
        "calcAmt": 1296,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 인감증명서 발급",
        "calcBasis": "1,000원*300매*4회",
        "calcAmt": 1200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 법인등기 발급",
        "calcBasis": "1,000원*8회*12개월",
        "calcAmt": 96,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[본부 주차요금 지원]",
        "calcBasis": "",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 본부 주차권 추가 구매",
        "calcBasis": "60,000원(40매)*5회",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[나라장터 이용관련 수수료]",
        "calcBasis": "",
        "calcAmt": 498,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 범용공인인증서 갱신(수요기관)",
        "calcBasis": "110,000원*1회",
        "calcAmt": 110,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 범용공인인증서 갱신(조달업체)",
        "calcBasis": "88,000원*1회",
        "calcAmt": 88,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 나라장터 전자입찰 수수료",
        "calcBasis": "30,000원*10회",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[법률 자문 수수료]",
        "calcBasis": "6,600,000원*1회",
        "calcAmt": 6600,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[법인 상표권 갱신 수수료]",
        "calcBasis": "",
        "calcAmt": 750,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 업무표장 갱신비용(굿워터프로젝트, 굿바이(착한소비캠페인), 前 굿네이버스 CI)",
        "calcBasis": "250,000원*3회",
        "calcAmt": 750,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지법인 전자계약시스템 이용비]",
        "calcBasis": "1,000건*550원",
        "calcAmt": 550,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[감정평가 수수료]",
        "calcBasis": "",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 기본재산 매각(사랑샘그룹홈)을 위한 감정평가 진행",
        "calcBasis": "500,000원*2회",
        "calcAmt": 1000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "사무용품비",
    "sehangName": "운영비",
    "mokName": "사무용품비",
    "semokName": "사무용품비(본부)",
    "legacyBudgetAmtWon": 6097000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[본부 비품 구입]",
        "calcBasis": "",
        "calcAmt": 1800,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 본부 사무용품, 가구 구입 등",
        "calcBasis": "150,000원*12개월",
        "calcAmt": 1800,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[직원증 제작]",
        "calcBasis": "",
        "calcAmt": 800,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 본부/지부 직원증",
        "calcBasis": "200,000원*4회",
        "calcAmt": 800,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[본부 파쇄 비용]",
        "calcBasis": "143,000원*4회",
        "calcAmt": 572,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지법인 공기청정기 임대료]",
        "calcBasis": "",
        "calcAmt": 120,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 공기청정기 임대료(이사장실)",
        "calcBasis": "10,000원*1대*12개월",
        "calcAmt": 120,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지법인 복합기 임대료]",
        "calcBasis": "",
        "calcAmt": 2805,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- A3 복합기(9층, 4층 우)",
        "calcBasis": "78,100원*2대*12개월",
        "calcAmt": 1875,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 컬러무한잉크 프린트(기획실)",
        "calcBasis": "37,400원*1대*12개월",
        "calcAmt": 449,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 컬러무한잉크 복합기(인재운영부)",
        "calcBasis": "40,150원*1대*12개월",
        "calcAmt": 482,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "통신비",
    "sehangName": "운영비",
    "mokName": "통신비",
    "semokName": "통신비(본부)",
    "legacyBudgetAmtWon": 17256000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지법인 본부 통신비용]",
        "calcBasis": "",
        "calcAmt": 12468,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- IPT 전화(사단법인 통신비 1,735천원의 24%)",
        "calcBasis": "416,400원*12개월",
        "calcAmt": 4997,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 인터넷 비용",
        "calcBasis": "622,600원*12개월",
        "calcAmt": 7472,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지법인 본부(창고) 통신비용]",
        "calcBasis": "28,000원*12개월",
        "calcAmt": 336,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지법인 대표번호 착신서비스]",
        "calcBasis": "75,000원*12개월",
        "calcAmt": 900,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[법인서류 발송비]",
        "calcBasis": "3,700원*월80건*12개월",
        "calcAmt": 3552,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "제세공과금",
    "sehangName": "운영비",
    "mokName": "제세공과금",
    "semokName": "제세공과금(본부)",
    "legacyBudgetAmtWon": 3113000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[지부 설치,이전,종료,명칭변경,자산변경 등 등기 제세]",
        "calcBasis": "",
        "calcAmt": 640,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 본점등기",
        "calcBasis": "100,000*4회",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 지점등기",
        "calcBasis": "60,000원*4회",
        "calcAmt": 240,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[임원변동 등기 제세(임원1명/최소연 이사]",
        "calcBasis": "",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 본점 및 지점등기",
        "calcBasis": "100,000원*1회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[법인 관련 제세]",
        "calcBasis": "",
        "calcAmt": 473,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 강원도 건축물(원주시 판부면 서곡리) 재산세",
        "calcBasis": "150,000원*1회",
        "calcAmt": 150,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 본부 주민세(법인균등분)",
        "calcBasis": "63,000원*1회",
        "calcAmt": 63,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 강원도 토지(원주시 판부면 서곡리) 재산세",
        "calcBasis": "260,000원*1회",
        "calcAmt": 260,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[법인상표권 갱신 제세]",
        "calcBasis": "",
        "calcAmt": 1800,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 업무표장 갱신비용(굿워터프로젝트, 굿바이(착한소비캠페인), 前 굿네이버스 CI)",
        "calcBasis": "600,000원*3회",
        "calcAmt": 1800,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[종료사업장 전세권 말소 제세(대구경북지역본부)]",
        "calcBasis": "100,000원*1회",
        "calcAmt": 100,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "차량비",
    "sehangName": "운영비",
    "mokName": "차량비",
    "semokName": "차량유류대",
    "legacyBudgetAmtWon": 4800000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[차량 유류대]",
        "calcBasis": "100,000원*4대*12개월",
        "calcAmt": 4800,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "차량비",
    "sehangName": "운영비",
    "mokName": "차량비",
    "semokName": "차량유지보수비",
    "legacyBudgetAmtWon": 2412000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[차량 세차]",
        "calcBasis": "35,200원*4대*6개월",
        "calcAmt": 845,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[차량관리시스템]",
        "calcBasis": "",
        "calcAmt": 1268,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 차량관리시스템(Basic)",
        "calcBasis": "14,300원*2대*12개월",
        "calcAmt": 344,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 차량관리시스템(Premium)",
        "calcBasis": "38500*2대*12개월",
        "calcAmt": 924,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[차량수리 및 정기점검]",
        "calcBasis": "100,000원*3회",
        "calcAmt": 300,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "차량비",
    "sehangName": "운영비",
    "mokName": "차량비",
    "semokName": "차량렌트비",
    "legacyBudgetAmtWon": 25320000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[차량렌트비]",
        "calcBasis": "",
        "calcAmt": 25320,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- K3(4386)",
        "calcBasis": "403,000원*12개월",
        "calcAmt": 4836,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- K3(9940)",
        "calcBasis": "517,000원*12개월",
        "calcAmt": 6204,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- K5(4006)",
        "calcBasis": "540,000원*12개월",
        "calcAmt": 6480,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 그랜저(9537)",
        "calcBasis": "650,000원*12개월",
        "calcAmt": 7800,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "사무실관리비",
    "sehangName": "운영비",
    "mokName": "사무실관리비",
    "semokName": "임대료",
    "legacyBudgetAmtWon": 190980000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지법인 사무실 임대료]",
        "calcBasis": "15,175,000원*12개월",
        "calcAmt": 182100,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지법인 창고 임대료]",
        "calcBasis": "715,000원*12개월",
        "calcAmt": 8580,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[종료사업장 임대료(대구경북지역본부(]",
        "calcBasis": "300,000원*1회",
        "calcAmt": 300,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "사무실관리비",
    "sehangName": "운영비",
    "mokName": "사무실관리비",
    "semokName": "사무실관리비",
    "legacyBudgetAmtWon": 132576000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지법인 사무실 관리비]",
        "calcBasis": "10,868,000원*12개월",
        "calcAmt": 130416,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지법인 창고 관리비]",
        "calcBasis": "180,000원*12개월",
        "calcAmt": 2160,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "기타제지출",
    "sehangName": "운영비",
    "mokName": "기타제지출",
    "semokName": "기타제지출",
    "legacyBudgetAmtWon": 2501760,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[캡스 물리보안 임대료]",
        "calcBasis": "61,600원*12개월",
        "calcAmt": 740,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지법인 공기청정기 임대료]",
        "calcBasis": "",
        "calcAmt": 216,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 공기청정기 임대료(4층 우)",
        "calcBasis": "17,950원*1대*12개월",
        "calcAmt": 216,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지법인 정수기 임대료]",
        "calcBasis": "",
        "calcAmt": 756,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 정수기 임대료(4층 좌)",
        "calcBasis": "25,740원*1대*12개월",
        "calcAmt": 309,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 정수기 임대료(4층 우)",
        "calcBasis": "37,240원*1대*12개월",
        "calcAmt": 447,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지법인 비데 임대료]",
        "calcBasis": "",
        "calcAmt": 310,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 비데(4층 남,여)",
        "calcBasis": "12,900원*2대*12개월",
        "calcAmt": 310,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지법인 복합기 임대료]",
        "calcBasis": "",
        "calcAmt": 482,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 컬러무한잉크 복합기(감사실)",
        "calcBasis": "40,150원*1대*12개월",
        "calcAmt": 482,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "기타제지출",
    "sehangName": "운영비",
    "mokName": "기타제지출",
    "semokName": "기타제지출(부서운영비)",
    "legacyBudgetAmtWon": 1200000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[부서운영비]",
        "calcBasis": "",
        "calcAmt": 1200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 일반직 부서운영비",
        "calcBasis": "30,000원*3명*12개월",
        "calcAmt": 1080,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 부서워크샵",
        "calcBasis": "40,000원*3명*1회",
        "calcAmt": 120,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "기타제지출",
    "sehangName": "운영비",
    "mokName": "기타제지출",
    "semokName": "기타제지출(기타)",
    "legacyBudgetAmtWon": 1600000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[외부업체 미팅 진행비]",
        "calcBasis": "5,000원*4명*5회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[투명거래심의위원회 진행비]",
        "calcBasis": "5,000원*6명(심의위원4명, 업체2명)*10회",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[ESG 경영캠페인 진행비]",
        "calcBasis": "600,000원*2회",
        "calcAmt": 1200,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "사회적약자통합지원센터 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "사회적약자통합지원센터 전출금(후원금)",
    "semokName": "사회적약자통합지원센터 전출금(후원금)",
    "legacyBudgetAmtWon": 756000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장 일반공사, 수선 및 비품교체",
        "calcBasis": "63,000원*12개월",
        "calcAmt": 756,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "지역아동센터 시도지원단 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "지역아동센터 시도지원단 전출금(후원금)",
    "semokName": "지역아동센터 시도지원단 전출금(후원금)",
    "legacyBudgetAmtWon": 756000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장 일반공사, 수선 및 비품교체",
        "calcBasis": "63,000원*12개월",
        "calcAmt": 756,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1050",
    "deptName": "총무팀",
    "bizName": "아동복지센터 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "아동복지센터 전출금(후원금)",
    "semokName": "아동복지센터 전출금(후원금)",
    "legacyBudgetAmtWon": 756000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장 일반공사, 수선 및 비품교체",
        "calcBasis": "63,000원*12개월",
        "calcAmt": 756,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1060",
    "deptName": "디지털기획운영팀",
    "bizName": "지부지원사업",
    "sehangName": "조사연구사업",
    "mokName": "지부지원사업",
    "semokName": "사업장방문",
    "legacyBudgetAmtWon": 855000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[본부교육]",
        "calcBasis": "",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "오피셜 업무 공유 워크숍(본부직원대상)",
        "calcBasis": "40명*5,000원",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[사업장 교육]",
        "calcBasis": "",
        "calcAmt": 655,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "신규 회계담당자 ERP 교육(집합)",
        "calcBasis": "5,000원*35명*1회",
        "calcAmt": 175,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "희망이음 연계 및 ERP 사용자 교육(집합)",
        "calcBasis": "5,000원*32개기관*3명",
        "calcAmt": 480,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1060",
    "deptName": "디지털기획운영팀",
    "bizName": "부서운영비",
    "sehangName": "조사연구사업",
    "mokName": "부서운영비",
    "semokName": "부서운영비",
    "legacyBudgetAmtWon": 1600000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "부서운영비(일반직 4명)",
        "calcBasis": "일반직 4명 * 30,000원 * 12개월",
        "calcAmt": 1440,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "부서워크샵(일반직 4명)",
        "calcBasis": "일반직 4명 * 40,000원 * 1개월",
        "calcAmt": 160,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1060",
    "deptName": "디지털기획운영팀",
    "bizName": "부서운영비",
    "sehangName": "사업비",
    "mokName": "부서운영비",
    "semokName": "업무추진비",
    "legacyBudgetAmtWon": 2400000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "경영지원본부장 업무추진비",
        "calcBasis": "100,000원*12개월",
        "calcAmt": 1200,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "디지털기획운영부장 업무추진비",
        "calcBasis": "100,000원*12개월",
        "calcAmt": 1200,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1060",
    "deptName": "디지털기획운영팀",
    "bizName": "직원지원정책",
    "sehangName": "사업비",
    "mokName": "직원지원정책",
    "semokName": "정책연구사업지원인력",
    "legacyBudgetAmtWon": 9432000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[IT] PC OA 초단시간 계약직 근로자 급여",
        "calcBasis": "786,000원*12개월",
        "calcAmt": 9432,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1060",
    "deptName": "디지털기획운영팀",
    "bizName": "지급수수료",
    "sehangName": "운영비",
    "mokName": "지급수수료",
    "semokName": "지급수수료(본부)",
    "legacyBudgetAmtWon": 192218390,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[사복단독]",
        "calcBasis": "",
        "calcAmt": 77535,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 관리",
        "calcBasis": "",
        "calcAmt": 75445,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) Bizplay 중계서버 및 ERP 클라우드 비용",
        "calcBasis": "",
        "calcAmt": 29749,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- Bizplay 중계서버 비용",
        "calcBasis": "305,580*12개월",
        "calcAmt": 3667,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- ERP 클라우드 비용",
        "calcBasis": "2,173,490*12개월",
        "calcAmt": 26082,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2) MS오피스 라이선스",
        "calcBasis": "255,000*50개",
        "calcAmt": 12750,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "3) 백신 소프트웨어 라이선스 갱신(V3)",
        "calcBasis": "11,550,000원*1회",
        "calcAmt": 11550,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "4) IDC운영비(마포)",
        "calcBasis": "1,540,000*12개월",
        "calcAmt": 18480,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "5) 한컴오피스 라이선스 연간 구독료",
        "calcBasis": "30,690원*95명",
        "calcAmt": 2916,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2. 유지보수",
        "calcBasis": "",
        "calcAmt": 2090,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 비품관리시스템 유지보수",
        "calcBasis": "2,090,000원*1회",
        "calcAmt": 2090,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[사단협력]",
        "calcBasis": "",
        "calcAmt": 114684,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 관리",
        "calcBasis": "",
        "calcAmt": 88634,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 그룹웨어 사용료",
        "calcBasis": "5,390,000원*12회",
        "calcAmt": 64680,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2) RPA 라이선스",
        "calcBasis": "",
        "calcAmt": 7500,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- RPA BOT 사용료",
        "calcBasis": "5,500,000원*1회",
        "calcAmt": 5500,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- RPA Orchestrator 사용료",
        "calcBasis": "2,000,000원*1회",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "3) RPA 디자이너 사용료",
        "calcBasis": "4,500,000원*1회",
        "calcAmt": 4500,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "4) CRM 클라우드 Server",
        "calcBasis": "11,354,000*1회",
        "calcAmt": 11354,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "5) 내부 웹사이트 보안 인증서 구입",
        "calcBasis": "600,000원*1회",
        "calcAmt": 600,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "6) 사회복지법인 도메인 관리",
        "calcBasis": "0",
        "calcAmt": 0,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2. 유지보수",
        "calcBasis": "",
        "calcAmt": 26050,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 인사시스템 유지보수",
        "calcBasis": "14,300,000원*1회",
        "calcAmt": 14300,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2) 오피스키퍼(정책보안 솔루션) 유지보수",
        "calcBasis": "5,400,000원*1회",
        "calcAmt": 5400,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "3) 더존 ERP 유지보수",
        "calcBasis": "2,750,000원",
        "calcAmt": 2750,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "4) 시스템 H/W 유지보수",
        "calcBasis": "900,000원*4개월",
        "calcAmt": 3600,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1060",
    "deptName": "디지털기획운영팀",
    "bizName": "사무용품비",
    "sehangName": "운영비",
    "mokName": "사무용품비",
    "semokName": "사무용품비(본부)",
    "legacyBudgetAmtWon": 3000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[IT] 전산 소모품 구매",
        "calcBasis": "500,000원*2회",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[IT] IT 운영팀 업무용 PC 구입",
        "calcBasis": "2,000,000원*1회",
        "calcAmt": 2000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1060",
    "deptName": "디지털기획운영팀",
    "bizName": "자산취득비",
    "sehangName": "시설비",
    "mokName": "자산취득비",
    "semokName": "자산취득비",
    "legacyBudgetAmtWon": 132100000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "통합 경영정보시스템(ERP) 3차 고도화 사업 대금(중도금)",
        "calcBasis": "40000000",
        "calcAmt": 40000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "통합 경영정보시스템(ERP) 3차 고도화 사업 대금(잔금)",
        "calcBasis": "40000000",
        "calcAmt": 40000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "통합 경영정보시스템(ERP) 기술지원협약금(잔금)",
        "calcBasis": "50000000",
        "calcAmt": 50000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "네트워크 라이선스 구입",
        "calcBasis": "",
        "calcAmt": 2100,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 네트워크스위치(데이터)",
        "calcBasis": "9EA*100,000",
        "calcAmt": 900,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 네트워크스위치(전화)",
        "calcBasis": "3EA*310,000",
        "calcAmt": 930,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 무선AP스위치",
        "calcBasis": "9EA*30,000",
        "calcAmt": 270,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1060",
    "deptName": "디지털기획운영팀",
    "bizName": "시설장비유지비",
    "sehangName": "시설비",
    "mokName": "시설장비유지비",
    "semokName": "시설장비유지비",
    "legacyBudgetAmtWon": 100619000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "유지보수",
        "calcBasis": "",
        "calcAmt": 100619,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) ERP 유지보수 비용(분기별)",
        "calcBasis": "17,500,000*4회",
        "calcAmt": 70000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2) 인터넷디스크 유지보수",
        "calcBasis": "3,619,000원*1회",
        "calcAmt": 3619,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "3) 문서보안환경(DRM) 유지보수",
        "calcBasis": "27,000,000원*1회",
        "calcAmt": 27000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 99433000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "일반직 인건비",
        "calcBasis": "99432710",
        "calcAmt": 99433,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 39296000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "일반직 인건비",
        "calcBasis": "39296030",
        "calcAmt": 39296,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 11517000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "일반직 인건비",
        "calcBasis": "11517062",
        "calcAmt": 11517,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 85281000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "일반직 인건비",
        "calcBasis": "85281260",
        "calcAmt": 85281,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "기획사업비",
    "sehangName": "사업비",
    "mokName": "기획사업비",
    "semokName": "사업연구",
    "legacyBudgetAmtWon": 1000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "더좋은파트너 홈페이지 유지보수",
        "calcBasis": "",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "홈페이지 유지비",
        "calcBasis": "165000",
        "calcAmt": 165,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "기능 업데이트",
        "calcBasis": "835000",
        "calcAmt": 835,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "기획사업비",
    "sehangName": "사업비",
    "mokName": "기획사업비",
    "semokName": "기타지부지원사업비",
    "legacyBudgetAmtWon": 50000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "기타지부지원금 (대구경북지역본부)",
        "calcBasis": "50000",
        "calcAmt": 50,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "부서운영비",
    "sehangName": "사업비",
    "mokName": "부서운영비",
    "semokName": "부서운영비",
    "legacyBudgetAmtWon": 3200000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "임팩트사업1팀 부서운영비",
        "calcBasis": "",
        "calcAmt": 3200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "부서운영비",
        "calcBasis": "30000*8*12",
        "calcAmt": 2880,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "워크숍",
        "calcBasis": "40000*8*1",
        "calcAmt": 320,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "부서운영비",
    "sehangName": "사업비",
    "mokName": "부서운영비",
    "semokName": "업무추진비",
    "legacyBudgetAmtWon": 1200000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "임팩트사업부 업무추진비",
        "calcBasis": "100000*12",
        "calcAmt": 1200,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "대외협력사업",
    "sehangName": "조사연구사업",
    "mokName": "대외협력사업",
    "semokName": "대외협력사업비",
    "legacyBudgetAmtWon": 480000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "임팩트사업부 대외협력비",
        "calcBasis": "5000*8*12",
        "calcAmt": 480,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 44666000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "인건비",
        "calcBasis": "",
        "calcAmt": 44666,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "일반직 인건비",
        "calcBasis": "21201140",
        "calcAmt": 21201,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "계약직 인건비",
        "calcBasis": "23465220",
        "calcAmt": 23465,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "자립역량 지원",
    "sehangName": "사업비",
    "mokName": "자립역량 지원",
    "semokName": "자립준비",
    "legacyBudgetAmtWon": 150000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "전문업체 용역비용",
        "calcBasis": "125000000",
        "calcAmt": 125000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "자립준비청년 생활안정지원금",
        "calcBasis": "25000000",
        "calcAmt": 25000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "자립역량 지원",
    "sehangName": "사업비",
    "mokName": "자립역량 지원",
    "semokName": "자립준비",
    "legacyBudgetAmtWon": 220000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "우리사이 3차 사업비",
        "calcBasis": "",
        "calcAmt": 220000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "전문업체 용역비용",
        "calcBasis": "35500000",
        "calcAmt": 35500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "자립준비청년 멘토 지원금 (사회인멘토 포함)",
        "calcBasis": "134500000*1",
        "calcAmt": 134500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "자립준비청년 생활안정지원금",
        "calcBasis": "50000000",
        "calcAmt": 50000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "자립 지원 기획사업비",
    "sehangName": "사업비",
    "mokName": "자립 지원 기획사업비",
    "semokName": "자립 지원 기획사업",
    "legacyBudgetAmtWon": 8850000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지정기금 사업비",
        "calcBasis": "",
        "calcAmt": 8850,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "우리사이 3차 모니터링 진행비",
        "calcBasis": "3000000",
        "calcAmt": 3000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "우리사이 3차 사무용품 구입비",
        "calcBasis": "3000000",
        "calcAmt": 3000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "우리사이 3차 회의 진행비",
        "calcBasis": "1000000",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "우리사이 3차 기타 사업 진행비",
        "calcBasis": "1850000",
        "calcAmt": 1850,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "자립지원전담기관 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "자립지원전담기관 전출금(후원금)",
    "semokName": "자립지원전담기관 전출금(후원금)기타",
    "legacyBudgetAmtWon": 60000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지정기금 사업비",
        "calcBasis": "",
        "calcAmt": 60000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "경상남도 자립지원전담기관",
        "calcBasis": "30000000*1",
        "calcAmt": 30000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "전라북도 자립지원전담기관",
        "calcBasis": "30000000*1",
        "calcAmt": 30000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "가정위탁지원센터 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "가정위탁지원센터 전출금(후원금)",
    "semokName": "가정위탁지원센터 전출금(후원금)기타",
    "legacyBudgetAmtWon": 30000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "가정위탁지원센터 사업비",
        "calcBasis": "30000000*1",
        "calcAmt": 30000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 7000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지정기금 전담인력 인건비",
        "calcBasis": "3500000*2",
        "calcAmt": 7000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "건강증진지원사업",
    "sehangName": "사업비",
    "mokName": "건강증진지원사업",
    "semokName": "건강관리지원",
    "legacyBudgetAmtWon": 135000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지정기금 사업비",
        "calcBasis": "",
        "calcAmt": 135000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "키트 제작 비용",
        "calcBasis": "133500000*1",
        "calcAmt": 133500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "임직원 봉사활동",
        "calcBasis": "1500000*1",
        "calcAmt": 1500,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "신체건강 지원 기획사업비",
    "sehangName": "사업비",
    "mokName": "신체건강 지원 기획사업비",
    "semokName": "신체건강 지원 기획사업",
    "legacyBudgetAmtWon": 500000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "모니터링 및 회의비",
        "calcBasis": "500000*1",
        "calcAmt": 500,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "가정위탁지원센터 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "가정위탁지원센터 전출금(후원금)",
    "semokName": "가정위탁지원센터 전출금(후원금)기타",
    "legacyBudgetAmtWon": 10000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "가정위탁지원센터 사업비",
        "calcBasis": "10000000*1",
        "calcAmt": 10000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 786000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "일반직 인건비",
        "calcBasis": "785698",
        "calcAmt": 786,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "자립역량 지원",
    "sehangName": "사업비",
    "mokName": "자립역량 지원",
    "semokName": "자립생활",
    "legacyBudgetAmtWon": 95000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "키트 용역업체 잔금",
        "calcBasis": "95000000",
        "calcAmt": 95000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 44482000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지정기금 전담인력 인건비",
        "calcBasis": "44481417",
        "calcAmt": 44482,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "긴급 위기사례 지원사업",
    "sehangName": "사업비",
    "mokName": "긴급 위기사례 지원사업",
    "semokName": "생계비지원",
    "legacyBudgetAmtWon": 410869000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "맞춤형 지원사업 사업비",
        "calcBasis": "",
        "calcAmt": 410869,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "7차 사업비",
        "calcBasis": "340000000*1",
        "calcAmt": 340000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "7차 심사비",
        "calcBasis": "2400000*1",
        "calcAmt": 2400,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "포상 (연수, 전자기기)",
        "calcBasis": "12000000*1",
        "calcAmt": 12000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "공모전",
        "calcBasis": "13269000*1",
        "calcAmt": 13269,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "희망영웅",
        "calcBasis": "42400000*1",
        "calcAmt": 42400,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "심사회의비",
        "calcBasis": "800000*1",
        "calcAmt": 800,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "위기가정아동 돌봄 및 지원 기획사업비",
    "sehangName": "사업비",
    "mokName": "위기가정아동 돌봄 및 지원 기획사업비",
    "semokName": "위기가정아동 돌봄 및 지원 기획사업",
    "legacyBudgetAmtWon": 252000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "모니터링 및 기타 사업비 251,198원",
        "calcBasis": "251198",
        "calcAmt": 252,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "위기가정아동 돌봄 및 지원 기획사업비",
    "sehangName": "사업비",
    "mokName": "위기가정아동 돌봄 및 지원 기획사업비",
    "semokName": "위기가정아동 돌봄 및 지원 기획사업",
    "legacyBudgetAmtWon": 1700000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지정기금 사업비",
        "calcBasis": "",
        "calcAmt": 1700,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1",
        "calcBasis": "700000*1",
        "calcAmt": 700,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2",
        "calcBasis": "500000*2",
        "calcAmt": 1000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "아동보호전문기관 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "아동보호전문기관 전출금(후원금)",
    "semokName": "아동보호전문기관 전출금(후원금)기타",
    "legacyBudgetAmtWon": 200000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지정기금 사업비",
        "calcBasis": "200*1000000",
        "calcAmt": 200000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 24000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지정기금 전담인력 인건비",
        "calcBasis": "4000000*6",
        "calcAmt": 24000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "긴급 위기사례 지원사업",
    "sehangName": "사업비",
    "mokName": "긴급 위기사례 지원사업",
    "semokName": "생계비지원",
    "legacyBudgetAmtWon": 90000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "외부기관 10개 사례 *9,000천원",
        "calcBasis": "9000000*10",
        "calcAmt": 90000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "위기가정아동 돌봄 및 지원 기획사업비",
    "sehangName": "사업비",
    "mokName": "위기가정아동 돌봄 및 지원 기획사업비",
    "semokName": "위기가정아동 돌봄 및 지원 기획사업",
    "legacyBudgetAmtWon": 1000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지정기금사업 모니터링 및 회의비 등 사업 진행비",
        "calcBasis": "1000000*1",
        "calcAmt": 1000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "아동보호전문기관 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "아동보호전문기관 전출금(후원금)",
    "semokName": "아동보호전문기관 전출금(후원금)기타",
    "legacyBudgetAmtWon": 135000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지정기금 사업비",
        "calcBasis": "9000000*15",
        "calcAmt": 135000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "사회적약자통합지원센터 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "사회적약자통합지원센터 전출금(후원금)",
    "semokName": "사회적약자통합지원센터 전출금(후원금)기타",
    "legacyBudgetAmtWon": 500000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "범죄피해아동 및 가정지원사업(신규기획)",
        "calcBasis": "500000000",
        "calcAmt": 500000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 852000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "일반직 인건비",
        "calcBasis": "851733",
        "calcAmt": 852,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "아동보호전문기관 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "아동보호전문기관 전출금(후원금)",
    "semokName": "아동보호전문기관 전출금(후원금)기타",
    "legacyBudgetAmtWon": 10000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지정기금 사업비",
        "calcBasis": "10000000*1",
        "calcAmt": 10000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 7593000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지정기금 전담인력 인건비",
        "calcBasis": "7592930",
        "calcAmt": 7593,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "자립역량 지원",
    "sehangName": "사업비",
    "mokName": "자립역량 지원",
    "semokName": "자립준비",
    "legacyBudgetAmtWon": 60000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지정기금 사업비",
        "calcBasis": "",
        "calcAmt": 60000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "전문업체 용역비용",
        "calcBasis": "50000000*1",
        "calcAmt": 50000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "자립준비청년 멘토 지원금",
        "calcBasis": "10000000*1",
        "calcAmt": 10000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 35000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "우리찬스 자립키트 전담인력 인건비",
        "calcBasis": "35000000",
        "calcAmt": 35000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "자립역량 지원",
    "sehangName": "사업비",
    "mokName": "자립역량 지원",
    "semokName": "자립생활",
    "legacyBudgetAmtWon": 455000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "우리찬스 자립키트 키트제작비용",
        "calcBasis": "650000*700",
        "calcAmt": 455000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "자립 지원 기획사업비",
    "sehangName": "사업비",
    "mokName": "자립 지원 기획사업비",
    "semokName": "자립 지원 기획사업",
    "legacyBudgetAmtWon": 10000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "우리찬스 자립키트 관리운영비",
        "calcBasis": "10000000",
        "calcAmt": 10000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "역량강화사업",
    "sehangName": "사업비",
    "mokName": "역량강화사업",
    "semokName": "교육지원사업",
    "legacyBudgetAmtWon": 48000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지정기금 사업비",
        "calcBasis": "480000*100",
        "calcAmt": 48000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "미래성장 지원 기획사업비",
    "sehangName": "사업비",
    "mokName": "미래성장 지원 기획사업비",
    "semokName": "미래성장 지원 기획사업",
    "legacyBudgetAmtWon": 1000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지정기금 사업비",
        "calcBasis": "1000000",
        "calcAmt": 1000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "아동보호전문기관 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "아동보호전문기관 전출금(후원금)",
    "semokName": "아동보호전문기관 전출금(후원금)기타",
    "legacyBudgetAmtWon": 9350000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지정기금 사업비",
        "calcBasis": "9350000*1",
        "calcAmt": 9350,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "지역아동센터 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "지역아동센터 전출금(후원금)",
    "semokName": "지역아동센터 전출금(후원금)기타",
    "legacyBudgetAmtWon": 2000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지정기금 사업비",
        "calcBasis": "",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "전년도 이월금",
        "calcBasis": "2000000",
        "calcAmt": 2000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "지역아동센터 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "지역아동센터 전출금(후원금)",
    "semokName": "지역아동센터 전출금(후원금)기타",
    "legacyBudgetAmtWon": 10000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지정기금 사업비",
        "calcBasis": "10000000",
        "calcAmt": 10000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 135538000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지정기금 전담인력 인건비",
        "calcBasis": "135537720",
        "calcAmt": 135538,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "긴급 위기사례 지원사업",
    "sehangName": "사업비",
    "mokName": "긴급 위기사례 지원사업",
    "semokName": "생계비지원",
    "legacyBudgetAmtWon": 5514463000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지정기금 사업비",
        "calcBasis": "",
        "calcAmt": 5514463,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사례지원비 1",
        "calcBasis": "3000000*560",
        "calcAmt": 1680000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사레지원비 2",
        "calcBasis": "1000000*3540",
        "calcAmt": 3540000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "기타 사업비 (공모전, 심사비 등)",
        "calcBasis": "294462280*1",
        "calcAmt": 294463,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "위기가정아동 돌봄 및 지원 기획사업비",
    "sehangName": "사업비",
    "mokName": "위기가정아동 돌봄 및 지원 기획사업비",
    "semokName": "위기가정아동 돌봄 및 지원 기획사업",
    "legacyBudgetAmtWon": 150000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "직/간접 운영비",
        "calcBasis": "150000000*1",
        "calcAmt": 150000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "아동보호전문기관 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "아동보호전문기관 전출금(후원금)",
    "semokName": "아동보호전문기관 전출금(후원금)기타",
    "legacyBudgetAmtWon": 1200000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지정기금 사레지원비",
        "calcBasis": "3000000*400",
        "calcAmt": 1200000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1070",
    "deptName": "임팩트사업1팀",
    "bizName": "건강증진지원사업",
    "sehangName": "사업비",
    "mokName": "건강증진지원사업",
    "semokName": "건강관리지원",
    "legacyBudgetAmtWon": 300000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지정기금 사업비",
        "calcBasis": "300000000*1",
        "calcAmt": 300000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1080",
    "deptName": "아동행복동행팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 60099120,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "황00 차장 L급 14호봉->15호봉(10월 승호)",
        "calcBasis": "(4,939,130원*7개월)+(5,177,150원*2개월)+(5,056,970원*3개월)",
        "calcAmt": 60100,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1080",
    "deptName": "아동행복동행팀",
    "bizName": "기획사업비",
    "sehangName": "사업비",
    "mokName": "기획사업비",
    "semokName": "사업장방문",
    "legacyBudgetAmtWon": 900000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "교통비",
        "calcBasis": "50,000원*3명*2회*2개소",
        "calcAmt": 600,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "회의 진행비",
        "calcBasis": "15,000원*10명*2개소",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "교통비",
        "calcBasis": "50,000원*3명*2회*2개소",
        "calcAmt": 600,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "회의 진행비",
        "calcBasis": "15,000원*10명*2개소",
        "calcAmt": 300,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1080",
    "deptName": "아동행복동행팀",
    "bizName": "기획사업비",
    "sehangName": "사업비",
    "mokName": "기획사업비",
    "semokName": "교육및워크샵",
    "legacyBudgetAmtWon": 3330000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장 역량강화 지원(38개소)",
        "calcBasis": "",
        "calcAmt": 1710,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "교육 진행비",
        "calcBasis": "5,000원*38개소*3명*3회",
        "calcAmt": 1710,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "권역본부장 회의",
        "calcBasis": "",
        "calcAmt": 1620,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "회의 진행비",
        "calcBasis": "15,000원*18명*6회",
        "calcAmt": 1620,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1080",
    "deptName": "아동행복동행팀",
    "bizName": "기획사업비",
    "sehangName": "사업비",
    "mokName": "기획사업비",
    "semokName": "기타지부지원사업비",
    "legacyBudgetAmtWon": 6500000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "신규위탁 지원",
        "calcBasis": "1개소*2,000,000원",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "종료사업장 후속업무 지원 비용",
        "calcBasis": "",
        "calcAmt": 4500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "9월 종료사업장(남원,전북,청주)",
        "calcBasis": "3개소*500,000원",
        "calcAmt": 1500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "12월 종료사업장(전북서부,목포,대전)",
        "calcBasis": "3개소*1,000,000원",
        "calcAmt": 3000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1080",
    "deptName": "아동행복동행팀",
    "bizName": "부서운영비",
    "sehangName": "사업비",
    "mokName": "부서운영비",
    "semokName": "부서운영비",
    "legacyBudgetAmtWon": 2000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "부서운영비",
        "calcBasis": "",
        "calcAmt": 1800,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사업운영팀 부서운영비(5명)",
        "calcBasis": "30,000원*5명*12개월",
        "calcAmt": 1800,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "부서연수 및 워크샵비",
        "calcBasis": "",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사업운영팀 부서연수 및 워크샵비(5명)",
        "calcBasis": "40,000원*5명*1회",
        "calcAmt": 200,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1080",
    "deptName": "아동행복동행팀",
    "bizName": "부서운영비",
    "sehangName": "사업비",
    "mokName": "부서운영비",
    "semokName": "업무추진비",
    "legacyBudgetAmtWon": 1200000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "아동권리사업부 부장 업무추진비(1명)",
        "calcBasis": "100,000원*1명*12개월",
        "calcAmt": 1200,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1080",
    "deptName": "아동행복동행팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 58024760,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "이00 과장 4급 12호봉->13호봉(4월 승호)",
        "calcBasis": "(4,715,400원*2개월)+(4,953,430원*1개월)+(4,822,500원*8개월)+(5,060,530원*1개월)",
        "calcAmt": 58025,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1080",
    "deptName": "아동행복동행팀",
    "bizName": "지역아동센터 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "지역아동센터 전출금(후원금)",
    "semokName": "지역아동센터 전출금(후원금)",
    "legacyBudgetAmtWon": 301997000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지역아동센터(14개소) 2026년 연예산",
        "calcBasis": "301997000",
        "calcAmt": 301997,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1080",
    "deptName": "아동행복동행팀",
    "bizName": "역량강화사업",
    "sehangName": "사업비",
    "mokName": "역량강화사업",
    "semokName": "교육지원사업",
    "legacyBudgetAmtWon": 9000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "시설보호아동 특수욕구 맞춤형지원 사업비",
        "calcBasis": "",
        "calcAmt": 9000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "특수욕구 맞춤형지원사업",
        "calcBasis": "3,000,000원*3개소*1회",
        "calcAmt": 9000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1080",
    "deptName": "아동행복동행팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 77347790,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "김00 팀장 L급 18호봉->19호봉(10월 승호)",
        "calcBasis": "(6,379,200원*7개월)+(6,617,230원*2개월)+(6,486,310원*3개월)",
        "calcAmt": 77348,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1080",
    "deptName": "아동행복동행팀",
    "bizName": "기획사업비",
    "sehangName": "사업비",
    "mokName": "기획사업비",
    "semokName": "교육및워크샵",
    "legacyBudgetAmtWon": 1125000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장 역량강화 지원(25개소)",
        "calcBasis": "",
        "calcAmt": 1125,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "교육 진행비",
        "calcBasis": "5,000원*25개소*3명*3회",
        "calcAmt": 1125,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1080",
    "deptName": "아동행복동행팀",
    "bizName": "기획사업비",
    "sehangName": "사업비",
    "mokName": "기획사업비",
    "semokName": "기타지부지원사업비",
    "legacyBudgetAmtWon": 4000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "신규위탁 지원",
        "calcBasis": "2개소*2,000,000원",
        "calcAmt": 4000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1080",
    "deptName": "아동행복동행팀",
    "bizName": "심리치유센터 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "심리치유센터 전출금(후원금)",
    "semokName": "심리치유센터 전출금(후원금)",
    "legacyBudgetAmtWon": 258547000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "심리치유센터(1개소) 2026년 연예산",
        "calcBasis": "258547000",
        "calcAmt": 258547,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1080",
    "deptName": "아동행복동행팀",
    "bizName": "건강증진지원사업",
    "sehangName": "사업비",
    "mokName": "건강증진지원사업",
    "semokName": "건강관리지원",
    "legacyBudgetAmtWon": 10000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "여아지원사업 긴급사례지원",
        "calcBasis": "",
        "calcAmt": 10000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "긴급사례지원 생계비, 의료비, 주거비",
        "calcBasis": "3,000,000원*약2명*2회",
        "calcAmt": 10000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1080",
    "deptName": "아동행복동행팀",
    "bizName": "건강증진지원사업",
    "sehangName": "사업비",
    "mokName": "건강증진지원사업",
    "semokName": "건강관리지원",
    "legacyBudgetAmtWon": 300000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "여아지원사업 위생용품 KIT 및 건강권 교육지원",
        "calcBasis": "",
        "calcAmt": 300000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "위생용품 KIT 및 건강권 교육자료 제작비(상/하반기 2회)",
        "calcBasis": "75,000,000원 * 2회",
        "calcAmt": 150000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "위생용품 KIT 및 건강권 교육자료 제작비(상/하반기 2회)",
        "calcBasis": "75,000,000원 * 2회",
        "calcAmt": 150000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1080",
    "deptName": "아동행복동행팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 46874500,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "이00 대리 5급 6호봉->7호봉(4월 승호)",
        "calcBasis": "(3,794,230원*2개월)+(4,032,250원*1개월)+(3,890,640원*8개월)+(4,128,670원*1개월)",
        "calcAmt": 46875,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "김00 대리 5급 6호봉->7호봉(4월 승호)",
        "calcBasis": "(3,794,230원*2개월)+(4,032,250원*1개월)+(3,890,640원*8개월)+(4,128,670원*1개월)",
        "calcAmt": 46875,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1080",
    "deptName": "아동행복동행팀",
    "bizName": "기획사업비",
    "sehangName": "사업비",
    "mokName": "기획사업비",
    "semokName": "사업연구",
    "legacyBudgetAmtWon": 8500000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "범죄피해아동및가정지원 성과공유회",
        "calcBasis": "",
        "calcAmt": 8500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "성과공유회 진행비",
        "calcBasis": "",
        "calcAmt": 8500,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "전시회관 대관비",
        "calcBasis": "2,000,000원*1곳",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "성과자료집 제작",
        "calcBasis": "10,000원*150부",
        "calcAmt": 1500,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "홍보자료 제작",
        "calcBasis": "1,000,000원*1회",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "성과발표 사례비(유관기관, 전문가)",
        "calcBasis": "150,000원*3명",
        "calcAmt": 450,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "부스운영지원비",
        "calcBasis": "300,000원*5팀",
        "calcAmt": 1500,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "배포 기념품 제작비",
        "calcBasis": "5,000원*150명",
        "calcAmt": 750,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "케이터링 다과비",
        "calcBasis": "5,000원*150명",
        "calcAmt": 750,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "물품구입(현수막, 포토존, 상품 등)",
        "calcBasis": "550,000원*1회",
        "calcAmt": 550,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1080",
    "deptName": "아동행복동행팀",
    "bizName": "사회적약자통합지원센터 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "사회적약자통합지원센터 전출금(후원금)",
    "semokName": "사회적약자통합지원센터 전출금(후원금)",
    "legacyBudgetAmtWon": 333152000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사회적약자통합지원센터(1개소) 2026년 연예산",
        "calcBasis": "333152000",
        "calcAmt": 333152,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1080",
    "deptName": "아동행복동행팀",
    "bizName": "지역아동센터 시도지원단 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "지역아동센터 시도지원단 전출금(후원금)",
    "semokName": "지역아동센터 시도지원단 전출금(후원금)",
    "legacyBudgetAmtWon": 171034000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "지역아동센터 시도지원단(1개소) 2026년 연예산",
        "calcBasis": "171034000",
        "calcAmt": 171034,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1090",
    "deptName": "아동권리옹호팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 294628340,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "1. 직원관리비",
        "calcBasis": "",
        "calcAmt": 294629,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) 김규하 (L급 19호봉)",
        "calcBasis": "78237840",
        "calcAmt": 78238,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2) 신미희 (4급 13호봉 -> 14호봉 / 4월)",
        "calcBasis": "60804770",
        "calcAmt": 60805,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "3) 안은애 (4급 14호봉 -> 15호봉 / 10월)",
        "calcBasis": "60758310",
        "calcAmt": 60759,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "4) 박준이 (5급 6호봉 -> 7호봉 / 4월)",
        "calcBasis": "46916960",
        "calcAmt": 46917,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "5) 정은영 (5급 5호봉 -> 6호봉 / 4월)",
        "calcBasis": "47910460",
        "calcAmt": 47911,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1090",
    "deptName": "아동권리옹호팀",
    "bizName": "아동권리옹호활동",
    "sehangName": "사업비",
    "mokName": "아동권리옹호활동",
    "semokName": "홍보사업",
    "legacyBudgetAmtWon": 114540000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[언론 홍보]",
        "calcBasis": "",
        "calcAmt": 55000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 기획기사 언론사 연간 계약 진행비",
        "calcBasis": "55,000,000원*1회",
        "calcAmt": 55000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[언론보도]",
        "calcBasis": "",
        "calcAmt": 1570,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 언론 취재 지원",
        "calcBasis": "",
        "calcAmt": 1570,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 언론사 취재 진행비",
        "calcBasis": "",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 식대비",
        "calcBasis": "10,000원*5명*2회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 다과비",
        "calcBasis": "5,000원*10명*2회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 교통비",
        "calcBasis": "50,000원*2회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 물품 구입비",
        "calcBasis": "50,000원*2회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2) 주요일간지 구독비",
        "calcBasis": "",
        "calcAmt": 900,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 3개 언론사 연간 구독비",
        "calcBasis": "300,000원*3개",
        "calcAmt": 900,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "3) 상시 언론 홍보 운영",
        "calcBasis": "",
        "calcAmt": 270,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 신문/잡지 구입비 (매월)",
        "calcBasis": "10,000원*12개월",
        "calcAmt": 120,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 문자 서비스 이용료",
        "calcBasis": "150,000원*1회",
        "calcAmt": 150,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[온라인 홍보]",
        "calcBasis": "",
        "calcAmt": 28000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 온라인 콘텐츠 기획 및 제작비",
        "calcBasis": "",
        "calcAmt": 28000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) SNS 카드뉴스 제작비",
        "calcBasis": "300,000원*24회",
        "calcAmt": 7200,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2) 홈페이지 현장이야기 콘텐츠 제작비",
        "calcBasis": "20,000원*20회",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "3) SNS 영상 콘텐츠 제작비",
        "calcBasis": "6,000,000원*2회",
        "calcAmt": 12000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "4) 인플루언서 온라인 콘텐츠 제작비",
        "calcBasis": "4,000,000원*1회",
        "calcAmt": 4000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "4) 블로그 콘텐츠 제작비",
        "calcBasis": "100,000*24회",
        "calcAmt": 2400,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "5) 콘텐츠 취재 진행비",
        "calcBasis": "",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 교통비",
        "calcBasis": "100,000원*2명*4회",
        "calcAmt": 800,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 인터뷰이 리워드 구입비",
        "calcBasis": "30,000원*2명*4회",
        "calcAmt": 240,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 취재 진행 시 식대비",
        "calcBasis": "10,000원*4명*4회",
        "calcAmt": 160,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 취재 물품 구입비",
        "calcBasis": "100,000원*4회",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 취재 진행시 사진 작가 섭외비",
        "calcBasis": "200,000원*2회",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[온라인 광고]",
        "calcBasis": "",
        "calcAmt": 20400,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "메타광고 진행비",
        "calcBasis": "850,000*24",
        "calcAmt": 20400,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[브랜드 관리]",
        "calcBasis": "",
        "calcAmt": 9570,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "데일리 모니터링 진행비 (스크랩마스터 구독비)",
        "calcBasis": "9,570,000원*1회",
        "calcAmt": 9570,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1090",
    "deptName": "아동권리옹호팀",
    "bizName": "아동권리옹호활동",
    "sehangName": "사업비",
    "mokName": "아동권리옹호활동",
    "semokName": "홍보 및 캠페인",
    "legacyBudgetAmtWon": 96650000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[아젠다 기획 조정]",
        "calcBasis": "",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "아동행복ING위원회 운영비",
        "calcBasis": "5,000원*10명*10회",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[대국민아동권리옹호 캠페인]",
        "calcBasis": "",
        "calcAmt": 36700,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 캠페인 1 진행비 (아동 건강권)",
        "calcBasis": "",
        "calcAmt": 11800,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 온라인 캠페인 진행비",
        "calcBasis": "",
        "calcAmt": 5000,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 영상/협업 진행비",
        "calcBasis": "5,000,000원*1회",
        "calcAmt": 5000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2) 오프라인 캠페인 진행비",
        "calcBasis": "",
        "calcAmt": 6800,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 물품 제작비",
        "calcBasis": "150,000*40개지부",
        "calcAmt": 6000,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 물품 발송비",
        "calcBasis": "20,000원*40개 지부",
        "calcAmt": 800,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2. 캠페인 2 진행비 (아동학대예방)",
        "calcBasis": "",
        "calcAmt": 11800,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 온라인 캠페인 진행비",
        "calcBasis": "",
        "calcAmt": 5000,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 영상/협업 진행비",
        "calcBasis": "5,000,000원*1회",
        "calcAmt": 5000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2) 오프라인 캠페인 진행비",
        "calcBasis": "",
        "calcAmt": 6800,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 물품 제작비",
        "calcBasis": "150,000원*40개 지부",
        "calcAmt": 6000,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 물품 발송비",
        "calcBasis": "20,000원*40개 지부",
        "calcAmt": 800,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "3. 캠페인 3 진행비 (디지털/기후)",
        "calcBasis": "",
        "calcAmt": 8400,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 온라인 캠페인 진행비",
        "calcBasis": "",
        "calcAmt": 5000,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 아동참여/영상 진행비",
        "calcBasis": "5,000,000원*1회",
        "calcAmt": 5000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2) 오프라인 캠페인 진행비",
        "calcBasis": "",
        "calcAmt": 3400,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 물품 제작비",
        "calcBasis": "150,000원*20개 지부",
        "calcAmt": 3000,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 물품 발송비",
        "calcBasis": "20,000원*20개 지부",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "4. 캠페인 4 진행비 (자립)",
        "calcBasis": "",
        "calcAmt": 4700,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 온라인 캠페인 진행비",
        "calcBasis": "",
        "calcAmt": 3000,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 협업/이벤트 진행비",
        "calcBasis": "3,000,000원*1회",
        "calcAmt": 3000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2) 오프라인 캠페인 진행비",
        "calcBasis": "",
        "calcAmt": 1700,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 물품 제작비",
        "calcBasis": "150,000원*10개 지부",
        "calcAmt": 1500,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 물품 발송비",
        "calcBasis": "20,000원*10개 지부",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[이슈 아젠다 캠페인]",
        "calcBasis": "",
        "calcAmt": 12500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 이슈아젠다 캠페인 1 진행비",
        "calcBasis": "",
        "calcAmt": 6000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 웹페이지/플랫폼 기획 및 제작비",
        "calcBasis": "5,000,000원*1회",
        "calcAmt": 5000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2) 이벤트 리워드 구입 및 발송비",
        "calcBasis": "20,000원*50명*1회",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2. 이슈아젠다 캠페인 2 진행비",
        "calcBasis": "",
        "calcAmt": 6500,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 영상 제작비",
        "calcBasis": "5,000,000원*1회",
        "calcAmt": 5000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2) 이벤트 리워드 구입 및 발송비",
        "calcBasis": "30,000원*50명*1회",
        "calcAmt": 1500,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[아동권리옹호 컨퍼런스]",
        "calcBasis": "",
        "calcAmt": 19110,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 컨퍼런스 1 진행비 (정책)",
        "calcBasis": "",
        "calcAmt": 6390,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 물품 제작비",
        "calcBasis": "",
        "calcAmt": 2500,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 물품 제작비(현수막, 포스터, 자료집, 명패 등 디자인/출력 일체)",
        "calcBasis": "2,500,000원*1회",
        "calcAmt": 2500,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2) 유튜브 생중계 진행비",
        "calcBasis": "",
        "calcAmt": 1800,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 유튜브 생중계 진행비",
        "calcBasis": "1,500,000원*1회",
        "calcAmt": 1500,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 문자통역 진행비",
        "calcBasis": "300,000원*1회",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "3) 발표자 및 토론자 사례비",
        "calcBasis": "",
        "calcAmt": 1500,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 기조강연/주제발표/좌장 사례비",
        "calcBasis": "250,000원*2명",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 전문가 토론 사례비",
        "calcBasis": "200,000원*5명",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "4) 행사 진행비",
        "calcBasis": "",
        "calcAmt": 590,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 식대비",
        "calcBasis": "10,000원*30명",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 다과비",
        "calcBasis": "5,000원*30명",
        "calcAmt": 150,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 물품 구입비",
        "calcBasis": "100,000원*1회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 현장 답사 및 미팅 참석 시 교통비",
        "calcBasis": "20,000원*2회",
        "calcAmt": 40,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2. 컨퍼런스 2 진행비 (아동참여)",
        "calcBasis": "",
        "calcAmt": 4140,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 물품 제작비",
        "calcBasis": "",
        "calcAmt": 2500,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 물품 제작비(현수막, 포스터, 자료집, 명패 등 디자인/출력 일체)",
        "calcBasis": "2,500,000원*1회",
        "calcAmt": 2500,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2) 발표자 및 토론자 사례비",
        "calcBasis": "",
        "calcAmt": 1200,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 기조강연/주제발표/좌장 사례비",
        "calcBasis": "250,000원*2명",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 전문가 토론 사례비",
        "calcBasis": "200,000원*3명",
        "calcAmt": 600,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 아동 토론 사례비",
        "calcBasis": "100,000원*1명",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "3) 행사 진행비",
        "calcBasis": "",
        "calcAmt": 440,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 식대비",
        "calcBasis": "10,000원*20명",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 다과비",
        "calcBasis": "5,000원*20명",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 물품 구입비",
        "calcBasis": "100,000원*1회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 현장 답사 및 미팅 교통비",
        "calcBasis": "20,000원*2회",
        "calcAmt": 40,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "3. 컨퍼런스 3 진행비 (아동참여)",
        "calcBasis": "",
        "calcAmt": 4140,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 물품 제작비",
        "calcBasis": "",
        "calcAmt": 2500,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 물품 제작비(현수막, 포스터, 자료집, 명패 등 디자인/출력 일체)",
        "calcBasis": "2,500,000원*1회",
        "calcAmt": 2500,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2) 발표자 및 토론자 사례비",
        "calcBasis": "",
        "calcAmt": 1200,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 기조강연/주제발표/좌장 사례비",
        "calcBasis": "250,000원*2명",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 전문가 토론 사례비",
        "calcBasis": "200,000원*3명",
        "calcAmt": 600,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 아동 토론 사례비",
        "calcBasis": "100,000원*1명",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "3) 행사 진행비",
        "calcBasis": "",
        "calcAmt": 440,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 식대비",
        "calcBasis": "10,000원*20명",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 다과비",
        "calcBasis": "5,000원*20명",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 물품 구입비",
        "calcBasis": "100,000원*1회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 현장 답사 및 미팅 교통비",
        "calcBasis": "20,000원*2회",
        "calcAmt": 40,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "4. 컨퍼런스 4 진행비 (정책)",
        "calcBasis": "",
        "calcAmt": 4440,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 물품 제작비",
        "calcBasis": "",
        "calcAmt": 2500,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 물품 제작비(현수막, 포스터, 자료집, 명패 등 디자인/출력 일체)",
        "calcBasis": "2,500,000원*1회",
        "calcAmt": 2500,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2) 발표자 및 토론자 사례비",
        "calcBasis": "",
        "calcAmt": 1500,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 기조강연/주제발표/좌장 사례비",
        "calcBasis": "250,000원*2명",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 전문가 토론 사례비",
        "calcBasis": "200,000원*5명",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "3) 행사 진행비",
        "calcBasis": "",
        "calcAmt": 440,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 식대비",
        "calcBasis": "10,000원*20명",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 다과비",
        "calcBasis": "5,000원*20명",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 물품 구입비",
        "calcBasis": "100,000원*1회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 현장 답사 및 미팅 교통비",
        "calcBasis": "20,000원*2회",
        "calcAmt": 40,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[정책제언 활동]",
        "calcBasis": "",
        "calcAmt": 11140,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 정책 제언 활동 진행비",
        "calcBasis": "",
        "calcAmt": 6140,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 물품 제작비",
        "calcBasis": "",
        "calcAmt": 2400,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 물품 제작비(판넬/피켓 등 디자인/출력 일체)",
        "calcBasis": "600,000원*4회",
        "calcAmt": 2400,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2) 참석자 사례비",
        "calcBasis": "",
        "calcAmt": 800,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 참석자(발언자) 사례비",
        "calcBasis": "100,000원*2명*4회",
        "calcAmt": 800,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "3) 활동 진행비",
        "calcBasis": "",
        "calcAmt": 2940,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 아동 참석 교통비 (보호자 포함, 왕복)",
        "calcBasis": "50,000원*4명*8회",
        "calcAmt": 1600,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 식대비",
        "calcBasis": "10,000원*15명*4회",
        "calcAmt": 600,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 다과비",
        "calcBasis": "5,000원*15명*4회",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 물품 구입비",
        "calcBasis": "100,000원*4회",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 현장 답사 및 미팅 교통비",
        "calcBasis": "20,000원*2회",
        "calcAmt": 40,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2. UN아동권리협약 대한민국 제7차 심의 (아동보고서, 민간 보고서)",
        "calcBasis": "",
        "calcAmt": 5000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 물품 제작비",
        "calcBasis": "",
        "calcAmt": 2525,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 물품 제작비(판넬/피켓 등 디자인/출력 일체)",
        "calcBasis": "1,000,000원*2회",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 자료집 제작비",
        "calcBasis": "525,000원*1회",
        "calcAmt": 525,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2) 활동 진행비",
        "calcBasis": "",
        "calcAmt": 2475,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 문서 번역 및 자문비",
        "calcBasis": "1,000,000원*2회",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 네트워크 회의 진행 시 교통비",
        "calcBasis": "20,000*5회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 네트워크 회의 진행시 식대비",
        "calcBasis": "10,000원*5명*5회",
        "calcAmt": 250,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 네트워크 회의 진행시 다과비",
        "calcBasis": "5,000원*5명*5회",
        "calcAmt": 125,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[아동권리모니터링단]",
        "calcBasis": "",
        "calcAmt": 3800,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 아동권리모니터링단 권역대표단 운영비",
        "calcBasis": "",
        "calcAmt": 3800,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 발대식 진행비",
        "calcBasis": "",
        "calcAmt": 1400,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 발대식 리워드 구입비",
        "calcBasis": "50,000원*12명",
        "calcAmt": 600,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 발대식 진행물품 구입비",
        "calcBasis": "200,000원*1회",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 발대식 활동비",
        "calcBasis": "600,000원*1회",
        "calcAmt": 600,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2) 오프라인 활동(간담회 등) 진행비",
        "calcBasis": "",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 오프라인 활동비",
        "calcBasis": "500,000*2회",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "3) 해단식 진행비",
        "calcBasis": "",
        "calcAmt": 1400,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 해단식 리워드 구입비",
        "calcBasis": "50,000원*12명",
        "calcAmt": 600,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 해단식 진행물품 구입비",
        "calcBasis": "200,000원*1회",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 해단식 활동비",
        "calcBasis": "600,000원*1회",
        "calcAmt": 600,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[아동권리옹호 서포터즈]",
        "calcBasis": "",
        "calcAmt": 5000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 아동권리옹호 본부주도 활동",
        "calcBasis": "",
        "calcAmt": 5000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 전국 활동 기획 및 진행비",
        "calcBasis": "2,000,000원*1회",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2) 전국 활동 물품/협업 진행비",
        "calcBasis": "2,000,000원*1회",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "3) 참여자 리워드 제작 및 발송비",
        "calcBasis": "50,000원*20명",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[자문위원 네트워크 관리]",
        "calcBasis": "",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) 자문위원 네트워크 관리비",
        "calcBasis": "",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 자문료",
        "calcBasis": "200,000원*5명*1회",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 회의 진행비",
        "calcBasis": "200,000원*5회",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[네트워크 협력 및 협약]",
        "calcBasis": "",
        "calcAmt": 2500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 네트워크 협력",
        "calcBasis": "",
        "calcAmt": 1500,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 공동주최 행사 진행비",
        "calcBasis": "500,000원*3회",
        "calcAmt": 1500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2. 네트워크 협약 (신규 네트워크)",
        "calcBasis": "",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 협약식 진행비",
        "calcBasis": "1000,000원*1회",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[유관기관 및 홍보 네트워크 관리]",
        "calcBasis": "",
        "calcAmt": 3400,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 유관기관 및 정부기관 네트워크 미팅",
        "calcBasis": "100,000원*12회",
        "calcAmt": 1200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2. 홍보 네트워크 미팅",
        "calcBasis": "100,000원*12회",
        "calcAmt": 1200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "3. 연간 네트워크 관리 (달력 및 사업소개서 발송비)",
        "calcBasis": "10,000원*100개",
        "calcAmt": 1000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1090",
    "deptName": "아동권리옹호팀",
    "bizName": "부서운영비",
    "sehangName": "사업비",
    "mokName": "부서운영비",
    "semokName": "부서운영비",
    "legacyBudgetAmtWon": 2000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "1. 부서운영비",
        "calcBasis": "",
        "calcAmt": 1800,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) 부서운영비",
        "calcBasis": "30,000원*5명*12개월",
        "calcAmt": 1800,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "2. 워크샵 진행비",
        "calcBasis": "",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) 워크샵 진행비",
        "calcBasis": "40,000원*5명*1회",
        "calcAmt": 200,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1100",
    "deptName": "아동보호사업팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 312389130,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "인건비(일반직)",
        "calcBasis": "",
        "calcAmt": 312390,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "일반직 급여(부장1명, 팀장1명, 차장1명, 과장3명)",
        "calcBasis": "",
        "calcAmt": 312390,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "이선영팀장(L급 21~22호봉 / 4월 승호)",
        "calcBasis": "80,289,920원",
        "calcAmt": 80290,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "안희선차장(L급 14~15호봉 / 4월 승호)",
        "calcBasis": "63,662,350원",
        "calcAmt": 63663,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "조지향과장(4급 14~15호봉 / 4월 승호)",
        "calcBasis": "58,531,760원",
        "calcAmt": 58532,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "김선영과장(4급 10~11호봉 / 4월 승호)",
        "calcBasis": "56,971,660원",
        "calcAmt": 56972,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "정성선과장(4급 8~9호봉 / 4월 승호)",
        "calcBasis": "52,933,440원",
        "calcAmt": 52934,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1100",
    "deptName": "아동보호사업팀",
    "bizName": "대외협력사업",
    "sehangName": "사업비",
    "mokName": "대외협력사업",
    "semokName": "대외협력사업비",
    "legacyBudgetAmtWon": 330000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "대외협력사업",
        "calcBasis": "",
        "calcAmt": 330,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) 외부네트워크관리",
        "calcBasis": "",
        "calcAmt": 220,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "교통비",
        "calcBasis": "20,000원*2회",
        "calcAmt": 40,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "식대 및 다과비",
        "calcBasis": "15,000원*6명*2회",
        "calcAmt": 180,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2) 제도개선 촉구활동 및 회의",
        "calcBasis": "",
        "calcAmt": 110,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "식대 및 다과비",
        "calcBasis": "15,000원*6명*1회",
        "calcAmt": 90,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "기타진행비",
        "calcBasis": "20,000원*1회",
        "calcAmt": 20,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1100",
    "deptName": "아동보호사업팀",
    "bizName": "기획사업비",
    "sehangName": "사업비",
    "mokName": "기획사업비",
    "semokName": "사업평가",
    "legacyBudgetAmtWon": 5308000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업평가",
        "calcBasis": "",
        "calcAmt": 5308,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) 사업장 정성평가(아보전)",
        "calcBasis": "",
        "calcAmt": 5308,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "식사 및 다과비(지부평가위원)",
        "calcBasis": "15,000원*72명*1회",
        "calcAmt": 1080,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "식비",
        "calcBasis": "12,000원*6명*7일",
        "calcAmt": 504,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "일비",
        "calcBasis": "12,000원*6명*7일",
        "calcAmt": 504,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "교통비(진행인력)",
        "calcBasis": "60,000원*6명*7회",
        "calcAmt": 2520,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "기타운영비(사전준비 및 숙박)",
        "calcBasis": "200,000원*2회",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "기타행정비(서류출력 및 제본 등)",
        "calcBasis": "150,000원*2회",
        "calcAmt": 300,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1100",
    "deptName": "아동보호사업팀",
    "bizName": "기획사업비",
    "sehangName": "사업비",
    "mokName": "기획사업비",
    "semokName": "사업장방문",
    "legacyBudgetAmtWon": 1080000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장 방문",
        "calcBasis": "",
        "calcAmt": 1080,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) 아동보호전문기관 사업장 방문",
        "calcBasis": "",
        "calcAmt": 1080,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "교통비",
        "calcBasis": "50,000원*3명*4회",
        "calcAmt": 600,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "식대 및 다과비(진행인력)",
        "calcBasis": "15,000원*3명*4회",
        "calcAmt": 180,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "식대 및 다과비(사업장방문인력)",
        "calcBasis": "15,000원*5명*4회",
        "calcAmt": 300,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1100",
    "deptName": "아동보호사업팀",
    "bizName": "기획사업비",
    "sehangName": "사업비",
    "mokName": "기획사업비",
    "semokName": "사업연구",
    "legacyBudgetAmtWon": 6030000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업연구",
        "calcBasis": "",
        "calcAmt": 6030,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 사례관리지원",
        "calcBasis": "",
        "calcAmt": 1830,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 평가기반후속지원",
        "calcBasis": "",
        "calcAmt": 1080,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "교통비",
        "calcBasis": "60,000원*2인*2회*4개 기관",
        "calcAmt": 960,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "식대 및 다과비",
        "calcBasis": "15,000원*2인*4회",
        "calcAmt": 120,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2) 고위험사례가이드마련",
        "calcBasis": "",
        "calcAmt": 750,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "자문비",
        "calcBasis": "100,000원*3회",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "자료집 제작비",
        "calcBasis": "9,000원*50부",
        "calcAmt": 450,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2. 사업장 지원",
        "calcBasis": "",
        "calcAmt": 4200,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 아동보호전문기관 지부장회의",
        "calcBasis": "",
        "calcAmt": 3900,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "식대 및 다과비",
        "calcBasis": "15,000원*45명*4회",
        "calcAmt": 2700,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "자료집 제작",
        "calcBasis": "5,000원*45부*4회",
        "calcAmt": 900,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "영상회의(zoom) 계정 연간 사용료",
        "calcBasis": "300,000",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2)기타회의운영",
        "calcBasis": "",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "식대 및 다과비",
        "calcBasis": "",
        "calcAmt": 300,
        "remark": "산출기초(이관): 15,000원*11명*1회"
      }
    ]
  },
  {
    "deptCode": "GNK1100",
    "deptName": "아동보호사업팀",
    "bizName": "기획사업비",
    "sehangName": "사업비",
    "mokName": "기획사업비",
    "semokName": "기타지부지원사업비",
    "legacyBudgetAmtWon": 420000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장 위수탁지원(아보전)",
        "calcBasis": "",
        "calcAmt": 420,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "서류발급 및 우편수수료 등 행정비용",
        "calcBasis": "60,000원*7개소",
        "calcAmt": 420,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1100",
    "deptName": "아동보호사업팀",
    "bizName": "부서운영비",
    "sehangName": "사업비",
    "mokName": "부서운영비",
    "semokName": "부서운영비",
    "legacyBudgetAmtWon": 2400000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "부서운영비",
        "calcBasis": "",
        "calcAmt": 2400,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "부서운영비(본부장, 팀장포함 6명)",
        "calcBasis": "",
        "calcAmt": 2400,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "월 부서운영비",
        "calcBasis": "30,000원*6명*12개월",
        "calcAmt": 2160,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "부서연수 및 워크샵비",
        "calcBasis": "40,000원*6명*1회",
        "calcAmt": 240,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1100",
    "deptName": "아동보호사업팀",
    "bizName": "아동보호전문기관 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "아동보호전문기관 전출금(후원금)",
    "semokName": "아동보호전문기관 전출금(후원금)",
    "legacyBudgetAmtWon": 5287996000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "아동보호전문기관(36개소) 2026년 연예산",
        "calcBasis": "5287996000",
        "calcAmt": 5287996,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1100",
    "deptName": "아동보호사업팀",
    "bizName": "아동보호전문기관 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "아동보호전문기관 전출금(후원금)",
    "semokName": "아동보호전문기관 전출금(후원금)",
    "legacyBudgetAmtWon": 6000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "아동보호전문기관 전출금(후원금)",
        "calcBasis": "",
        "calcAmt": 6000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) 사업장 위기관리 및 민원대응(법률비용 지원)",
        "calcBasis": "",
        "calcAmt": 6000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "법률지원(서면자문 포함) 및 법률대리 비용(지부지원)",
        "calcBasis": "2,000,000원*3개소",
        "calcAmt": 6000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1100",
    "deptName": "아동보호사업팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 83224680,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "김미주부장(L급 20호봉 / 1월 승호)",
        "calcBasis": "83,224,680원",
        "calcAmt": 83225,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1100",
    "deptName": "아동보호사업팀",
    "bizName": "지역사회 지원 기획사업비",
    "sehangName": "사업비",
    "mokName": "지역사회 지원 기획사업비",
    "semokName": "지역사회 지원 기획사업",
    "legacyBudgetAmtWon": 400000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "좋은이웃후원회",
        "calcBasis": "",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "후원회 물품제작비(박스 등)",
        "calcBasis": "400,000원*1회",
        "calcAmt": 400,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1100",
    "deptName": "아동보호사업팀",
    "bizName": "모금사업비",
    "sehangName": "사업비",
    "mokName": "모금사업비",
    "semokName": "지역사회개발",
    "legacyBudgetAmtWon": 8000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "좋은이웃가게",
        "calcBasis": "",
        "calcAmt": 8000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "지부 좋은이웃가게 현판 제작비",
        "calcBasis": "격월 1회*1,070,000원*6회",
        "calcAmt": 6420,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "지부 좋은이웃가게 공통키트 제작비",
        "calcBasis": "35,000원*45개소*1회",
        "calcAmt": 1575,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "계약서류 발송비",
        "calcBasis": "5,000원*1회",
        "calcAmt": 5,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1110",
    "deptName": "미래성장지원팀",
    "bizName": "가정위탁지원센터 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "가정위탁지원센터 전출금(후원금)",
    "semokName": "가정위탁지원센터 전출금(후원금)",
    "legacyBudgetAmtWon": 231357000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "가정위탁지원센터(1개소) 2026년 연예산",
        "calcBasis": "231357000",
        "calcAmt": 231357,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1110",
    "deptName": "미래성장지원팀",
    "bizName": "가정위탁지원센터 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "가정위탁지원센터 전출금(후원금)",
    "semokName": "가정위탁지원센터 전출금(후원금)기타",
    "legacyBudgetAmtWon": 20000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "가정형보호자립역량강화지원사업",
        "calcBasis": "20,000,000원*1회",
        "calcAmt": 20000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1110",
    "deptName": "미래성장지원팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 78983010,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "급여(마음건강증진지원사업)",
        "calcBasis": "",
        "calcAmt": 78984,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "김영미/L급/19호봉→20호봉(7월)",
        "calcBasis": "78983010",
        "calcAmt": 78984,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1110",
    "deptName": "미래성장지원팀",
    "bizName": "협력시설지원",
    "sehangName": "사업비",
    "mokName": "협력시설지원",
    "semokName": "운영지원사업",
    "legacyBudgetAmtWon": 348319000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "굿네이버스협력시설 운영지원사업",
        "calcBasis": "",
        "calcAmt": 348319,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "운영지원사업비 1차",
        "calcBasis": "348,319,000원*70%",
        "calcAmt": 243823,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "운영지원사업비 2차",
        "calcBasis": "348,319,000원*30%",
        "calcAmt": 104496,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1110",
    "deptName": "미래성장지원팀",
    "bizName": "협력시설지원",
    "sehangName": "사업비",
    "mokName": "협력시설지원",
    "semokName": "기타지원사업",
    "legacyBudgetAmtWon": 16820000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "굿네이버스협력시설 기타지원사업",
        "calcBasis": "",
        "calcAmt": 16820,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "신년교례회 진행비",
        "calcBasis": "",
        "calcAmt": 4000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "사례비(설교)",
        "calcBasis": "400,000원*1회",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "굿네이버스(임원) 및 연합회(원로/임원) 식비 및 다과비",
        "calcBasis": "17,000원*12명",
        "calcAmt": 204,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "굿네이버스(직원) 및 연합회(시설장) 식비",
        "calcBasis": "10,000원*100명",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "물품구입비(기념물품, 현수막, 순서지, 기타물품 등)",
        "calcBasis": "2,396,000원*1회",
        "calcAmt": 2396,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "협력시설 모니터링 진행비",
        "calcBasis": "",
        "calcAmt": 580,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "교통비(지역미정)",
        "calcBasis": "50,000원*2명*2회(왕복)*2개소",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "식비 및 다과비",
        "calcBasis": "15,000원*4명*2개소",
        "calcAmt": 120,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "기관방문비",
        "calcBasis": "30,000원*2개소",
        "calcAmt": 60,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "협력시설연합회 임원단회의 진행비",
        "calcBasis": "",
        "calcAmt": 240,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "식비 및 다과비",
        "calcBasis": "15,000원*8명*2회",
        "calcAmt": 240,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "협력시설종사자 역량강화워크숍 진행비",
        "calcBasis": "",
        "calcAmt": 12000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "진행비",
        "calcBasis": "",
        "calcAmt": 11856,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "숙박비",
        "calcBasis": "200,000원*25객실",
        "calcAmt": 5000,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "대관료",
        "calcBasis": "2,500,000원*1회",
        "calcAmt": 2500,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "식비",
        "calcBasis": "13,000원*45명*3식",
        "calcAmt": 1755,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "다과비",
        "calcBasis": "5,000원*45명*1회",
        "calcAmt": 225,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "강사비(역량강화교육, 업무소진예방p/g)",
        "calcBasis": "평균 1,000,000원*2회",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "물품구입비",
        "calcBasis": "376,000원*1회",
        "calcAmt": 376,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "워크숍수행인력체제비",
        "calcBasis": "",
        "calcAmt": 144,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "식비",
        "calcBasis": "12,000원*6명*1식",
        "calcAmt": 72,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "교통비",
        "calcBasis": "15,000원*2회(왕복)",
        "calcAmt": 30,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "기타제잡비",
        "calcBasis": "42,000원*1회",
        "calcAmt": 42,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1110",
    "deptName": "미래성장지원팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 65090670,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "급여(자립준비청년 및 보호아동 자립역량강화지원사업)",
        "calcBasis": "",
        "calcAmt": 65091,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "김진희/L급/ 14호봉 ->15호봉(04월)",
        "calcBasis": "65090670",
        "calcAmt": 65091,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1110",
    "deptName": "미래성장지원팀",
    "bizName": "지부지원사업",
    "sehangName": "사업비",
    "mokName": "지부지원사업",
    "semokName": "사업장방문",
    "legacyBudgetAmtWon": 1572000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장방문 진행비",
        "calcBasis": "",
        "calcAmt": 1572,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "진행인력교통비(지역미정)",
        "calcBasis": "30,000원*3명*2회*4회",
        "calcAmt": 720,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "진행인력진행비(여비,물품구입등)",
        "calcBasis": "21,000원*3명*4회",
        "calcAmt": 252,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사업장방문진행비(사업장식사등)",
        "calcBasis": "150,000원*4회",
        "calcAmt": 600,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1110",
    "deptName": "미래성장지원팀",
    "bizName": "대외협력사업",
    "sehangName": "사업비",
    "mokName": "대외협력사업",
    "semokName": "대외협력사업비",
    "legacyBudgetAmtWon": 2294000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "자립지원사업전문가네트워크",
        "calcBasis": "",
        "calcAmt": 2294,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "식사및다과비",
        "calcBasis": "17,000원*11명*2회",
        "calcAmt": 374,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "진행비(물품구입)",
        "calcBasis": "50,000원*2회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "거마비/자문수당(2시간초과)",
        "calcBasis": "130,000원*7회*2회",
        "calcAmt": 1820,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1110",
    "deptName": "미래성장지원팀",
    "bizName": "기획사업비",
    "sehangName": "사업비",
    "mokName": "기획사업비",
    "semokName": "사업평가",
    "legacyBudgetAmtWon": 3209000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장 (전년도)사업평가",
        "calcBasis": "",
        "calcAmt": 3209,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사업장 사업평가 교통비",
        "calcBasis": "",
        "calcAmt": 1420,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "교통비(영남)",
        "calcBasis": "60,000원*4명*2회*1개소",
        "calcAmt": 480,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "교통비(호남)",
        "calcBasis": "50,000원*4명*2회*1개소",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "교통비(충청)",
        "calcBasis": "20,000원*4명*2회*1개소",
        "calcAmt": 160,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "교통비(경기)",
        "calcBasis": "10,000원*4명*2회*1개소",
        "calcAmt": 80,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "택시비(역에서 기관 왕복)",
        "calcBasis": "50,000원*6개소",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사업장 사업평가 식사 및 다과비",
        "calcBasis": "",
        "calcAmt": 525,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "식사비 및 다과비(평가위원포함)",
        "calcBasis": "15,000원*35명",
        "calcAmt": 525,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사업장 사업평가 진행비",
        "calcBasis": "",
        "calcAmt": 1264,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "숙박비(영남방문시)",
        "calcBasis": "100,000원 *2객실 *2일",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "식비 및 일비",
        "calcBasis": "36,000원* 4명 * 6회",
        "calcAmt": 864,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1110",
    "deptName": "미래성장지원팀",
    "bizName": "기획사업비",
    "sehangName": "사업비",
    "mokName": "기획사업비",
    "semokName": "기타지부지원사업비",
    "legacyBudgetAmtWon": 1750000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장행정관리",
        "calcBasis": "",
        "calcAmt": 1750,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사업장행정관리 진행비(재수탁진행비)",
        "calcBasis": "100,000원* 1회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사업장 법률자문 지원",
        "calcBasis": "550,000원 * 3회",
        "calcAmt": 1650,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1110",
    "deptName": "미래성장지원팀",
    "bizName": "기획사업비",
    "sehangName": "사업비",
    "mokName": "기획사업비",
    "semokName": "기타지부지원사업비",
    "legacyBudgetAmtWon": 420000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사업장업무회의",
        "calcBasis": "",
        "calcAmt": 420,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사업장 업무회의 진행비",
        "calcBasis": "15000원* 7명 * 4회",
        "calcAmt": 420,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1110",
    "deptName": "미래성장지원팀",
    "bizName": "부서운영비",
    "sehangName": "사업비",
    "mokName": "부서운영비",
    "semokName": "부서운영비",
    "legacyBudgetAmtWon": 2000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "",
        "calcBasis": "",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "아동권리사업부 및 미래성장지원팀 부서운영비",
        "calcBasis": "30,000원*5명*12개월",
        "calcAmt": 1800,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "아동권리사업부 및 미래성장지원팀 부서워크숍",
        "calcBasis": "20,000원*5명*2회",
        "calcAmt": 200,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1110",
    "deptName": "미래성장지원팀",
    "bizName": "자립지원전담기관 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "자립지원전담기관 전출금(후원금)",
    "semokName": "자립지원전담기관 전출금(후원금)",
    "legacyBudgetAmtWon": 3625000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "좋은이웃청년상 진행비",
        "calcBasis": "",
        "calcAmt": 3625,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "좋은이웃청년상부상(장학금)",
        "calcBasis": "500,000원*6명",
        "calcAmt": 3000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "좋은이웃청년상시상식진행비",
        "calcBasis": "100,000원*6회",
        "calcAmt": 600,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "심사진행비",
        "calcBasis": "5,000원*5명",
        "calcAmt": 25,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1110",
    "deptName": "미래성장지원팀",
    "bizName": "자립지원전담기관 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "자립지원전담기관 전출금(후원금)",
    "semokName": "자립지원전담기관 전출금(후원금)",
    "legacyBudgetAmtWon": 545295000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "자립지원전담기관(2개소) 2026년 연예산",
        "calcBasis": "545295000",
        "calcAmt": 545295,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1110",
    "deptName": "미래성장지원팀",
    "bizName": "어린이집 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "어린이집 전출금(후원금)",
    "semokName": "어린이집 전출금(후원금)",
    "legacyBudgetAmtWon": 9600000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "어린이집(1개소) 2026년 연예산",
        "calcBasis": "9600000",
        "calcAmt": 9600,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1110",
    "deptName": "미래성장지원팀",
    "bizName": "종합사회복지관 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "종합사회복지관 전출금(후원금)",
    "semokName": "종합사회복지관 전출금(후원금)",
    "legacyBudgetAmtWon": 317756000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "종합사회복지관(2개소) 2026년 연예산",
        "calcBasis": "317756000",
        "calcAmt": 317756,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1110",
    "deptName": "미래성장지원팀",
    "bizName": "역량강화사업",
    "sehangName": "사업비",
    "mokName": "역량강화사업",
    "semokName": "진로탐색지원",
    "legacyBudgetAmtWon": 38300000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "굿네이버스 협력시설 아동역량강화사업(문화예체능) 사업비",
        "calcBasis": "",
        "calcAmt": 38300,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "문화예체능지원사업",
        "calcBasis": "38,300,000원*1회",
        "calcAmt": 38300,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1110",
    "deptName": "미래성장지원팀",
    "bizName": "역량강화사업",
    "sehangName": "사업비",
    "mokName": "역량강화사업",
    "semokName": "진로탐색지원",
    "legacyBudgetAmtWon": 100000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "굿네이버스 협력시설 아동역량강화사업(장학) 사업비",
        "calcBasis": "",
        "calcAmt": 100000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "대학생장학지원사업",
        "calcBasis": "100,000,000원*1회",
        "calcAmt": 100000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1110",
    "deptName": "미래성장지원팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 47163740,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "이기윤/5급/7호봉(1월)",
        "calcBasis": "47163740",
        "calcAmt": 47164,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1110",
    "deptName": "미래성장지원팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 54632800,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "임치은/4급/10호봉 (01월)",
        "calcBasis": "54632800",
        "calcAmt": 54633,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1110",
    "deptName": "미래성장지원팀",
    "bizName": "아동복지센터 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "아동복지센터 전출금(후원금)",
    "semokName": "아동복지센터 전출금(후원금)",
    "legacyBudgetAmtWon": 85868000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "아동복지센터(1개소) 2026년 연예산",
        "calcBasis": "85868000",
        "calcAmt": 85868,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1120",
    "deptName": "아동권리연구소",
    "bizName": "급여",
    "sehangName": "조사연구사업",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 317148460,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "직원관리비",
        "calcBasis": "",
        "calcAmt": 317149,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "일반직",
        "calcBasis": "",
        "calcAmt": 191656,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "팀장(L급 24-25호봉)",
        "calcBasis": "85059810",
        "calcAmt": 85060,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "과장(4급 11-12호봉)",
        "calcBasis": "57578600",
        "calcAmt": 57579,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "대리(5급 6-7호봉)",
        "calcBasis": "49016720",
        "calcAmt": 49017,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "전담직",
        "calcBasis": "",
        "calcAmt": 125494,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "연구위원(17-18호봉)",
        "calcBasis": "69803610",
        "calcAmt": 69804,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "연구위원(7-8호봉)",
        "calcBasis": "55689720",
        "calcAmt": 55690,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1120",
    "deptName": "아동권리연구소",
    "bizName": "대외협력사업",
    "sehangName": "조사연구사업",
    "mokName": "대외협력사업",
    "semokName": "대외협력사업비",
    "legacyBudgetAmtWon": 4600000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "대외협력사업",
        "calcBasis": "",
        "calcAmt": 4600,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "학회연회비납부",
        "calcBasis": "",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "한국아동복지학회 연회비",
        "calcBasis": "40000원*1회",
        "calcAmt": 40,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "한국사회복지학회 연회비",
        "calcBasis": "300000원*1회",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "아동권리학회 연회비",
        "calcBasis": "60000원*1회",
        "calcAmt": 60,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "학술대회 후원금",
        "calcBasis": "2000000원*2회",
        "calcAmt": 4000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "zoom 연간회원권",
        "calcBasis": "200000원*1회",
        "calcAmt": 200,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1120",
    "deptName": "아동권리연구소",
    "bizName": "정책연구사업",
    "sehangName": "조사연구사업",
    "mokName": "정책연구사업",
    "semokName": "사업정책연구",
    "legacyBudgetAmtWon": 122550000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "3차 아동보호전문기관 사례관리 성과평가 연구",
        "calcBasis": "",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "연구진행비",
        "calcBasis": "200000",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "발간비 및 발송비",
        "calcBasis": "20000원*40부",
        "calcAmt": 800,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "ACEs(아동기 역경경험)가 아동발달에 미치는 영향 연구",
        "calcBasis": "",
        "calcAmt": 10700,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "연구진행비",
        "calcBasis": "200000",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "설문조사비",
        "calcBasis": "8000000원*1회",
        "calcAmt": 8000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "심층면접 진행비",
        "calcBasis": "100000*15명",
        "calcAmt": 1500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "발간비 및 발송비",
        "calcBasis": "20000원*40부",
        "calcAmt": 800,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "IRB 심의비",
        "calcBasis": "200000",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "아동의 미디어 사용과 디지털 페이런팅 연구",
        "calcBasis": "",
        "calcAmt": 30000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "용역비",
        "calcBasis": "28200000",
        "calcAmt": 28200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "연구진행비",
        "calcBasis": "400000",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "자문비",
        "calcBasis": "200000원*3회",
        "calcAmt": 600,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "발간비 및 발송비",
        "calcBasis": "20000원*40부",
        "calcAmt": 800,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "학습소외아동, 느린학습자 관련 연구",
        "calcBasis": "",
        "calcAmt": 15000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "연구진행비",
        "calcBasis": "200000",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "델파이 연구비",
        "calcBasis": "150000원*20명*2회",
        "calcAmt": 6000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "설문조사비",
        "calcBasis": "8000000",
        "calcAmt": 8000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "발간비 및 발송비",
        "calcBasis": "20000원*40부",
        "calcAmt": 800,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "제5차 대한민국 아동권리지수",
        "calcBasis": "",
        "calcAmt": 6500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "연구진행비",
        "calcBasis": "220000",
        "calcAmt": 220,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "발간비(컬러)",
        "calcBasis": "60000원*100부",
        "calcAmt": 6000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "발송비",
        "calcBasis": "3500원*80부",
        "calcAmt": 280,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "제9회 전국동시지방선거 아동정책제안",
        "calcBasis": "",
        "calcAmt": 6500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "연구진행비",
        "calcBasis": "60000",
        "calcAmt": 60,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "인터뷰 진행비",
        "calcBasis": "30000원*50명",
        "calcAmt": 1500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "발간비(컬러)",
        "calcBasis": "80000원*60부",
        "calcAmt": 4800,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "발송비",
        "calcBasis": "3500원*40부",
        "calcAmt": 140,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "취약계층 진로와 인생개발 역량의 종단적 변화 국제비교 연구",
        "calcBasis": "",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "연구진행비",
        "calcBasis": "200000",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "발간비 및 발송비",
        "calcBasis": "20000원*40부",
        "calcAmt": 800,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "굿네이버스 사회적 가치 지표관리 및 측정",
        "calcBasis": "",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "연구진행비",
        "calcBasis": "200000",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "자문비",
        "calcBasis": "200000원*5회",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "발간비 및 발송비",
        "calcBasis": "20000원*40부",
        "calcAmt": 800,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "전문가 자문비",
        "calcBasis": "200000원*10회",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "자료 발간비",
        "calcBasis": "20000원*60부*4건",
        "calcAmt": 4800,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "이슈포커스 제작비",
        "calcBasis": "1000000원*3종",
        "calcAmt": 3000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "포럼 컨퍼런스 개최",
        "calcBasis": "",
        "calcAmt": 7000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "영상송출비",
        "calcBasis": "2500000",
        "calcAmt": 2500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "장소대관비",
        "calcBasis": "1500000",
        "calcAmt": 1500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "제작비",
        "calcBasis": "2500000",
        "calcAmt": 2500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "진행비",
        "calcBasis": "500000",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "연구결과활용",
        "calcBasis": "",
        "calcAmt": 1500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "학술지 투고비",
        "calcBasis": "500000원*2회",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "번역비",
        "calcBasis": "500000",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "동향조사",
        "calcBasis": "",
        "calcAmt": 350,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "학회 참가비",
        "calcBasis": "50000원*5명",
        "calcAmt": 250,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "자료구입 및 제본비",
        "calcBasis": "50000원*2회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "자문위원 정례회의",
        "calcBasis": "",
        "calcAmt": 1200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "자문비",
        "calcBasis": "200000원*4명*1회",
        "calcAmt": 800,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "회의비",
        "calcBasis": "15000원*15명*1회",
        "calcAmt": 225,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "자료인쇄비",
        "calcBasis": "175000",
        "calcAmt": 175,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "연구비 추가",
        "calcBasis": "30000000",
        "calcAmt": 30000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1120",
    "deptName": "아동권리연구소",
    "bizName": "부서운영비",
    "sehangName": "조사연구사업",
    "mokName": "부서운영비",
    "semokName": "부서운영비",
    "legacyBudgetAmtWon": 2000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "부서운영비",
        "calcBasis": "",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "부서운영비",
        "calcBasis": "30000원*5명*12개월",
        "calcAmt": 1800,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "부서워크샵",
        "calcBasis": "40000원*5명*1회",
        "calcAmt": 200,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1120",
    "deptName": "아동권리연구소",
    "bizName": "부서운영비",
    "sehangName": "조사연구사업",
    "mokName": "부서운영비",
    "semokName": "업무추진비",
    "legacyBudgetAmtWon": 1200000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "업무추진비",
        "calcBasis": "100000원*1명*12개월",
        "calcAmt": 1200,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1140",
    "deptName": "후원서비스팀",
    "bizName": "아동권리옹호활동",
    "sehangName": "사업비",
    "mokName": "아동권리옹호활동",
    "semokName": "홍보 및 캠페인",
    "legacyBudgetAmtWon": 5520000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[회원참여활동(온/오프라인)]",
        "calcBasis": "",
        "calcAmt": 4600,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 리워드 구입 및 발송비(5,12월/2회)",
        "calcBasis": "",
        "calcAmt": 3600,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 리워드 구입비",
        "calcBasis": "200명*2회*5,000원",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 발송비",
        "calcBasis": "200명*2회*4,000원",
        "calcAmt": 1600,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2. 회원참여활동(오프라인)",
        "calcBasis": "",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 오프라인 행사 진행비",
        "calcBasis": "1,000,000원*1회",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "문화이벤트",
        "calcBasis": "",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "문화서비스 업체 감사서비스",
        "calcBasis": "15개 업체 * 20,000원",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "서적 문화이벤트",
        "calcBasis": "",
        "calcAmt": 620,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "서적 업체 감사서비스",
        "calcBasis": "7개 업체 * 20,000원",
        "calcAmt": 140,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "회원 서적 발송 비용",
        "calcBasis": "10명*4,000원*12개월",
        "calcAmt": 480,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1140",
    "deptName": "후원서비스팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(정규직/기간제)",
    "legacyBudgetAmtWon": 298444000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[후원서비스팀 급여]",
        "calcBasis": "",
        "calcAmt": 298444,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 일반직 5명(팀장1, 과장3, 대리1)",
        "calcBasis": "",
        "calcAmt": 298444,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "최일선 팀장(L급 20호봉 / 1월 승호)",
        "calcBasis": "80,368,340원",
        "calcAmt": 80369,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "진화성 과장(4급 13,14호봉 / 4월 승호)",
        "calcBasis": "57,178,520원",
        "calcAmt": 57179,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "정진솔 과장(4급 13호봉 / 1월 승호)",
        "calcBasis": "60,535,900원",
        "calcAmt": 60536,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "김혜진 과장(4급 8,9호봉 / 10월 승호)",
        "calcBasis": "52,276,540원",
        "calcAmt": 52277,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "김윤하 대리(5급 7,8호봉 / 4월 승호)",
        "calcBasis": "48,084,700원",
        "calcAmt": 48085,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1140",
    "deptName": "후원서비스팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 88500000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[급여(본부)]",
        "calcBasis": "",
        "calcAmt": 88500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "회원상담센터 급여 2명",
        "calcBasis": "44,250,000원*2명",
        "calcAmt": 88500,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1140",
    "deptName": "후원서비스팀",
    "bizName": "모금사업비",
    "sehangName": "사업비",
    "mokName": "모금사업비",
    "semokName": "국내신규회원관리",
    "legacyBudgetAmtWon": 4904200,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[국내신규회원관리]",
        "calcBasis": "",
        "calcAmt": 4905,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 국내신규회원 제작비",
        "calcBasis": "",
        "calcAmt": 2905,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 신규회원활동안내서 제작비(디자인)",
        "calcBasis": "1,200,000원*1회",
        "calcAmt": 1200,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 신규회원활동안내서 인쇄비",
        "calcBasis": "5,000부*341원",
        "calcAmt": 1705,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2. 국내신규회원 발송",
        "calcBasis": "",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 신규회원 우편발송료",
        "calcBasis": "500원*12개월*196명",
        "calcAmt": 1176,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 신규회원 발송대행료",
        "calcBasis": "350원*12개월*196명",
        "calcAmt": 824,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1140",
    "deptName": "후원서비스팀",
    "bizName": "모금사업비",
    "sehangName": "사업비",
    "mokName": "모금사업비",
    "semokName": "국내기존회원관리",
    "legacyBudgetAmtWon": 13483200,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "국내기존회원제작",
        "calcBasis": "",
        "calcAmt": 1292,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "OCR 지로(12개월)",
        "calcBasis": "1,320부*50원",
        "calcAmt": 66,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "종이창봉투(12개월)",
        "calcBasis": "1,320부*50원",
        "calcAmt": 66,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "대량발송 비닐롤봉투(5,10월)",
        "calcBasis": "20,000부*25원",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "연차보고서 / 회지 동판비(5,10월)",
        "calcBasis": "330,000*2회",
        "calcAmt": 660,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "기존회원발송_오프라인  대행료 및 발송료",
        "calcBasis": "",
        "calcAmt": 12192,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "OCR 대행료",
        "calcBasis": "1,320명*60원",
        "calcAmt": 80,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "OCR 발송료",
        "calcBasis": "1,320명*350원",
        "calcAmt": 462,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "연차보고서 대행료",
        "calcBasis": "10,500명*60원",
        "calcAmt": 630,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "연차보고서 발송료",
        "calcBasis": "10,500명*600원",
        "calcAmt": 6300,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "회지 대행료",
        "calcBasis": "9,500명*50원",
        "calcAmt": 475,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "회지 발송료",
        "calcBasis": "9,500명*350원",
        "calcAmt": 3325,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "내부발송(1~12월)",
        "calcBasis": "30명*12개월*2,000원",
        "calcAmt": 720,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "발송용 라벨지 구입(5월,12월)",
        "calcBasis": "100,000원*2회",
        "calcAmt": 200,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1140",
    "deptName": "후원서비스팀",
    "bizName": "모금사업비",
    "sehangName": "사업비",
    "mokName": "모금사업비",
    "semokName": "보고서 제작",
    "legacyBudgetAmtWon": 41498000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "오프라인 회지 제작",
        "calcBasis": "(제본/인쇄비 550원*10,000부)+(계약서 우편 발송비 6,000원)",
        "calcAmt": 5506,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "오프라인 회지 제작_제본 및 인쇄비",
        "calcBasis": "550원*10,000부",
        "calcAmt": 5500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "오프라인 회지 제작_우편발송비",
        "calcBasis": "6,000원",
        "calcAmt": 6,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "모바일 회지 제작",
        "calcBasis": "",
        "calcAmt": 3000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "모바일 회지 제작_디자인 예비비",
        "calcBasis": "700,000원*3회",
        "calcAmt": 2100,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "모바일 회지 제작_설문조사 리워드 구입",
        "calcBasis": "10,000원*20개*3회",
        "calcAmt": 600,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "모바일 회지 제작_설문조사 리워드 택배 발송",
        "calcBasis": "5,000원*20개*3회",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "웹메일 회지 제작",
        "calcBasis": "",
        "calcAmt": 900,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "웹메일 회지 제작_디자인 예비비",
        "calcBasis": "300,000원*3회",
        "calcAmt": 900,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "사회복지법인 연차보고서 제작",
        "calcBasis": "",
        "calcAmt": 21786,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사회복지법인 연차보고서 제작_기획 및 디자인, 제작비",
        "calcBasis": "단가 9,000원*2,200부",
        "calcAmt": 19800,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사회복지법인 연차보고서 제작_부가세 10%",
        "calcBasis": "1,980,000원",
        "calcAmt": 1980,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사회복지법인 연차보고서 제작_우편발송비",
        "calcBasis": "6,000원",
        "calcAmt": 6,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "통합 연차보고서 제작",
        "calcBasis": "",
        "calcAmt": 8006,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "통합 연차보고서 제작_제본 및 인쇄비",
        "calcBasis": "800원*10,000부",
        "calcAmt": 8000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "통합 연차보고서 제작_우편발송비",
        "calcBasis": "6,000원",
        "calcAmt": 6,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "모바일 연차보고서 제작",
        "calcBasis": "",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "모바일 연차보고서 제작_디자인 예비비",
        "calcBasis": "700,000원",
        "calcAmt": 700,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "모바일 연차보고서 제작_설문조사 리워드 구입",
        "calcBasis": "10,000원*20개",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "모바일 연차보고서 제작_설문조사 리워드 택배 발송",
        "calcBasis": "5,000원*20개",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "웹메일 연차보고서 제작",
        "calcBasis": "",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "웹메일 연차보고서 제작_디자인 예비비",
        "calcBasis": "300,000원",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "모바일 후원사업 중간보고서 제작",
        "calcBasis": "",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "모바일 후원사업 중간보고서 제작_디자인 예비비",
        "calcBasis": "700,000원",
        "calcAmt": 700,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "모바일 후원사업 중간보고서 제작_설문조사 리워드 구입",
        "calcBasis": "10,000원*20개",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "모바일 후원사업 중간보고서 제작_설문조사 리워드 택배 발송",
        "calcBasis": "5,000원*20개",
        "calcAmt": 100,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1140",
    "deptName": "후원서비스팀",
    "bizName": "모금사업비",
    "sehangName": "사업비",
    "mokName": "모금사업비",
    "semokName": "컨텐츠 제작",
    "legacyBudgetAmtWon": 7950000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "기관 홍보물 제작",
        "calcBasis": "",
        "calcAmt": 6950,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "기관 홍보물 제작_차년도 달력 제작비",
        "calcBasis": "단가 4,500원*1,500부",
        "calcAmt": 6750,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "기관 홍보물 제작_우편 발송 예비비",
        "calcBasis": "4,000원*50개",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "컨셉사진 구매",
        "calcBasis": "",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "컨셉사진 구매(영구보관)",
        "calcBasis": "장당 단가 50,000원*20장",
        "calcAmt": 1000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1140",
    "deptName": "후원서비스팀",
    "bizName": "모금사업비",
    "sehangName": "사업비",
    "mokName": "모금사업비",
    "semokName": "회원특성별관리",
    "legacyBudgetAmtWon": 43023205,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "미납서비스",
        "calcBasis": "",
        "calcAmt": 1856,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "미납서비스_당첨 리워드 구입비",
        "calcBasis": "(2,000원*300개)+(20,000원*40개)",
        "calcAmt": 1400,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "미납서비스_감사서신 제작비",
        "calcBasis": "400매*150원",
        "calcAmt": 60,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "미납서비스_당첨 리워드 우편 발송비",
        "calcBasis": "33명*12개월*1,000원",
        "calcAmt": 396,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "연말 달력 발송 서비스",
        "calcBasis": "",
        "calcAmt": 1200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "연말 달력 발송 서비스_발송 우편료",
        "calcBasis": "800명*1,000원",
        "calcAmt": 800,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "연말 달력 발송 서비스_발송 대행료",
        "calcBasis": "800명*500원",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "장기회원서비스",
        "calcBasis": "",
        "calcAmt": 30018,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1. 오프라인 장기회원서비스",
        "calcBasis": "",
        "calcAmt": 18410,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 오프라인 감사카드 제작",
        "calcBasis": "",
        "calcAmt": 5206,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 오프라인 감사카드/봉투 제작(10/15/20/25/30/35년)",
        "calcBasis": "1,352명*3,850원",
        "calcAmt": 5206,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2) 오프라인 장기회원서비스 리워드 제작",
        "calcBasis": "",
        "calcAmt": 9666,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 리워드 제작(10/15년)",
        "calcBasis": "974명*2,700원",
        "calcAmt": 2630,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 리워드 제작(20/25년)",
        "calcBasis": "289명*5,400원",
        "calcAmt": 1561,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 리워드 제작(30년)",
        "calcBasis": "66명*53,000원",
        "calcAmt": 3498,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 리워드 제작(35년)",
        "calcBasis": "23명*65,000원",
        "calcAmt": 1495,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 리워드 라벨 제작",
        "calcBasis": "1,000개*132원",
        "calcAmt": 132,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 안내 내지 제작",
        "calcBasis": "350,000원*1회",
        "calcAmt": 350,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "3) 박스제작비(30/35년)",
        "calcBasis": "89개*11,880원",
        "calcAmt": 1058,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "4) 발송비(우편 및 택배)",
        "calcBasis": "",
        "calcAmt": 2272,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 발송대행료",
        "calcBasis": "1,263명*495원",
        "calcAmt": 626,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 박스작업료(30/35년)",
        "calcBasis": "89명*1,650원",
        "calcAmt": 147,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 우편료",
        "calcBasis": "1,263명*약823원",
        "calcAmt": 1040,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 택배발송비",
        "calcBasis": "89명*2,750원",
        "calcAmt": 245,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 용차비",
        "calcBasis": "165,000원",
        "calcAmt": 165,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 물품보관비",
        "calcBasis": "50,000원",
        "calcAmt": 50,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "5) 재발송비(우편)",
        "calcBasis": "50명*1,200원",
        "calcAmt": 60,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "6) 재발송비(택배)",
        "calcBasis": "50명*3,000원",
        "calcAmt": 150,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2. 온라인 장기서비스",
        "calcBasis": "",
        "calcAmt": 11609,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "1) 온라인 리워드 제작(3,5,7년)",
        "calcBasis": "",
        "calcAmt": 6232,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 리워드 제작(키링)",
        "calcBasis": "1,000개*1,800원",
        "calcAmt": 1800,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 리워드 제작 1",
        "calcBasis": "1,000개*2,500원",
        "calcAmt": 2500,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 리워드 제작 2",
        "calcBasis": "500개*3,000원",
        "calcAmt": 1500,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 리워드 라벨 제작",
        "calcBasis": "1,000개*132원",
        "calcAmt": 132,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "안내 내지 제작",
        "calcBasis": "300,000월",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "2) 온라인 리워드 발송 봉투 제작",
        "calcBasis": "3,000,000월",
        "calcAmt": 3000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "3) 온라인 리워드 발송비(우편)",
        "calcBasis": "",
        "calcAmt": 2377,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 발송대행료(3,5,7년)",
        "calcBasis": "1,801명*400원",
        "calcAmt": 721,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 우편발송료",
        "calcBasis": "1,801명*800원",
        "calcAmt": 1441,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 용차비",
        "calcBasis": "165,000원",
        "calcAmt": 165,
        "remark": ""
      },
      {
        "calcLevel": 4,
        "calcDesc": "- 재발송 우편료",
        "calcBasis": "50명*1,000원",
        "calcAmt": 50,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[특성별회원_생일서비스]",
        "calcBasis": "",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 생일서비스 페이지 리뉴얼 진행비",
        "calcBasis": "500,000원*1회",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "타겟 맞춤형 신규서비스",
        "calcBasis": "",
        "calcAmt": 9450,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "신규 서비스 리플렛",
        "calcBasis": "2,100명*1,000원",
        "calcAmt": 2100,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "신규 서비스 리워드",
        "calcBasis": "2,100명*2,000원",
        "calcAmt": 4200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "신규 서비스 발송비",
        "calcBasis": "2,100명*1,500원",
        "calcAmt": 3150,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1140",
    "deptName": "후원서비스팀",
    "bizName": "모금사업비",
    "sehangName": "사업비",
    "mokName": "모금사업비",
    "semokName": "캠페인사업 지원인력",
    "legacyBudgetAmtWon": 63000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[캠페인사업 지원 인력비]",
        "calcBasis": "",
        "calcAmt": 63000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 캠페인사업 지원 인력비 1명",
        "calcBasis": "5,250,000원*12개월",
        "calcAmt": 63000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1140",
    "deptName": "후원서비스팀",
    "bizName": "부서운영비",
    "sehangName": "사업비",
    "mokName": "부서운영비",
    "semokName": "부서운영비",
    "legacyBudgetAmtWon": 2000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "부서운영비",
        "calcBasis": "",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "일반직 5명",
        "calcBasis": "일반직 5명 * 30,000원 * 12개월",
        "calcAmt": 1800,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "부서 워크샵",
        "calcBasis": "5명*40,000원",
        "calcAmt": 200,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1140",
    "deptName": "후원서비스팀",
    "bizName": "지급수수료",
    "sehangName": "운영비",
    "mokName": "지급수수료",
    "semokName": "지급수수료(본부)",
    "legacyBudgetAmtWon": 375750000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "",
        "calcBasis": "",
        "calcAmt": 374755,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "자동이체 수수료",
        "calcBasis": "110,830명 * 69.91% * 175원 * 12개월",
        "calcAmt": 164036,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "신용카드 수수료",
        "calcBasis": "24,567,520,131원 * 23.89% * 2.66%",
        "calcAmt": 155057,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "OCR 수수료",
        "calcBasis": "110,830명 * 0.13% * 205원 * 12개월",
        "calcAmt": 334,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "전자결제 수수료",
        "calcBasis": "24,567,520,131원 * 0.09% * 2.46%",
        "calcAmt": 511,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "네이버페이 수수료",
        "calcBasis": "24,567,520,131원 * 6.98% * 2.750%",
        "calcAmt": 46778,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "자동이체 대행료",
        "calcBasis": "187,159,400원 * 4.90%",
        "calcAmt": 8039,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "이행보증보험 수수료",
        "calcBasis": "836,550,000*0.119%",
        "calcAmt": 995,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1150",
    "deptName": "인재운영부",
    "bizName": "지부지원사업",
    "sehangName": "조사연구사업",
    "mokName": "지부지원사업",
    "semokName": "사업연구",
    "legacyBudgetAmtWon": 32263960,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[이사장 활동비]",
        "calcBasis": "",
        "calcAmt": 32264,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 활동비",
        "calcBasis": "2,456,000원*12개월",
        "calcAmt": 29472,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 명절휴가비",
        "calcBasis": "200,000원*2회",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 건강보험료",
        "calcBasis": "196,660원*10개월",
        "calcAmt": 1967,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 건강보험료(명절)",
        "calcBasis": "212,680원*2개월",
        "calcAmt": 426,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1150",
    "deptName": "인재운영부",
    "bizName": "직원지원정책",
    "sehangName": "조사연구사업",
    "mokName": "직원지원정책",
    "semokName": "장기근속포상",
    "legacyBudgetAmtWon": 87660000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[장기근속 포상 진행비]",
        "calcBasis": "",
        "calcAmt": 87660,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) 근속포상식 진행비",
        "calcBasis": "",
        "calcAmt": 2160,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 감사패 20년",
        "calcBasis": "40,000원*11명",
        "calcAmt": 440,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 감사패 25년",
        "calcBasis": "50,000원*3명",
        "calcAmt": 150,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 감사패 30년",
        "calcBasis": "80,000원*3명",
        "calcAmt": 240,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 근속포상식 행사 진행비(꽃)",
        "calcBasis": "50,000원*17명",
        "calcAmt": 850,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 본부 근속포상식 진행비",
        "calcBasis": "20,000원*24명",
        "calcAmt": 480,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2) 포상금",
        "calcBasis": "",
        "calcAmt": 60500,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 본부 포상금",
        "calcBasis": "(5년 포상금 50,000원*10명)+(10년 포상금 300,000원*11명)+(15년 포상금 600,000원*2명)+(20년 포상금 1,000,000원*1명)+(건강증진비 250,000원*2명)",
        "calcAmt": 6500,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 사업장 포상금",
        "calcBasis": "(5년 포상금 50,000원*65명)+(10년 포상금 300,000원*30명)+(15년 포상금 600,000원*25명)+(20년 포상금 1,000,000원*10명)+(25년 포상금 1,500,000원*3명)+(30년 포상금 2,000,000원*3명)+(건강증진비 250,000원*25명)",
        "calcAmt": 54000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "3) 자녀 학자금",
        "calcBasis": "",
        "calcAmt": 25000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 본부 자녀 학자금",
        "calcBasis": "(고등학생 자녀 4명*500,000원)+(대학생 자녀 2명*1,000,000원)",
        "calcAmt": 4000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 사업장 자녀 학자금",
        "calcBasis": "(고등학생 자녀 14명*500,000원)+(대학생 자녀 14명*1,000,000원)",
        "calcAmt": 21000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1150",
    "deptName": "인재운영부",
    "bizName": "직원지원정책",
    "sehangName": "조사연구사업",
    "mokName": "직원지원정책",
    "semokName": "기타복지지원",
    "legacyBudgetAmtWon": 53125970,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[직원 PTSD 치료지원]",
        "calcBasis": "",
        "calcAmt": 5000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 치료비",
        "calcBasis": "1,000,000원*5명",
        "calcAmt": 5000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[출산 축하 지원금]",
        "calcBasis": "",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 축하금",
        "calcBasis": "100,000원*10명",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[DB단체상해보험]",
        "calcBasis": "",
        "calcAmt": 43286,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 단체상해보험(2026.01~07 선급비용)",
        "calcBasis": "16,937,970원",
        "calcAmt": 16938,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 단체상해보험(7월-플랜1)",
        "calcBasis": "140,000원*119명",
        "calcAmt": 16660,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 단체상해보험(7월-플랜2)",
        "calcBasis": "14,000원*692명",
        "calcAmt": 9688,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[화환 발송]",
        "calcBasis": "",
        "calcAmt": 2400,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 화환 발송비",
        "calcBasis": "100,000원*2명*12개월",
        "calcAmt": 2400,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[장례조문비]",
        "calcBasis": "",
        "calcAmt": 1440,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 조문비",
        "calcBasis": "60,000원*2명*12개월",
        "calcAmt": 1440,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1150",
    "deptName": "인재운영부",
    "bizName": "부서운영비",
    "sehangName": "조사연구사업",
    "mokName": "부서운영비",
    "semokName": "부서운영비",
    "legacyBudgetAmtWon": 2000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[부서운영비]",
        "calcBasis": "",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 부서운영비",
        "calcBasis": "30,000원*5명*12개월",
        "calcAmt": 1800,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 부서연수 및 워크샵",
        "calcBasis": "40,000원*5명*1회",
        "calcAmt": 200,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1150",
    "deptName": "인재운영부",
    "bizName": "부서운영비",
    "sehangName": "조사연구사업",
    "mokName": "부서운영비",
    "semokName": "업무추진비",
    "legacyBudgetAmtWon": 2400000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[업무추진비]",
        "calcBasis": "",
        "calcAmt": 1200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 부장 업무추진비",
        "calcBasis": "100,000원*1명*12개월",
        "calcAmt": 1200,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[조문 수행 경조금]",
        "calcBasis": "",
        "calcAmt": 1200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 직원 장례 조문비",
        "calcBasis": "50,000원*2명*12개월",
        "calcAmt": 1200,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1150",
    "deptName": "인재운영부",
    "bizName": "급여",
    "sehangName": "인건비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 1294218170,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[행정 인건비]",
        "calcBasis": "",
        "calcAmt": 1294219,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 급여(25명)*12개월",
        "calcBasis": "",
        "calcAmt": 1294219,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1150",
    "deptName": "인재운영부",
    "bizName": "퇴직금 및 퇴직적립금",
    "sehangName": "인건비",
    "mokName": "퇴직금 및 퇴직적립금",
    "semokName": "퇴직금 및 퇴직적립금(본부)",
    "legacyBudgetAmtWon": 118821350,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[행정 인건비 퇴직적립금]",
        "calcBasis": "",
        "calcAmt": 118822,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 퇴직적립금(25명)*12개월",
        "calcBasis": "",
        "calcAmt": 118822,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1150",
    "deptName": "인재운영부",
    "bizName": "사회보험 부담금",
    "sehangName": "인건비",
    "mokName": "사회보험 부담금",
    "semokName": "사회보험부담금(정규직/기간제)",
    "legacyBudgetAmtWon": 284814340,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[사회보험부담비용]",
        "calcBasis": "",
        "calcAmt": 284815,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 건강보험(개인+법인)(25명)",
        "calcBasis": "",
        "calcAmt": 110930,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 국민연금(개인+법인)(25명)",
        "calcBasis": "",
        "calcAmt": 127699,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 고용보험(개인+법인)(25명)",
        "calcBasis": "",
        "calcAmt": 36254,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 산재보험(법인)(25명)",
        "calcBasis": "",
        "calcAmt": 9934,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1150",
    "deptName": "인재운영부",
    "bizName": "수용비및수수료",
    "sehangName": "운영비",
    "mokName": "수용비및수수료",
    "semokName": "수용비및수수료",
    "legacyBudgetAmtWon": 2340000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[2025년 귀속 연말정산 세무대행비]",
        "calcBasis": "",
        "calcAmt": 2340,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 연말정산 세무대행비",
        "calcBasis": "20,000원*117명",
        "calcAmt": 2340,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1150",
    "deptName": "인재운영부",
    "bizName": "지급수수료",
    "sehangName": "운영비",
    "mokName": "지급수수료",
    "semokName": "지급수수료(본부)",
    "legacyBudgetAmtWon": 61040400,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[퇴직연금 운용/자산관리 수수료]",
        "calcBasis": "",
        "calcAmt": 3000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 퇴직연금 DC계좌 운용 및 자산관리 수수료",
        "calcBasis": "3계좌*1,000,000원*1회",
        "calcAmt": 3000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[공인인증서 갱신]",
        "calcBasis": "",
        "calcAmt": 5,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 사회복지법인 공인인증서 갱신 수수료",
        "calcBasis": "4,400원*1회",
        "calcAmt": 5,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[성과평가 시스템 개발비]",
        "calcBasis": "",
        "calcAmt": 58036,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 성과평가 시스템 개발비",
        "calcBasis": "29,018,000원*2회(선급금,잔금)",
        "calcAmt": 58036,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1150",
    "deptName": "인재운영부",
    "bizName": "인사관리비",
    "sehangName": "운영비",
    "mokName": "인사관리비",
    "semokName": "인사관리",
    "legacyBudgetAmtWon": 83463200,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[직원채용(공개채용)]",
        "calcBasis": "",
        "calcAmt": 48850,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) 채용플랫폼(마이다스인)",
        "calcBasis": "",
        "calcAmt": 9950,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 임대비(2026년 6월~12월)",
        "calcBasis": "(1,200명*7,700원)*7/12개월",
        "calcAmt": 5390,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 임대비(2026년 1월~5월)",
        "calcBasis": "해당연도 선급비용 4,559,200원",
        "calcAmt": 4560,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2) 채용 홍보",
        "calcBasis": "",
        "calcAmt": 2400,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 채용 사이트 유료 공고비",
        "calcBasis": "800,000원*3개 사이트",
        "calcAmt": 2400,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "3) 역량검사 및 AI면접",
        "calcBasis": "",
        "calcAmt": 29700,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 역량검사비",
        "calcBasis": "49,500원*600명",
        "calcAmt": 29700,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "4) 최종면접 진행비",
        "calcBasis": "",
        "calcAmt": 6300,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 면접관 및 진행인력 사전 교육진행비",
        "calcBasis": "5,000원*12명*5일",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 면접관 및 진행인력 식비 다과비",
        "calcBasis": "15,000원*12명*5일",
        "calcAmt": 900,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 면접장소 대관비",
        "calcBasis": "500,000원*5일",
        "calcAmt": 2500,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 응시자 교통지원비",
        "calcBasis": "10,000원*250명",
        "calcAmt": 2500,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 기타 진행비",
        "calcBasis": "100,000원*1회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "5) 신입직원 발령 물품비",
        "calcBasis": "",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 상장케이스 제작비",
        "calcBasis": "2,000원*250개",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[직원채용(권역수시채용)]",
        "calcBasis": "",
        "calcAmt": 5700,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) 채용 운영비",
        "calcBasis": "",
        "calcAmt": 5700,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 최종면접 면접관 및 진행인력 사전 교육진행비",
        "calcBasis": "5,000원*5명*2회*6개권역",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 최종면접 면접관 및 진행인력 식비 다과비",
        "calcBasis": "15,000원*5명*2일*2회*6개권역",
        "calcAmt": 1800,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 응시자 교통지원비",
        "calcBasis": "10,000원*300명",
        "calcAmt": 3000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 기타 진행비",
        "calcBasis": "50,000원*2회*6개권역",
        "calcAmt": 600,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[면접관 교육]",
        "calcBasis": "",
        "calcAmt": 8324,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) 면접관 교육 진행비",
        "calcBasis": "",
        "calcAmt": 8324,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 교육 장소 대관료",
        "calcBasis": "500,000원*2일",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 면접관 교육 강사비",
        "calcBasis": "250,000원*8시간*2일",
        "calcAmt": 4000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 강사 및 직원 식비 다과비",
        "calcBasis": "13,000원*50명*2식*2일",
        "calcAmt": 2600,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 진행인력 식비 다과비",
        "calcBasis": "13,000원*12명*2식*2일",
        "calcAmt": 624,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 기타 진행비",
        "calcBasis": "50,000원*2회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[노무 네트워크]",
        "calcBasis": "",
        "calcAmt": 5940,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 노무자문료",
        "calcBasis": "495,000원*12개월",
        "calcAmt": 5940,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[인사위원회]",
        "calcBasis": "",
        "calcAmt": 1500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 인사위원회 다과비",
        "calcBasis": "5,000원*10명*6회",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 인사위원회 교통비(협의회 근로자위원)",
        "calcBasis": "100,000원*2명*6회",
        "calcAmt": 1200,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[더좋은이웃협의회]",
        "calcBasis": "",
        "calcAmt": 5780,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) 협의회 정기회의 진행비",
        "calcBasis": "",
        "calcAmt": 1340,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 정기회의 식대 및 다과비",
        "calcBasis": "15,000원*9명*4회",
        "calcAmt": 540,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 정기회의 교통비",
        "calcBasis": "100,000원*2명*4회",
        "calcAmt": 800,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2) 근로자위원 자체회의 진행비",
        "calcBasis": "",
        "calcAmt": 240,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 자체회의 식대 및 다과비",
        "calcBasis": "15,000원*4명*4회",
        "calcAmt": 240,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "3) 근로자위원 워크샵 진행비",
        "calcBasis": "",
        "calcAmt": 4200,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 워크샵 교통비",
        "calcBasis": "60,000원*4명*1회",
        "calcAmt": 240,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 워크샵 숙박비",
        "calcBasis": "100,000원*2실*1박",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 워크샵 식대 및 다과비",
        "calcBasis": "15,000원*4명*6식",
        "calcAmt": 360,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 협의회 캠페인 진행비",
        "calcBasis": "300,000원*10개 사업장",
        "calcAmt": 3000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 근로자위원 선거 진행비(선관위지원금)",
        "calcBasis": "100,000원*4명*1회",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[직원면담 및 지원]",
        "calcBasis": "",
        "calcAmt": 120,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 직원면담 진행비",
        "calcBasis": "2명*5,000원*12회",
        "calcAmt": 120,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "[승진심사 진행비]",
        "calcBasis": "",
        "calcAmt": 7250,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1) L급 승진심사 면접 진행비",
        "calcBasis": "",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- L급 승진 대상자 대기실 다과비",
        "calcBasis": "5,000원*60명",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2) 필기시험 진행비 (시스템 이용료)",
        "calcBasis": "",
        "calcAmt": 6250,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- L급 필기시험 진행비",
        "calcBasis": "15,000원*60명",
        "calcAmt": 900,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 4급 필기시험 진행비",
        "calcBasis": "15,000원*50명",
        "calcAmt": 750,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 5급 필기시험 진행비",
        "calcBasis": "15,000원*40명",
        "calcAmt": 600,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 필기시험 대관료 및 시스템 운영비",
        "calcBasis": "2,000,000원*2회",
        "calcAmt": 4000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "3) 승진심사 인사위원회 진행비",
        "calcBasis": "",
        "calcAmt": 700,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 인사위원회 다과비",
        "calcBasis": "5,000원*10명*2회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "- 인사위원회 교통비",
        "calcBasis": "100,000원*3명*2회",
        "calcAmt": 600,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1150",
    "deptName": "인재운영부",
    "bizName": "제세공과금",
    "sehangName": "운영비",
    "mokName": "제세공과금",
    "semokName": "제세공과금(본부)",
    "legacyBudgetAmtWon": 45050020,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[2025년 귀속 장애인고용부담금]",
        "calcBasis": "",
        "calcAmt": 45051,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 장애인고용부담금",
        "calcBasis": "",
        "calcAmt": 88740,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 장애인고용연계감면액",
        "calcBasis": "",
        "calcAmt": -43689,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1150",
    "deptName": "인재운영부",
    "bizName": "보험료",
    "sehangName": "운영비",
    "mokName": "보험료",
    "semokName": "보험료(본부)",
    "legacyBudgetAmtWon": 1170000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[사회복지공제회 단체 상해보험]",
        "calcBasis": "",
        "calcAmt": 1170,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 일반직",
        "calcBasis": "10,000원*101명",
        "calcAmt": 1010,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 전담직",
        "calcBasis": "10,000원*3명",
        "calcAmt": 30,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 기간제계약직",
        "calcBasis": "10,000원*8명",
        "calcAmt": 80,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 시간제계약직",
        "calcBasis": "10,000원*3명",
        "calcAmt": 30,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "- 초단시간근로자",
        "calcBasis": "10,000원*2명",
        "calcAmt": 20,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1160",
    "deptName": "GN컬쳐팀",
    "bizName": "기획사업비",
    "sehangName": "사업비",
    "mokName": "기획사업비",
    "semokName": "기타지부지원사업비",
    "legacyBudgetAmtWon": 47623233,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "대리 해외사업세미나",
        "calcBasis": "",
        "calcAmt": 47624,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "항공료(왕복)",
        "calcBasis": "800,000원*29명",
        "calcAmt": 23200,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사전준비비(OT&최종리허설)",
        "calcBasis": "15,000원* 29명*2회",
        "calcAmt": 870,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사업교류 활동비 - 번역비",
        "calcBasis": "50,000원*70페이지",
        "calcAmt": 3500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사업교류 활동비 - 자료집 제작비",
        "calcBasis": "12,000원*180개",
        "calcAmt": 2160,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사업교류 활동비 - 현지기관 방문비",
        "calcBasis": "50,000원*3개 기관",
        "calcAmt": 150,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사업교류 활동비 - 캠페인 준비비",
        "calcBasis": "5,000원*100명",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "현수막",
        "calcBasis": "100,000원*1회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "의약품",
        "calcBasis": "의약품 구입 1회*100,000",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "기타 진행비",
        "calcBasis": "세미나 물품 및 유심 구입비, 진행인력 및 본부 대상자 진행비",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "현지진행비",
        "calcBasis": "",
        "calcAmt": 16544,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1160",
    "deptName": "GN컬쳐팀",
    "bizName": "급여",
    "sehangName": "조사연구사업",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 190719660,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "정성화 (L급 19호봉)",
        "calcBasis": "78,311,780",
        "calcAmt": 78312,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "양은하 (4급 12호봉)",
        "calcBasis": "57,060,860",
        "calcAmt": 57061,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "양경아 (4급 10호봉)",
        "calcBasis": "55,347,020",
        "calcAmt": 55348,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1160",
    "deptName": "GN컬쳐팀",
    "bizName": "정책세미나",
    "sehangName": "조사연구사업",
    "mokName": "정책세미나",
    "semokName": "전담직 세미나",
    "legacyBudgetAmtWon": 4480000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "전담직 및 기능직 자체활동 지원",
        "calcBasis": "40,000원*112명",
        "calcAmt": 4480,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1160",
    "deptName": "GN컬쳐팀",
    "bizName": "정책세미나",
    "sehangName": "조사연구사업",
    "mokName": "정책세미나",
    "semokName": "리더 세미나",
    "legacyBudgetAmtWon": 36558000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "GN 리더십 과정 C3 (4급 과장)",
        "calcBasis": "",
        "calcAmt": 6634,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "강의실",
        "calcBasis": "770,000원*2일",
        "calcAmt": 1540,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "숙박비",
        "calcBasis": "30,000원*17개",
        "calcAmt": 510,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "식대",
        "calcBasis": "13,000원*4식*34명",
        "calcAmt": 1768,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "강사비",
        "calcBasis": "400,000원*5시간",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사무총장 간담회비",
        "calcBasis": "5,000원*30명",
        "calcAmt": 150,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "다과비",
        "calcBasis": "5,000원*34명",
        "calcAmt": 170,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "기타진행비",
        "calcBasis": "진행인력 일비, 프로그램 물품 구입비 등",
        "calcAmt": 496,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "GN 리더십 과정 C4 (L급 차장)",
        "calcBasis": "",
        "calcAmt": 4395,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "C4 신규 L급 승진자 과정",
        "calcBasis": "",
        "calcAmt": 1525,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "Self Study 모임 비용",
        "calcBasis": "20명*15,000원*3회",
        "calcAmt": 900,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "멘토 리더 인터뷰 진행비",
        "calcBasis": "25명*15,000원*1회",
        "calcAmt": 375,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "멘토 리더 기관방문비",
        "calcBasis": "5개*50,000원",
        "calcAmt": 250,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "C4 비대표 L급 및 선임과정",
        "calcBasis": "",
        "calcAmt": 2870,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "O.T 진행비용",
        "calcBasis": "5,000원*34명",
        "calcAmt": 170,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "Self Study 모임 비용",
        "calcBasis": "30명*15,000원*3회",
        "calcAmt": 1350,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "멘토 리더 인텨뷰 진행비",
        "calcBasis": "36명*15,000원*1회",
        "calcAmt": 540,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "멘토 리더 기관방문비",
        "calcBasis": "6명*50,000원",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "교육 수료 모임",
        "calcBasis": "15,000원*34명",
        "calcAmt": 510,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "GN 리더십 과정 C5 (대표직책)",
        "calcBasis": "",
        "calcAmt": 14150,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "외부강사비용",
        "calcBasis": "400,000원*5시간*7개권역",
        "calcAmt": 14000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "다과비(본부)",
        "calcBasis": "5,000원*30명",
        "calcAmt": 150,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "리더워크샵",
        "calcBasis": "",
        "calcAmt": 10474,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "강의실",
        "calcBasis": "770,000원*2개",
        "calcAmt": 1540,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "숙박료",
        "calcBasis": "30,000원*41개",
        "calcAmt": 1230,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "식대",
        "calcBasis": "13,000원*4식*84명",
        "calcAmt": 4368,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "강사비",
        "calcBasis": "400,000원*5시간",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사무총장 간담회비",
        "calcBasis": "5,000원*84명",
        "calcAmt": 420,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "다과비",
        "calcBasis": "5,000원*84명",
        "calcAmt": 420,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "기타진행비",
        "calcBasis": "진행인력 일비, 프로그램 물품 구입비 등",
        "calcAmt": 496,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "신임리더 세미나",
        "calcBasis": "",
        "calcAmt": 905,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "식비",
        "calcBasis": "13,000원*10명",
        "calcAmt": 130,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "다과비",
        "calcBasis": "5,000원*10명",
        "calcAmt": 50,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사무총장 간담회비",
        "calcBasis": "5,000원*10명",
        "calcAmt": 50,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "도서 지원비",
        "calcBasis": "25,000원*5명",
        "calcAmt": 125,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "신임리더 Celebration Kit 제작",
        "calcBasis": "50,000원*5명",
        "calcAmt": 250,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "기타진행비",
        "calcBasis": "연수 진행을 위한 제반비용",
        "calcAmt": 300,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1160",
    "deptName": "GN컬쳐팀",
    "bizName": "정책세미나",
    "sehangName": "조사연구사업",
    "mokName": "정책세미나",
    "semokName": "직원 세미나",
    "legacyBudgetAmtWon": 144212000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "강의장",
        "calcBasis": "1,500,000원*4개",
        "calcAmt": 6000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "식비",
        "calcBasis": "13,000원*700명*6식",
        "calcAmt": 54600,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "숙박비",
        "calcBasis": "30,000원*700개*2박",
        "calcAmt": 42000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "본부직원중식 및 다과비",
        "calcBasis": "80명*15,000원",
        "calcAmt": 1200,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "다과비",
        "calcBasis": "700명*10,000원",
        "calcAmt": 7000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "사무총장 간담회",
        "calcBasis": "78명*5,000원",
        "calcAmt": 390,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "공동체활동 프로그램 준비",
        "calcBasis": "700명*10,000원",
        "calcAmt": 7000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "공동체활동 시상비",
        "calcBasis": "200,000원*20개 사업장",
        "calcAmt": 4000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "이벤트 진행비",
        "calcBasis": "700명*5,000원",
        "calcAmt": 3500,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "라이브포럼 진행비",
        "calcBasis": "500,000원*3회",
        "calcAmt": 1500,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "본부 교통비",
        "calcBasis": "420,000원*16대",
        "calcAmt": 6720,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "물품제작(포스터/현수막/노트패드 등)",
        "calcBasis": "물품제작(포스터/현수막/노트패드 등)",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "장비 렌탈(음향, 촬영 등)",
        "calcBasis": "장비 렌탈(음향, 촬영 등",
        "calcAmt": 4000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "기타진행비(행사용품, 구급약품 구비)",
        "calcBasis": "기타진행비(행사용품, 구급약품 구비)",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "사전 답사비",
        "calcBasis": "100,000원*2회",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "TF(진행팀) 회의 준비",
        "calcBasis": "",
        "calcAmt": 1080,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1차 사전회의 진행비",
        "calcBasis": "26명*5,000원",
        "calcAmt": 130,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "1차 사전회의 식사비",
        "calcBasis": "26명*10,000원",
        "calcAmt": 260,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2차 현장답사 및 회의 진행비",
        "calcBasis": "26명*5,000원",
        "calcAmt": 130,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2차 현장답사 및 회의 식사비",
        "calcBasis": "26명*10,000원",
        "calcAmt": 260,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "2차 현장답사 및 회의 교통비(렌트 및 주유비 등)",
        "calcBasis": "2차 현장답사 및 회의 교통비(렌트 및 주유비 등)",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "사전입소 진행비",
        "calcBasis": "",
        "calcAmt": 2522,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사전입소 식사비",
        "calcBasis": "26명*13,000원*4식",
        "calcAmt": 1352,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사전입소 다과비",
        "calcBasis": "26명*5,000원",
        "calcAmt": 130,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사전입소 숙박비",
        "calcBasis": "40,000원*26명*1박",
        "calcAmt": 1040,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1160",
    "deptName": "GN컬쳐팀",
    "bizName": "정책세미나",
    "sehangName": "조사연구사업",
    "mokName": "정책세미나",
    "semokName": "신입직원 세미나",
    "legacyBudgetAmtWon": 50508000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "신입직원 연수",
        "calcBasis": "",
        "calcAmt": 43508,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "대관료",
        "calcBasis": "1,000,000원*3일*2회",
        "calcAmt": 6000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "숙박비",
        "calcBasis": "30,000원*74개*2박*2회",
        "calcAmt": 8880,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "식비",
        "calcBasis": "13,000원*74명*7식*2회",
        "calcAmt": 13468,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "다과비",
        "calcBasis": "10,000원*74명*2회",
        "calcAmt": 1480,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "자료집",
        "calcBasis": "80개*10,000원*2회",
        "calcAmt": 1600,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "버스대여",
        "calcBasis": "1,200,000원*2대*2회*2회",
        "calcAmt": 9600,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "액션러닝 프로그램 진행비",
        "calcBasis": "74명*10,000원*2회",
        "calcAmt": 1480,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "기타진행비(의약품, 현수막, 필요물품)",
        "calcBasis": "500,000원*2회",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "신입직원 웰컴키트 제작비",
        "calcBasis": "140명*50,000원",
        "calcAmt": 7000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1160",
    "deptName": "GN컬쳐팀",
    "bizName": "직원지원정책",
    "sehangName": "조사연구사업",
    "mokName": "직원지원정책",
    "semokName": "직원영성훈련",
    "legacyBudgetAmtWon": 12030000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "영성훈련교육자료(매일성경구입)",
        "calcBasis": "5권*2,500원*12회",
        "calcAmt": 150,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "시무예배 진행비",
        "calcBasis": "10,000원*100명",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "성탄예배 진행비",
        "calcBasis": "80명*10,000원",
        "calcAmt": 800,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "본부 월요아침예배",
        "calcBasis": "",
        "calcAmt": 10080,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "강사 활동비",
        "calcBasis": "400,000원*24회",
        "calcAmt": 9600,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "영성훈련 진행비",
        "calcBasis": "20,000원*24회",
        "calcAmt": 480,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1160",
    "deptName": "GN컬쳐팀",
    "bizName": "직원지원정책",
    "sehangName": "조사연구사업",
    "mokName": "직원지원정책",
    "semokName": "조직문화",
    "legacyBudgetAmtWon": 7520000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "영상제작비용",
        "calcBasis": "800,000원*2회",
        "calcAmt": 1600,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "컨텐츠 운영비(인터뷰 촬영시 교통비)",
        "calcBasis": "30,000원*3명*2회",
        "calcAmt": 180,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "컨텐츠 운영비(인터뷰 촬영시 사업장 내 인터뷰 대상자 등)",
        "calcBasis": "15,000원*3명*2회",
        "calcAmt": 90,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "기관방문비(인터뷰 방문시)",
        "calcBasis": "100,000원*6개",
        "calcAmt": 600,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "프로그램 물품제작(포스터/소품/리워드 물품 등)",
        "calcBasis": "프로그램 물품제작(포스터/소품/리워드 물품 등)",
        "calcAmt": 1500,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "프로그램 시상비",
        "calcBasis": "61개사업장*50,000원",
        "calcAmt": 3050,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "기타진행비(행사용품 등)",
        "calcBasis": "기타진행비(행사용품 등)",
        "calcAmt": 500,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1160",
    "deptName": "GN컬쳐팀",
    "bizName": "기획사업비",
    "sehangName": "조사연구사업",
    "mokName": "기획사업비",
    "semokName": "기타지부지원사업비",
    "legacyBudgetAmtWon": 32723460,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "L급 해외사업세미나",
        "calcBasis": "",
        "calcAmt": 32724,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "항공료",
        "calcBasis": "800,000원*20명",
        "calcAmt": 16000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "교통비",
        "calcBasis": "500,000원*2대",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "차량 보험료",
        "calcBasis": "500,000원*2대",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "기관방문 진행비",
        "calcBasis": "100,000원*4개기관",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "기타진행비",
        "calcBasis": "비자발급, 여행자 보험 등 1회*500,000원",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "해외진행비",
        "calcBasis": "",
        "calcAmt": 13824,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1160",
    "deptName": "GN컬쳐팀",
    "bizName": "부서운영비",
    "sehangName": "조사연구사업",
    "mokName": "부서운영비",
    "semokName": "부서운영비",
    "legacyBudgetAmtWon": 1200000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "부서운영비",
        "calcBasis": "3명*30,000원*12개원",
        "calcAmt": 1080,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "부서연수 및 워크샵",
        "calcBasis": "3명*40,000원",
        "calcAmt": 120,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1160",
    "deptName": "GN컬쳐팀",
    "bizName": "인사관리비",
    "sehangName": "운영비",
    "mokName": "인사관리비",
    "semokName": "교육지원",
    "legacyBudgetAmtWon": 115546000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "대학원 학비지원",
        "calcBasis": "25명*1,000,000원*2회",
        "calcAmt": 50000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "외부교육",
        "calcBasis": "",
        "calcAmt": 10500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "본부 외부교육",
        "calcBasis": "80명*100,000원",
        "calcAmt": 8000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "본부직원 직무 필수역량 직무교육",
        "calcBasis": "50명*50,000원",
        "calcAmt": 2500,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "대리 승진자 교육 (상, 하반기)",
        "calcBasis": "",
        "calcAmt": 22448,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "강의장",
        "calcBasis": "1,000,000원*3일*2회",
        "calcAmt": 6000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "식사비",
        "calcBasis": "13,000원*24명*7식*2회",
        "calcAmt": 4368,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "숙박비",
        "calcBasis": "30,000원*24명*2일*2회",
        "calcAmt": 2880,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "다과비",
        "calcBasis": "10,000원*24명*2회",
        "calcAmt": 480,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "버스대여",
        "calcBasis": "1,500,000원*1대*2회*2회",
        "calcAmt": 6000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "강의진행비",
        "calcBasis": "10,000원*24명*2회",
        "calcAmt": 480,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "프로그램 진행비",
        "calcBasis": "30,000원*24명*2회",
        "calcAmt": 1440,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "기타진행비",
        "calcBasis": "400000*2회",
        "calcAmt": 800,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "과장 승진자 교육 (상, 하반기)",
        "calcBasis": "",
        "calcAmt": 27894,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "강의장",
        "calcBasis": "700,000원*4일*2회",
        "calcAmt": 5600,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "식사비",
        "calcBasis": "13,000원*29명*6식*2회",
        "calcAmt": 4524,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "숙박비",
        "calcBasis": "30,000원*15명*3박*2회",
        "calcAmt": 2700,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "다과비",
        "calcBasis": "15,000원*29명*2회",
        "calcAmt": 870,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "교통비 (왕복 항공권)",
        "calcBasis": "200,000원*10명*2회",
        "calcAmt": 4000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "프로그램 진행비",
        "calcBasis": "152,000원*25명*2회",
        "calcAmt": 7600,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "진행팀 진행비",
        "calcBasis": "",
        "calcAmt": 2600,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "조기입소에 따른 식사비",
        "calcBasis": "12,000원*4명*2회",
        "calcAmt": 96,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "렌트비",
        "calcBasis": "250,000원*2대*2회",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "주유비",
        "calcBasis": "50,000원*2대*2회",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "프로그램 지원비",
        "calcBasis": "52,000원*4명*2회",
        "calcAmt": 416,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "기타 진행비",
        "calcBasis": "444,000*2회",
        "calcAmt": 888,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "L급 승진자 교육 (상반기)",
        "calcBasis": "",
        "calcAmt": 4704,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "강의장",
        "calcBasis": "700,000원*2일",
        "calcAmt": 1400,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "숙박비",
        "calcBasis": "30,000원*24명*1박",
        "calcAmt": 720,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "식사비",
        "calcBasis": "13,000원*24명*4식",
        "calcAmt": 1248,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "다과비",
        "calcBasis": "5,000원*24명",
        "calcAmt": 120,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "프로그램 진행비",
        "calcBasis": "20,000원*20명",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사무총장 간담회 진행비",
        "calcBasis": "5,000원*24명",
        "calcAmt": 120,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "도서구입비",
        "calcBasis": "25,000원*20명",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "기타 진행비",
        "calcBasis": "교육 물품 제작, 기타 물품 구입, 진행인력 일비",
        "calcAmt": 196,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1170",
    "deptName": "인재개발팀",
    "bizName": "기획사업비",
    "sehangName": "사업비",
    "mokName": "기획사업비",
    "semokName": "교육및워크샵",
    "legacyBudgetAmtWon": 4180000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "아동권리감수성 및 옹호교육",
        "calcBasis": "",
        "calcAmt": 4180,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "강사비",
        "calcBasis": "(250,000원+(150,000원*2시간))*2명",
        "calcAmt": 1100,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "식대 및 다과비",
        "calcBasis": "15,000원*132명",
        "calcAmt": 1980,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "장소 대관비",
        "calcBasis": "1,000,000원*1회",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "진행비",
        "calcBasis": "100,000원*1회",
        "calcAmt": 100,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1170",
    "deptName": "인재개발팀",
    "bizName": "기획사업비",
    "sehangName": "사업비",
    "mokName": "기획사업비",
    "semokName": "교육및워크샵",
    "legacyBudgetAmtWon": 8360000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "네트워크 역량강화 교육",
        "calcBasis": "",
        "calcAmt": 4180,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "강사비",
        "calcBasis": "(250,000원+(150,000원*2시간))*2명",
        "calcAmt": 1100,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "식대 및 다과비",
        "calcBasis": "15,000원*132명",
        "calcAmt": 1980,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "장소 대관비",
        "calcBasis": "1,000,000원*1회",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "진행비",
        "calcBasis": "100,000원*1회",
        "calcAmt": 100,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "AI리터러시 역량강화 교육",
        "calcBasis": "",
        "calcAmt": 4180,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "강사비",
        "calcBasis": "(250,000원+(150,000원*2시간))*2명",
        "calcAmt": 1100,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "식대 및 다과비",
        "calcBasis": "15,000원*132명",
        "calcAmt": 1980,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "장소 대관비",
        "calcBasis": "1,000,000원*1회",
        "calcAmt": 1000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "진행비",
        "calcBasis": "100,000원*1회",
        "calcAmt": 100,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1170",
    "deptName": "인재개발팀",
    "bizName": "부서운영비",
    "sehangName": "조사연구사업",
    "mokName": "부서운영비",
    "semokName": "업무추진비",
    "legacyBudgetAmtWon": 1200000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "업무추진비(부장)",
        "calcBasis": "100,000원*12개월",
        "calcAmt": 1200,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1170",
    "deptName": "인재개발팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 205322330,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "김성진 부장 (L급 22호봉)",
        "calcBasis": "83,981,420",
        "calcAmt": 83982,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "송민지 차장(L급 14호봉)",
        "calcBasis": "61,887,960",
        "calcAmt": 61888,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "정원구 과장(4급 12호봉,13호봉)",
        "calcBasis": "59,452,950",
        "calcAmt": 59453,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1170",
    "deptName": "인재개발팀",
    "bizName": "부서운영비",
    "sehangName": "사업비",
    "mokName": "부서운영비",
    "semokName": "부서운영비",
    "legacyBudgetAmtWon": 1200000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "부서운영비",
        "calcBasis": "30,000*3명*12개월",
        "calcAmt": 1080,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "부서워크샵",
        "calcBasis": "40,000*3명*1회",
        "calcAmt": 120,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1170",
    "deptName": "인재개발팀",
    "bizName": "인사관리비",
    "sehangName": "운영비",
    "mokName": "인사관리비",
    "semokName": "교육지원",
    "legacyBudgetAmtWon": 35000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "신규 교육플랫폼 구축",
        "calcBasis": "신규교육플랫폼 계약비(LMS서비스 오픈, 교육콘텐츠 수강 등)",
        "calcAmt": 35000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 16565000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "일반직(김아리, 김지용), 기간제계약직(서은솔) 급여",
        "calcBasis": "(1,380,400원 * 10개월) + (1,380,500원 * 2개월)",
        "calcAmt": 16565,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 13744000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "일반직(이윤지 차장) 급여",
        "calcBasis": "(1,145,300원 * 8개월) + (1,145,400원 * 4개월)",
        "calcAmt": 13744,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 66708000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "일반직 직원(김한나 팀장) 인건비",
        "calcBasis": "5,559,000원 * 12개월",
        "calcAmt": 66708,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "부서운영비",
    "sehangName": "사업비",
    "mokName": "부서운영비",
    "semokName": "부서운영비",
    "legacyBudgetAmtWon": 2400000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "부서운영비",
        "calcBasis": "30,000원 * 6명 * 12월",
        "calcAmt": 2160,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "워크샵",
        "calcBasis": "40,000원 * 6명",
        "calcAmt": 240,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "부서운영비",
    "sehangName": "사업비",
    "mokName": "부서운영비",
    "semokName": "업무추진비",
    "legacyBudgetAmtWon": 2400000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "아동권리사업부 업무추진비",
        "calcBasis": "200,000원 * 12개월",
        "calcAmt": 2400,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "대외협력사업",
    "sehangName": "조사연구사업",
    "mokName": "대외협력사업",
    "semokName": "대외협력사업비",
    "legacyBudgetAmtWon": 480000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "대외협력사업비",
        "calcBasis": "",
        "calcAmt": 480,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "외부기업 미팅 진행비(회의 식대 및 다과비 등)",
        "calcBasis": "40,000원 * 12개월",
        "calcAmt": 480,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "학대피해아동보호 및 예방 기획사업비",
    "sehangName": "사업비",
    "mokName": "학대피해아동보호 및 예방 기획사업비",
    "semokName": "학대피해아동보호 및 예방 기획사업",
    "legacyBudgetAmtWon": 32640000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "아이케어 3차 사업비 반납금",
        "calcBasis": "32,236,000원 * 1식",
        "calcAmt": 32236,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "아이케어 3차 예금이자 반납금",
        "calcBasis": "404,000원 * 1식",
        "calcAmt": 404,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "학대피해아동보호 및 예방 기획사업비",
    "sehangName": "사업비",
    "mokName": "학대피해아동보호 및 예방 기획사업비",
    "semokName": "학대피해아동보호 및 예방 기획사업",
    "legacyBudgetAmtWon": 100000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "희망봄프로젝트 5차 행정비",
        "calcBasis": "100,000원 * 1식",
        "calcAmt": 100,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 5170000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "Sol Mate 6차 사업담당자 인건비",
        "calcBasis": "5,170,000원 * 1식",
        "calcAmt": 5170,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "학대피해아동보호 및 예방 기획사업비",
    "sehangName": "사업비",
    "mokName": "학대피해아동보호 및 예방 기획사업비",
    "semokName": "학대피해아동보호 및 예방 기획사업",
    "legacyBudgetAmtWon": 400000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "Sol Mate 5차 행정비",
        "calcBasis": "400,000원 * 1식",
        "calcAmt": 400,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "자립역량 지원",
    "sehangName": "사업비",
    "mokName": "자립역량 지원",
    "semokName": "자립준비",
    "legacyBudgetAmtWon": 69300000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "양육시설 금융교육 3차 사업비",
        "calcBasis": "39,300,000원 * 1식",
        "calcAmt": 39300,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "양육시설 금융교육 3차 사업비",
        "calcBasis": "30,000,000원 * 1식",
        "calcAmt": 30000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "자립 지원 기획사업비",
    "sehangName": "사업비",
    "mokName": "자립 지원 기획사업비",
    "semokName": "자립 지원 기획사업",
    "legacyBudgetAmtWon": 630000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "양육시설 금융교육 3차 사업비",
        "calcBasis": "630,000원 * 1식",
        "calcAmt": 630,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "아동학대사례관리",
    "sehangName": "사업비",
    "mokName": "아동학대사례관리",
    "semokName": "아동학대사례관리",
    "legacyBudgetAmtWon": 24564000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "아이케어 1차년도 차량 재개조 사업비",
        "calcBasis": "24,564,000원 * 1식",
        "calcAmt": 24564,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 45725000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "일반직(서선민 대리) 급여",
        "calcBasis": "(3,810,500원 * 2개월) + (3,810,400원 * 10개월)",
        "calcAmt": 45725,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "아동보호전문기관 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "아동보호전문기관 전출금(후원금)",
    "semokName": "아동보호전문기관 전출금(후원금)기타",
    "legacyBudgetAmtWon": 26000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "세피앙 우리들은 행복해 6차 법인전출금",
        "calcBasis": "26,000,000원 * 1식",
        "calcAmt": 26000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 40000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "드림하이 9차 사업담당자 인건비",
        "calcBasis": "(4,500,000원 * 8개월) + 4,000,000원",
        "calcAmt": 40000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "역량강화사업",
    "sehangName": "사업비",
    "mokName": "역량강화사업",
    "semokName": "진로탐색지원",
    "legacyBudgetAmtWon": 248000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "드림하이 9차 사업비",
        "calcBasis": "248,000,000원 * 1식",
        "calcAmt": 248000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "미래성장 지원 기획사업비",
    "sehangName": "사업비",
    "mokName": "미래성장 지원 기획사업비",
    "semokName": "미래성장 지원 기획사업",
    "legacyBudgetAmtWon": 37000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "드림하이 9차 기획사업",
        "calcBasis": "37,000,000원 * 1식",
        "calcAmt": 37000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "지역아동센터 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "지역아동센터 전출금(후원금)",
    "semokName": "지역아동센터 전출금(후원금)기타",
    "legacyBudgetAmtWon": 25000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "드림하이 9차 법인전출금",
        "calcBasis": "25,000,000원 * 1식",
        "calcAmt": 25000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 8800000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "희망봄 프로젝트 6차 인건비",
        "calcBasis": "8,800,000원 * 1식",
        "calcAmt": 8800,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "학대피해아동보호 및 예방 기획사업비",
    "sehangName": "사업비",
    "mokName": "학대피해아동보호 및 예방 기획사업비",
    "semokName": "학대피해아동보호 및 예방 기획사업",
    "legacyBudgetAmtWon": 22100000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "희망봄 프로젝트 6차 사업비",
        "calcBasis": "22,100,000원 * 1식",
        "calcAmt": 22100,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "아동보호전문기관 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "아동보호전문기관 전출금(후원금)",
    "semokName": "아동보호전문기관 전출금(후원금)기타",
    "legacyBudgetAmtWon": 69100000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "희망봄 프로젝트 6차 전출금",
        "calcBasis": "69,100,000원 * 1식",
        "calcAmt": 69100,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 12000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "소외지역 금융체험교실 6차 사업담당자 인건비",
        "calcBasis": "2,000,000원 * 6개월",
        "calcAmt": 12000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "역량강화사업",
    "sehangName": "사업비",
    "mokName": "역량강화사업",
    "semokName": "교육지원사업",
    "legacyBudgetAmtWon": 256500000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "소외지역 금융체험교실 6차",
        "calcBasis": "256,500,000원 * 1식",
        "calcAmt": 256500,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "미래성장 지원 기획사업비",
    "sehangName": "사업비",
    "mokName": "미래성장 지원 기획사업비",
    "semokName": "미래성장 지원 기획사업",
    "legacyBudgetAmtWon": 1500000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "소외지역 금융체험교실 6차 기획사업",
        "calcBasis": "1,500,000원 * 1식",
        "calcAmt": 1500,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 8000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "Sol Mate 6차 사업담당자 인건비",
        "calcBasis": "8,000,000원 * 1식",
        "calcAmt": 8000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "아동학대사례관리",
    "sehangName": "사업비",
    "mokName": "아동학대사례관리",
    "semokName": "아동학대사례관리",
    "legacyBudgetAmtWon": 291000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "Sol Mate 6차 사업비",
        "calcBasis": "291,000,000원 * 1식",
        "calcAmt": 291000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "학대피해아동보호 및 예방 기획사업비",
    "sehangName": "사업비",
    "mokName": "학대피해아동보호 및 예방 기획사업비",
    "semokName": "학대피해아동보호 및 예방 기획사업",
    "legacyBudgetAmtWon": 1000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "SOL Mate 6차 사업비",
        "calcBasis": "1,000,000원 * 1식",
        "calcAmt": 1000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "성장환경 조성사업",
    "sehangName": "사업비",
    "mokName": "성장환경 조성사업",
    "semokName": "주거환경개선",
    "legacyBudgetAmtWon": 660000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "아이케어 4차 아이케어 홈 사업비",
        "calcBasis": "660,000,000원 * 1식",
        "calcAmt": 660000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 101400000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "아이케어 4차 사업담당자 인건비",
        "calcBasis": "101,400,000원 * 1식",
        "calcAmt": 101400,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "아동학대사례관리",
    "sehangName": "사업비",
    "mokName": "아동학대사례관리",
    "semokName": "아동학대사례관리",
    "legacyBudgetAmtWon": 1725000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "아이케어 4차 사업비",
        "calcBasis": "1,725,000,000원 * 1식",
        "calcAmt": 1725000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "학대피해아동보호 및 예방 기획사업비",
    "sehangName": "사업비",
    "mokName": "학대피해아동보호 및 예방 기획사업비",
    "semokName": "학대피해아동보호 및 예방 기획사업",
    "legacyBudgetAmtWon": 13600000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "아이케어 4차 사업비 및 행정비",
        "calcBasis": "13,600,000원 * 1식",
        "calcAmt": 13600,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "아동보호전문기관 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "아동보호전문기관 전출금(후원금)",
    "semokName": "아동보호전문기관 전출금(후원금)기타",
    "legacyBudgetAmtWon": 50000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "코스트코리아 8차 상반기 사업비",
        "calcBasis": "50,000,000원 * 1식",
        "calcAmt": 50000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1210",
    "deptName": "임팩트사업2팀",
    "bizName": "아동보호전문기관 전출금(후원금)",
    "sehangName": "전출금",
    "mokName": "아동보호전문기관 전출금(후원금)",
    "semokName": "아동보호전문기관 전출금(후원금)기타",
    "legacyBudgetAmtWon": 150000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "코스트코리아 7차 하반기 사업비",
        "calcBasis": "150,000,000원 * 1식",
        "calcAmt": 150000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1220",
    "deptName": "임팩트사업3팀",
    "bizName": "부서운영비",
    "sehangName": "사업비",
    "mokName": "부서운영비",
    "semokName": "부서운영비",
    "legacyBudgetAmtWon": 2400000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "부서운영비(정규직,기간제)",
        "calcBasis": "정규직 및 기간제 총 6명*30,000원*9개월",
        "calcAmt": 1620,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "부서운영비(시간제)",
        "calcBasis": "시간제 총 3명*20,000원*9개월",
        "calcAmt": 540,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "부서운영비(팀 워크샵)",
        "calcBasis": "정규직 및 기간제 총 6명*40,000원",
        "calcAmt": 240,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1220",
    "deptName": "임팩트사업3팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 225144000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "인건비-이필승 국장",
        "calcBasis": "인건비 1개월 약 7073040*9개월",
        "calcAmt": 60134,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "인건비-배성은 과장",
        "calcBasis": "인건비 1개월 약 4990310*9개월",
        "calcAmt": 42046,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "인건비-박정원 간사",
        "calcBasis": "인건비 1개월 약 3496690*9개월",
        "calcAmt": 31947,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "인건비-최명지 간사",
        "calcBasis": "인건비 1개월 약 3318170*9개월",
        "calcAmt": 30340,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "인건비-김태희 간사",
        "calcBasis": "인건비 1개월 약 3318170*9개월",
        "calcAmt": 30340,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "인건비-최현정 간사",
        "calcBasis": "인건비 1개월 약 3318170*9개월",
        "calcAmt": 30340,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1220",
    "deptName": "임팩트사업3팀",
    "bizName": "사회적 약자 지원",
    "sehangName": "사업비",
    "mokName": "사회적 약자 지원",
    "semokName": "사회적 약자 지원 서비스",
    "legacyBudgetAmtWon": 5953404000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "생활비 지원(1월)",
        "calcBasis": "생활비 (약 3,000,000원*약271명)+(2,732,000원*1명)",
        "calcAmt": 815732,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "생활비 지원(2월~9월)",
        "calcBasis": "생활비 약 1,570명 지원 4,710,672,000원",
        "calcAmt": 4710672,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "법률상담 지원",
        "calcBasis": "법률상담 50,000,000원",
        "calcAmt": 50000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "심리상담 지원",
        "calcBasis": "심리상담 1,000,000원*약 297명",
        "calcAmt": 297000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "피해 예방 교육",
        "calcBasis": "피해예방교육 강의운영비 60,000,000원+홍보 및 리워드 10,000,000원",
        "calcAmt": 70000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "보험 지원",
        "calcBasis": "보험지원 10,000,000원",
        "calcAmt": 10000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1220",
    "deptName": "임팩트사업3팀",
    "bizName": "지역사회 지원 기획사업비",
    "sehangName": "사업비",
    "mokName": "지역사회 지원 기획사업비",
    "semokName": "지역사회 지원 기획사업",
    "legacyBudgetAmtWon": 637184000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "대국민예방캠페인",
        "calcBasis": "라디오 광고 150,000,000원",
        "calcAmt": 150000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "대국민예방캠페인",
        "calcBasis": "온라인예방교육 홍보 239,250,000원",
        "calcAmt": 239250,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "민관협력체계구축-자문위원회의",
        "calcBasis": "자문위원회의 8,370,000원",
        "calcAmt": 8370,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "민관협력체계구축-리플렛배포 등",
        "calcBasis": "리플렛 배포 등 홍보 20,190,000원",
        "calcAmt": 20190,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "민관협력체계구축-콜센터운영",
        "calcBasis": "콜센터 및 심리상담 인력 운영 55,200,000원",
        "calcAmt": 55200,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "민관협력체계구축-성과공유회",
        "calcBasis": "성과공유회 100,000,000원",
        "calcAmt": 100000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "행정비",
        "calcBasis": "행정비 64,174,000원",
        "calcAmt": 64174,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1230",
    "deptName": "사회공헌협력센터",
    "bizName": "지역사회 지원 기획사업비",
    "sehangName": "사업비",
    "mokName": "지역사회 지원 기획사업비",
    "semokName": "지역사회 지원 기획사업",
    "legacyBudgetAmtWon": 2610000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "핸즈온 봉사활동 KIT 제작비",
        "calcBasis": "",
        "calcAmt": 2160,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "핸즈온 키트 2종 제작비",
        "calcBasis": "20,000원*2종*50개",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "핸즈온 키트 샘플 제작비",
        "calcBasis": "20,000원*2종*4개",
        "calcAmt": 160,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "핸즈온 봉사활동 진행 비용",
        "calcBasis": "",
        "calcAmt": 450,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "봉사활동 장소대관비",
        "calcBasis": "300,000원*1회",
        "calcAmt": 300,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "봉사활동 진행 물품 구입비",
        "calcBasis": "50,000원*3회",
        "calcAmt": 150,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1230",
    "deptName": "사회공헌협력센터",
    "bizName": "부서운영비",
    "sehangName": "사업비",
    "mokName": "부서운영비",
    "semokName": "부서운영비",
    "legacyBudgetAmtWon": 1600000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사회공헌협력센터 부서운영비",
        "calcBasis": "사회공헌협력팀 직원 4명 * 30,000원*12회",
        "calcAmt": 1440,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "사회공헌협력센터 워크샵 진행비",
        "calcBasis": "사회공헌협력센터 직원 4명 * 40,000원",
        "calcAmt": 160,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1230",
    "deptName": "사회공헌협력센터",
    "bizName": "부서운영비",
    "sehangName": "사업비",
    "mokName": "부서운영비",
    "semokName": "업무추진비",
    "legacyBudgetAmtWon": 600000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사회공헌협력센터 업무추진비",
        "calcBasis": "부장 1명 * 50,000원 * 12회",
        "calcAmt": 600,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1230",
    "deptName": "사회공헌협력센터",
    "bizName": "대외협력사업(정책연구사업)",
    "sehangName": "사업비",
    "mokName": "대외협력사업(정책연구사업)",
    "semokName": "대외협력사업비(정책연구사업)",
    "legacyBudgetAmtWon": 5840000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사회공헌사업 임팩트 관리",
        "calcBasis": "",
        "calcAmt": 5600,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사회공헌 임팩트 보고서 도출",
        "calcBasis": "",
        "calcAmt": 5000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "보고서 디자인비",
        "calcBasis": "3,000,000원*1회",
        "calcAmt": 3000,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "보고서 제작비(자료집 인쇄)",
        "calcBasis": "20,000원*100부*1회",
        "calcAmt": 2000,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "국내사업 포럼 연계",
        "calcBasis": "",
        "calcAmt": 600,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "사례 발표 기업 사례비",
        "calcBasis": "250,000원*2명",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "식대비",
        "calcBasis": "15,000원*4명",
        "calcAmt": 60,
        "remark": ""
      },
      {
        "calcLevel": 3,
        "calcDesc": "사전 미팅 교통비",
        "calcBasis": "10,000원*4회",
        "calcAmt": 40,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "사회공헌 역량개발을 위한 컴퍼런스 참석",
        "calcBasis": "30,000원*4명*2회",
        "calcAmt": 240,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1230",
    "deptName": "사회공헌협력센터",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 213501000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "L급 16호봉(17호봉)",
        "calcBasis": "(5,341,000원*5개월)+5,580,000원+(5,444,000원*5개월)+5,682,000원",
        "calcAmt": 65187,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "4급 8호봉(9호봉)",
        "calcBasis": "(4,293,000원*2개월)+4,531,000원+(4,403,000원*8개월)+4,641,000원",
        "calcAmt": 52982,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "5급 5호봉(6호봉)",
        "calcBasis": "(4,061,000원*5개월)+4,299,000원+(4,155,000원*5개월)+4,393,000원",
        "calcAmt": 49772,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "6급 3호봉",
        "calcBasis": "(3,757,000원*10개월)+(3,995,000원*2개월)",
        "calcAmt": 45560,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1230",
    "deptName": "사회공헌협력센터",
    "bizName": "모금사업비",
    "sehangName": "사업비",
    "mokName": "모금사업비",
    "semokName": "모금관리비",
    "legacyBudgetAmtWon": 6852000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "사회공헌사업(기업) 파트너십 관리",
        "calcBasis": "",
        "calcAmt": 3672,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "감사패 제작비",
        "calcBasis": "(200,000원*2회)+(500,000원*3회)",
        "calcAmt": 1900,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "현판 제작비",
        "calcBasis": "(50,000원*3회)*10회",
        "calcAmt": 1500,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "감사장 인쇄비",
        "calcBasis": "(3,000원*2회)*12회",
        "calcAmt": 72,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "관계기업 달력 및 우편 발송",
        "calcBasis": "200,000원*1회",
        "calcAmt": 200,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "사회공헌사업(기업&동종) 관계자 미팅 및 협약식",
        "calcBasis": "",
        "calcAmt": 2220,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "관계기업 및 신규기업 대면 미팅",
        "calcBasis": "5,000원*4명*30회",
        "calcAmt": 600,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "COFFEE CHAT 및 동종기관 네트워크 미팅",
        "calcBasis": "5,000*2명*18회",
        "calcAmt": 180,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "사회공헌 협약식 진행 및 참석",
        "calcBasis": "(5,000원*6명*12회)+(10,000원*3명*12회)+(60,000원*12회)",
        "calcAmt": 1440,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "사회공헌 사업 모니터링",
        "calcBasis": "",
        "calcAmt": 960,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "기업 관계자와 사업 모니터링 동행",
        "calcBasis": "15,000원*4명*6회",
        "calcAmt": 360,
        "remark": ""
      },
      {
        "calcLevel": 2,
        "calcDesc": "관계기업 방문을 위한 교통비",
        "calcBasis": "왕복 20,000원*30회",
        "calcAmt": 600,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1240",
    "deptName": "물품후원팀",
    "bizName": "급여",
    "sehangName": "사업비",
    "mokName": "급여",
    "semokName": "급여(본부)",
    "legacyBudgetAmtWon": 52214600,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "[일반직] 총 1명/대리(5급 8호봉)",
        "calcBasis": "4,351,220원*12개월*1명",
        "calcAmt": 52215,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1240",
    "deptName": "물품후원팀",
    "bizName": "지역사회 지원 기획사업비",
    "sehangName": "사업비",
    "mokName": "지역사회 지원 기획사업비",
    "semokName": "지역사회 지원 기획사업",
    "legacyBudgetAmtWon": 61266600,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "1. 창고 임대료",
        "calcBasis": "창고 이용료 : 평당 단가 35,200원*100평*12개월",
        "calcAmt": 42240,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "2. 창고 운영비(창고 전기료)",
        "calcBasis": "70,000원*12개월",
        "calcAmt": 840,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "3. 운송비",
        "calcBasis": "250,000원*12회*5톤트럭 용달비용",
        "calcAmt": 3000,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "4. 검수 및 패킹 진행비",
        "calcBasis": "일용직 인건비 : 인당 182,000원*20명",
        "calcAmt": 3640,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "5. 택배발송비",
        "calcBasis": "200,000원*12회",
        "calcAmt": 2400,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "6. 기탁판 & 현수막 제작 비용",
        "calcBasis": "50,000원*8회",
        "calcAmt": 400,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "7. 후원처/배분처/사업장 등 미팅 진행비",
        "calcBasis": "15,000원*24회*4명",
        "calcAmt": 1440,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "8. 초단시간 계약직 급여 지원",
        "calcBasis": "10,320원*59시간*12개월*1명",
        "calcAmt": 7307,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1240",
    "deptName": "물품후원팀",
    "bizName": "지역사회 지원(물품)",
    "sehangName": "사업비",
    "mokName": "지역사회 지원(물품)",
    "semokName": "지역사회 지원(물품)",
    "legacyBudgetAmtWon": 3500000000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "1. 후원물품 수시배분(굿네이버스 법인, 외부 복지단체, 지자체 등)",
        "calcBasis": "3,500,000,000원*1년",
        "calcAmt": 3500000,
        "remark": ""
      }
    ]
  },
  {
    "deptCode": "GNK1250",
    "deptName": "특별후원팀",
    "bizName": "모금사업비",
    "sehangName": "사업비",
    "mokName": "모금사업비",
    "semokName": "모금관리비",
    "legacyBudgetAmtWon": 1450000,
    "details": [
      {
        "calcLevel": 1,
        "calcDesc": "등재 물품 구입비",
        "calcBasis": "후원감사패 제작비 50,000원*10명",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "등재식 진행비",
        "calcBasis": "꽃다발 및 물품 구입비 50,000원*10명",
        "calcAmt": 500,
        "remark": ""
      },
      {
        "calcLevel": 1,
        "calcDesc": "사업 제안 및 결과보고 진행비",
        "calcBasis": "착수, 보고 2회*5,000원*45명",
        "calcAmt": 450,
        "remark": ""
      }
    ]
  }
];
